<template>
  <div class="main-content">
    <!-- HEADER -->
    <div class="header">
      <div class="container-fluid">
        <!-- Card -->
        <div class="card mt-5">
          <div class="card-body">
            <div class="row justify-content-between align-items-center">
              <div class="col-12 col-md-9 col-xl-7">
                <div class="mb-2">
                  <span>My IDP</span>
                  <span class="text-muted ml-2">></span>
                  <span class="text-danger ml-2">{{ activeTabTitle }}</span>
                </div>

                <p class="text-muted mb-md-0">This is My IDP menu</p>
              </div>
            </div>
          </div>
        </div>
        <!-- My IDP dll -->
        <div class="card mt-5">
          <div class="card-header">
            <span class="mt-3 fs-2">My IDP</span>
            <b-button
              v-if="
                currentTab === 1 &&
                listTabMenu &&
                listTabMenu.tabMenu?.some((item) => item.title === 'Strcutured Learning' && item.privilages.create)
              "
              class="btn btn-primary"
              variant="primary"
              @click="showAddTraining"
            >
              <span class="fe fe-plus-circle"></span>
              Add Training
            </b-button>
            <b-button
              v-if="
                currentTab === 2 &&
                listTabMenu &&
                listTabMenu.tabMenu?.some((item) => item.title === 'Social Learning' && item.privilages.create)
              "
              class="btn btn-primary"
              variant="primary"
              @click="showAddCoaching"
            >
              <span class="fe fe-plus-circle"></span>
              Add Social Learning
            </b-button>
            <b-button
              class="btn btn-primary mx-2"
              variant="primary"
              @click="showReportModal"
              v-if="currentTab !== 4 && listTabMenu"
            >
              <span class="fe fe-download"></span>
              Report
            </b-button>
            <b-button v-if="currentTab === 3" class="btn btn-primary" variant="primary" @click="showAddProject">
              <span class="fe fe-plus-circle"></span>
              Add Project
            </b-button>
          </div>
          <b-tabs v-model="currentTab" class="px-4">
            <b-tab title="Progress Summary" disabled>
              <div class="table-responsive">
                <table class="table table-sm table-bordered table-nowrap mt-4">
                  <thead>
                    <tr class="text-center">
                      <th rowspan="2">No</th>
                      <th rowspan="2">Competency Group/Competency</th>
                      <th colspan="3">Learning Progress</th>
                      <th rowspan="2">Status</th>
                    </tr>
                    <tr class="text-center">
                      <th colspan="1">Structure Learning</th>
                      <th colspan="1">Social Learning</th>
                      <th colspan="1">Experiential Learning</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in summary" :key="index">
                      <td :class="{ 'fw-bold': item.isBold }" class="text-center">
                        {{ item.no }}
                      </td>
                      <td :class="{ 'fw-bold': item.isBold }">
                        {{ item.isBehaviour ? "- " + item.competency : item.competency }}
                      </td>
                      <td class="text-center">
                        {{ item.structureLearning }}
                      </td>
                      <td class="text-center">
                        {{ item.socialLearning }}
                      </td>
                      <td class="text-center">
                        {{ item.experientialLearning }}
                      </td>
                      <td class="text-center">
                        <span :class="getBadgeSummary(item.status)">{{ item.status }}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </b-tab>
            <b-tab
              title="Structured Learning"
              v-if="
                listTabMenu &&
                listTabMenu.tabMenu?.some((item) => item.title === 'Strcutured Learning' && item.privilages.read)
              "
            >
              <div class="row mt-5">
                <div class="col-12 col-lg-6 col-xl">
                  <!-- Value  -->
                  <div class="card bg-secondary text-white">
                    <div class="card-body">
                      <div class="row align-items-center gx-0">
                        <div class="col">
                          <!-- Title -->
                          <h6 class="text-uppercase text-body-secondary mb-2">Planned</h6>

                          <!-- Heading -->
                          <span class="h2 mb-0">
                            {{
                              personalData?.data?.structuredCount?.planned ? personalData?.data?.structuredCount.planned : 0
                            }}
                          </span>
                        </div>
                        <div class="col-auto">
                          <!-- Icon -->
                          <span class="h2 fe fe-file-text text-body-secondary mb-0"></span>
                        </div>
                      </div>
                      <!-- / .row -->
                    </div>
                  </div>
                </div>
                <div class="col-12 col-lg-6 col-xl">
                  <!-- Value  -->
                  <div class="card bg-warning">
                    <div class="card-body">
                      <div class="row align-items-center gx-0">
                        <div class="col">
                          <!-- Title -->
                          <h6 class="text-uppercase text-body-secondary mb-2">In Progress</h6>

                          <!-- Heading -->
                          <span class="h2 mb-0">
                            {{
                              personalData?.data?.structuredCount?.in_progress
                                ? personalData?.data?.structuredCount.in_progress
                                : 0
                            }}
                          </span>
                        </div>
                        <div class="col-auto">
                          <!-- Icon -->
                          <span class="h2 fe fe-loader text-body-secondary mb-0"></span>
                        </div>
                      </div>
                      <!-- / .row -->
                    </div>
                  </div>
                </div>
                <div class="col-12 col-lg-6 col-xl">
                  <!-- Hours -->
                  <div class="card bg-success text-white">
                    <div class="card-body">
                      <div class="row align-items-center gx-0">
                        <div class="col">
                          <!-- Title -->
                          <h6 class="text-uppercase text-body-secondary mb-2">Completed</h6>

                          <!-- Heading -->
                          <span class="h2 mb-0">
                            {{
                              personalData?.data?.structuredCount?.completed
                                ? personalData?.data?.structuredCount.completed
                                : 0
                            }}
                          </span>
                        </div>
                        <div class="col-auto">
                          <!-- Icon -->
                          <span class="h2 fe fe-check-circle text-body-secondary mb-0"></span>
                        </div>
                      </div>
                      <!-- / .row -->
                    </div>
                  </div>
                </div>
                <div class="col-12 col-lg-6 col-xl" v-b-tooltip.hover="'Total approved hours / Total minimal hours'">
                  <!-- Hours -->
                  <div class="card bg-info text-white">
                    <div class="card-body">
                      <div class="row align-items-center gx-0">
                        <div class="col">
                          <!-- Title -->
                          <h6 class="text-uppercase text-body-secondary mb-2">Total Learning Hours</h6>

                          <!-- Heading -->
                          <span class="h2 mb-0">
                            {{ personalData?.data?.count?.total_hours ? personalData?.data?.count.total_hours : 0 }}
                            /
                            {{ personalData?.data?.count?.min_hours ? personalData?.data?.count.min_hours : 0 }}
                          </span>
                        </div>
                        <div class="col-auto">
                          <!-- Icon -->
                          <span class="h2 fe fe-check-circle text-body-secondary mb-0"></span>
                        </div>
                      </div>
                      <!-- / .row -->
                    </div>
                  </div>
                </div>
                <div class="col-12 col-lg-6 col-xl" v-b-tooltip.hover="'Total completed hours / Total approved hours'">
                  <!-- Hours -->
                  <div class="card bg-primary text-white">
                    <div class="card-body">
                      <div class="row align-items-center gx-0">
                        <div class="col">
                          <!-- Title -->
                          <h6 class="text-uppercase text-body-secondary mb-2">Certification Learning Hour</h6>

                          <!-- Heading -->
                          <span class="h2 mb-0">
                            {{
                              personalData?.data?.count?.total_completed_hours
                                ? personalData?.data?.count.total_completed_hours
                                : 0
                            }}
                            /
                            {{ personalData?.data?.count?.total_hours ? personalData?.data?.count.total_hours : 0 }}
                          </span>
                        </div>
                        <div class="col-auto">
                          <!-- Icon -->
                          <span class="h2 fe fe-check-circle text-body-secondary mb-0"></span>
                        </div>
                      </div>
                      <!-- / .row -->
                    </div>
                  </div>
                </div>
                <div class="col-12 col-lg-6 col-xl">
                  <div class="row align-items-center gx-0">
                    <div class="col-12 col-lg-12">
                      <apexchart
                        type="radialBar"
                        :height="dimensionChart()"
                        :options="chartOption(1)"
                        :series="
                          totals(
                            personalData?.data?.structuredCount?.percentage
                              ? personalData?.data?.structuredCount?.percentage
                              : 0
                          )
                        "
                      ></apexchart>
                      <h3 class="text-center">Overall Fullfillment</h3>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Status Flow -->
              <div class="status-flow mb-2 mt-3 d-flex align-items-center">
                <h4 class="fw-bold mt-3 me-3">Status Flow:</h4>

                <!-- Draft Status -->
                <span class="badge bg-warning text-dark px-3 py-2 d-flex align-items-center">
                  <i class="fe fe-file-text me-1"></i> Draft
                </span>

                <!-- Arrow Icon -->
                <i class="fe fe-arrow-right mx-3 text-muted fs-5"></i>

                <!-- Submitted Status -->
                <span class="badge bg-success text-white px-3 py-2 d-flex align-items-center">
                  <i class="fe fe-check me-1"></i> Waiting Approval Manager
                </span>

                <!-- Arrow Icon -->
                <i class="fe fe-arrow-right mx-3 text-muted fs-5"></i>

                <!-- Approved Status -->
                <span class="badge bg-success text-white px-3 py-2 d-flex align-items-center">
                  <i class="fe fe-check me-1"></i> Waiting Approval HR
                </span>

                <!-- Arrow Icon -->
                <i class="fe fe-arrow-right mx-3 text-muted fs-5"></i>

                <!-- Enrolled Status -->
                <span class="badge bg-success text-white px-3 py-2 d-flex align-items-center">
                  <i class="fe fe-user-plus me-1"></i> Enrolled
                </span>

                <!-- Arrow Icon -->
                <i class="fe fe-arrow-right mx-3 text-muted fs-5"></i>

                <!-- In Review Status -->
                <span class="badge bg-info text-white px-3 py-2 d-flex align-items-center">
                  <i class="fe fe-eye me-1"></i> In Review
                </span>

                <!-- Arrow Icon -->
                <i class="fe fe-arrow-right mx-3 text-muted fs-5"></i>

                <!-- Completed Status -->
                <span class="badge bg-success text-white px-3 py-2 d-flex align-items-center">
                  <i class="fe fe-check-circle me-1"></i> Completed
                </span>

                <!-- Arrow Icon -->
                <!-- <i class="fe fe-arrow-right mx-3 text-muted fs-5"></i> -->

                <!-- Closed Status -->
                <!-- <span
                  class="badge bg-secondary text-white px-3 py-2 d-flex align-items-center">
                  <i class="fe fe-x me-1"></i> Closed
                </span> -->
              </div>
              <div class="row">
                <div class="col-8">
                  <div class="d-flex">
                    <div class="rectangle filled-target mt-3"></div>
                    <span class="ml-2 mt-2">: Proficiency Standard</span>
                    <div class="rectangle filled-achievement mt-3 ml-3"></div>
                    <span class="ml-2 mt-2">: Proficiency</span>
                  </div>
                </div>
                <!-- <div class="col-4">
                  <input
                    type="text"
                    class="form-control"
                    v-model="searchStructure"
                    placeholder="Search..." />
                </div> -->
              </div>
              <div class="row mt-2">
                <div class="col-3">
                  <v-select
                    v-model="idpPeriod"
                    :options="listIdpPeriod"
                    :reduce="(e) => e"
                    label="label"
                    placeholder="Select IDP Period"
                    @input="selectIdpPeriod"
                  >
                  </v-select>
                </div>
                <div class="col-3">
                  <v-select
                    v-model="filter_competency_struckture"
                    :options="dataCompetency"
                    :reduce="(e) => e"
                    label="competency"
                    placeholder="Filter By Competency"
                    @input="getDataIdpStructured"
                  >
                  </v-select>
                </div>
                <div class="col-2">
                  <v-select
                    v-model="filter_type_struckture"
                    :options="['Certification', 'Semi Certification', 'Training']"
                    :reduce="(e) => e"
                    label="label"
                    placeholder="Filter By Type"
                    @input="getDataIdpStructured"
                  >
                  </v-select>
                </div>
                <div class="col-2">
                  <v-select
                    v-model="filter_platform_struckture"
                    :options="['Ugems University', 'My Learning', 'Other']"
                    :reduce="(e) => e"
                    label="label"
                    placeholder="Filter By Platform"
                    @input="getDataIdpStructured"
                  >
                  </v-select>
                </div>
                <div class="col-2">
                  <input type="text" class="form-control" v-model="searchStructure" placeholder="Search..." />
                </div>
              </div>
              <div class="table overflow-scroll">
                <div v-if="isLoading" class="text-center my-4">
                  <span class="spinner-border" role="status" aria-hidden="true"></span>
                  <span>Loading...</span>
                </div>
                <table v-else class="table table-sm table-bordered table-nowrap mt-4">
                  <!-- Log structured -->
                  <!-- {{
                    structuredLearning
                  }} -->
                  <thead>
                    <tr class="">
                      <th rowspan="2">
                        <input type="checkbox" @click="changeAllStructur" v-model="checkStructured" />
                      </th>
                      <th rowspan="2">Training Title</th>
                      <th rowspan="2">Competency</th>
                      <th rowspan="2">Level</th>
                      <th rowspan="2">Gap</th>
                      <th rowspan="2">Learning Type</th>
                      <!-- <th rowspan="2">Platform</th> -->
                      <th rowspan="2">Provider</th>
                      <!-- <th rowspan="2">Proposed By</th>
                      <th rowspan="2">Price</th> -->
                      <th rowspan="2">Hour</th>
                      <th rowspan="2">Status</th>
                      <!-- <th rowspan="2">Proposed By</th>
                      <th colspan="2" class="text-center">Schedule</th>
                      <th rowspan="2">Score</th> -->
                      <th rowspan="2">Action</th>
                    </tr>
                    <!-- <tr class="">
                      <th colspan="1">Start Date</th>
                      <th colspan="1">End Date</th>
                    </tr> -->
                  </thead>
                  <tbody v-if="structuredLearning && structuredLearning.length > 0">
                    <tr v-for="(item, index) in structuredLearning" :key="index">
                      <td class="text-center">
                        <input
                          type="checkbox"
                          v-if="
                            (item.status === 'draft' || item.status === 'proposed') &&
                            item.training_title !== null &&
                            item.isAllowedAction
                          "
                          v-model="srStructuredLearning"
                          @click="changeOnceCheckboxStructured(item)"
                          :value="item.id"
                        />
                      </td>
                      <td class="">
                        {{ item.training_title }}
                        <div v-if="item.have_schedule && item.training_title">
                          <span :class="getBadgeStatus('scheduled')">
                            <i :class="getIconClass('scheduled')" class="me-1"></i>
                            {{ capitalizeStatus("scheduled") }}
                          </span>
                        </div>
                      </td>
                      <td v-if="item.competency !== null">
                        {{ item.competency }}
                      </td>
                      <td class="fw-bold" v-else></td>
                      <td v-if="item.competency">
                        <div class="rectangle-container">
                          <div
                            v-for="n in 5"
                            :key="'proficiency_standard-' + n"
                            :class="[
                              'rectangle',
                              {
                                'filled-target': n <= item.proficiency_standard,
                              },
                            ]"
                          ></div>
                        </div>
                        <div class="rectangle-container mt-1">
                          <div
                            v-for="n in 5"
                            :key="'proficiency-' + n"
                            :class="[
                              'rectangle',
                              {
                                'filled-achievement': n <= item.proficiency,
                              },
                            ]"
                          ></div>
                        </div>
                      </td>
                      <td v-else></td>
                      <td v-if="item.competency">
                        <span v-if="item.difference !== null" :class="getBadgeGap(item.difference)">
                          {{ Math.abs(item.difference) }}
                        </span>
                      </td>
                      <td v-else></td>
                      <td class="">
                        {{ item.training_type }}
                      </td>
                      <!-- <td class="">
                        {{ item.training_platform }}
                      </td> -->
                      <td class="">
                        {{ item.training_provider }}
                      </td>
                      <!-- <td class="">
                        {{ item.proposed_by }}
                      </td>
                      <td class="text-center" v-if="item.price !== null">
                        {{ item.training_currency }} {{ formatterNumber(item.price) }}
                      </td> -->
                      <!-- <td v-else></td> -->
                      <!-- 
                      <td class="">
                        {{ item.startDate }}
                      </td>
                      <td class="">
                        {{ item.endDate }}
                      </td>
                      <td class="">
                        {{ item.score }}
                      </td> -->
                      <td class="text-center">
                        {{ item.training_hours == "0.00" ? "-" : item.training_hours }}
                      </td>
                      <td class="text-center" v-if="item.training_title !== null">
                        <h2>
                          <span :class="getBadgeStatus(item.status)">
                            <i class="me-1"></i>
                            {{ modifyStatus(item.status) }}
                          </span>
                        </h2>
                      </td>
                      <td class="text-center">
                        <button
                          v-if="
                            item.status !== null &&
                            item.training_title !== null &&
                            listTabMenu &&
                            listTabMenu.tabMenu?.some((item) => item.title === 'Strcutured Learning' && item.privilages.read)
                          "
                          class="btn btn-sm btn-info mx-2"
                          @click="viewDetailStructured(item)"
                          v-b-tooltip.hover="'View Details'"
                        >
                          <span class="fe fe-eye"></span>
                        </button>
                        <!-- <button
                          v-if="item.status === 'enrolled'"
                          class="btn btn-sm btn-primary mx-2">
                          <span class="fe fe-download"></span>
                        </button> -->
                        <button
                          v-if="
                            (item.status === 'enrolled' || item.status === 'in review') && item.training_platform === 'Other'
                          "
                          class="btn btn-sm btn-primary mx-2"
                          @click="uploadCertificate(item)"
                        >
                          <span class="fe fe-upload"></span>
                        </button>
                        <!-- <button
                          v-if="item.status === 'enrolled'"
                          class="btn btn-sm btn-primary mx-2"
                          @click="uploadCertificate(item)">
                          <span class="fe fe-upload"></span>
                        </button> -->
                        <!-- <button
                          v-if="item.status === 'enrolled'"
                          class="btn btn-sm btn-primary mx-2"
                          @click="uploadCertificate(item)">
                          <span class="fe fe-upload"></span>
                        </button> -->
                        <!-- <button
                          v-if="item.status === 'draft'"
                          class="btn btn-sm btn-primary mx-2"
                          @click="enrollTrainingEvent()">
                          <span class="fe fe-rotate-ccw"></span>
                        </button> -->
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td class="text-center" colspan="12">No Data Available</td>
                    </tr>
                  </tbody>
                </table>
                <p class="mt-3">
                  <i> Note: If checked, it will be submitted. If unchecked, it will be rejected. </i>
                </p>
              </div>
              <div class="pagination-controls d-flex justify-content-between align-items-center mt-3">
                <div class="pagination-navigation d-flex align-items-center mt-4">
                  <!-- Previous button -->
                  <b-button
                    @click="prevPageStructure"
                    :disabled="currentPageStructure === 1 || isLoading"
                    size="sm"
                    variant="outline-primary"
                    class="me-2"
                  >
                    <i class="fe fe-chevron-left"></i> Previous
                  </b-button>

                  <!-- Page info -->
                  <span class="mx-3"> Page {{ currentPageStructure }} of {{ totalPagesStructure }} </span>

                  <!-- Next button -->
                  <b-button
                    @click="nextPageStructure"
                    :disabled="currentPageStructure === totalPagesStructure || isLoading"
                    size="sm"
                    variant="outline-primary"
                    class="ms-2"
                  >
                    Next <i class="fe fe-chevron-right"></i>
                  </b-button>
                </div>

                <div class="page-size-selector d-flex">
                  <label class="me-2">Show:</label>
                  <select
                    v-model="itemsPerPageStructure"
                    @change="changePageSizeStructured(itemsPerPageStructure)"
                    class="form-select form-select-sm"
                    style="width: auto"
                  >
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </div>
              </div>
              <div class="float-end mb-4">
                <b-button 
                  v-if="structuredLearning.length > 0" 
                  class="mr-3" 
                  @click="submitStructured()" 
                  variant="primary"
                  :disabled="isSubmittingStructured"
                >
                  <template v-if="isSubmittingStructured">
                    <b-spinner small></b-spinner>
                    Mengirim...
                  </template>
                  <template v-else>
                    <span class="fe fe-save"></span>
                    Submit
                  </template>
                </b-button>
                <!-- <b-button
                  v-else
                  @click="initStructuredLearning()"
                  variant="primary"
                  ><span class="fe fe-info"></span>
                  Get Recommendations
                </b-button> -->
              </div>
            </b-tab>
            <b-tab
              title="Social Learning"
              v-if="
                listTabMenu && listTabMenu.tabMenu?.some((item) => item.title === 'Social Learning' && item.privilages.read)
              "
            >
              <div class="row mt-5">
                <div class="col-12 col-lg-6 col-xl">
                  <!-- Value  -->
                  <div class="card bg-secondary text-white">
                    <div class="card-body">
                      <div class="row align-items-center gx-0">
                        <div class="col">
                          <!-- Title -->
                          <h6 class="text-uppercase text-body-secondary mb-2">Planned</h6>

                          <!-- Heading -->
                          <span class="h2 mb-0">
                            {{ personalData?.data?.socialCount?.planned ? personalData?.data?.socialCount.planned : 0 }}
                          </span>
                        </div>
                        <div class="col-auto">
                          <!-- Icon -->
                          <span class="h2 fe fe-file-text text-body-secondary mb-0"></span>
                        </div>
                      </div>
                      <!-- / .row -->
                    </div>
                  </div>
                </div>
                <div class="col-12 col-lg-6 col-xl">
                  <!-- Value  -->
                  <div class="card bg-warning">
                    <div class="card-body">
                      <div class="row align-items-center gx-0">
                        <div class="col">
                          <!-- Title -->
                          <h6 class="text-uppercase text-body-secondary mb-2">In Progress</h6>

                          <!-- Heading -->
                          <span class="h2 mb-0">
                            {{
                              personalData?.data?.socialCount?.in_progress ? personalData?.data?.socialCount.in_progress : 0
                            }}
                          </span>
                        </div>
                        <div class="col-auto">
                          <!-- Icon -->
                          <span class="h2 fe fe-loader text-body-secondary mb-0"></span>
                        </div>
                      </div>
                      <!-- / .row -->
                    </div>
                  </div>
                </div>
                <div class="col-12 col-lg-6 col-xl">
                  <!-- Hours -->
                  <div class="card bg-success text-white">
                    <div class="card-body">
                      <div class="row align-items-center gx-0">
                        <div class="col">
                          <!-- Title -->
                          <h6 class="text-uppercase text-body-secondary mb-2">Completed</h6>

                          <!-- Heading -->
                          <span class="h2 mb-0">
                            {{ personalData?.data?.socialCount?.completed ? personalData?.data?.socialCount.completed : 0 }}
                          </span>
                        </div>
                        <div class="col-auto">
                          <!-- Icon -->
                          <span class="h2 fe fe-check-circle text-body-secondary mb-0"></span>
                        </div>
                      </div>
                      <!-- / .row -->
                    </div>
                  </div>
                </div>
                <div class="col-12 col-lg-6 col-xl">
                  <div class="row align-items-center gx-0">
                    <div class="col-12 col-lg-12">
                      <apexchart
                        type="radialBar"
                        :height="dimensionChart()"
                        :options="chartOption(1)"
                        :series="
                          totals(
                            personalData?.data?.socialCount?.percentage ? personalData?.data?.socialCount?.percentage : 0
                          )
                        "
                      ></apexchart>
                      <h3 class="text-center">Overall Fullfillment</h3>
                    </div>
                  </div>
                </div>
              </div>
              <div class="status-flow mb-1 mt-3 d-flex align-items-center">
                <h4 class="fw-bold mt-3 me-3">Status Flow:</h4>

                <!-- Draft Status -->
                <span class="badge bg-warning text-dark px-3 py-2 d-flex align-items-center">
                  <i class="fe fe-file-text me-1"></i> Draft
                </span>

                <!-- Arrow Icon -->
                <i class="fe fe-arrow-right mx-3 text-muted fs-5"></i>

                <!-- Submitted Status -->
                <span class="badge bg-success text-white px-3 py-2 d-flex align-items-center">
                  <i class="fe fe-send me-1"></i> Submitted
                </span>

                <!-- Arrow Icon -->
                <i class="fe fe-arrow-right mx-3 text-muted fs-5"></i>

                <!-- Approved Status -->
                <span class="badge bg-success text-white px-3 py-2 d-flex align-items-center">
                  <i class="fe fe-check me-1"></i> Approved
                </span>
                <!-- Arrow Icon -->
                <i class="fe fe-arrow-right mx-3 text-muted fs-5"></i>

                <!-- Scheduled -->
                <span class="badge bg-warning text-black px-3 py-2 d-flex align-items-center">
                  <i class="fe fe-calendar me-1"></i> Scheduled
                </span>

                <!-- Arrow Icon -->
                <i class="fe fe-arrow-right mx-3 text-muted fs-5"></i>

                <!-- In Progress Status -->
                <span class="badge bg-warning text-dark px-3 py-2 d-flex align-items-center">
                  <i class="fe fe-loader me-1"></i> In Progress
                </span>

                <!-- Arrow Icon -->
                <i class="fe fe-arrow-right mx-3 text-muted fs-5"></i>

                <!-- In Progress Status -->
                <span class="badge bg-info px-3 py-2 d-flex align-items-center">
                  <i class="fe fe-eye me-1"></i> In Review
                </span>

                <!-- Arrow Icon -->
                <i class="fe fe-arrow-right mx-3 text-muted fs-5"></i>

                <!-- Completed Status -->
                <span class="badge bg-success text-white px-3 py-2 d-flex align-items-center">
                  <i class="fe fe-check-circle me-1"></i> Completed
                </span>
              </div>
              <div class="row">
                <div class="col-8">
                  <div class="d-flex">
                    <div class="rectangle filled-target mt-3"></div>
                    <span class="ml-2 mt-2">: Proficiency Standard</span>
                    <div class="rectangle filled-achievement mt-3 ml-3"></div>
                    <span class="ml-2 mt-2">: Proficiency</span>
                  </div>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-3">
                  <v-select
                    v-model="idpPeriod"
                    :options="listIdpPeriod"
                    :reduce="(e) => e"
                    label="label"
                    placeholder="Select IDP Period"
                    @input="selectIdpPeriod"
                  >
                  </v-select>
                </div>
                <div class="col-3">
                  <v-select
                    v-model="filter_competency_social"
                    :options="dataCompetency"
                    :reduce="(e) => e"
                    label="competency"
                    placeholder="Filter By Competency"
                    @input="getDataIdpSocial"
                  >
                  </v-select>
                </div>
                <div class="col-3">
                  <v-select
                    v-model="filter_type_social"
                    :options="['Coaching', 'Mentoring']"
                    :reduce="(e) => e"
                    label="label"
                    placeholder="Filter By Type"
                    @input="getDataIdpSocial"
                  >
                  </v-select>
                </div>
                <div class="col-3">
                  <input type="text" class="form-control" v-model="searchSocial" placeholder="Search..." />
                </div>
              </div>
              <div class="table overflow-scroll">
                <!-- Status Flow -->
                <div v-if="isLoading" class="text-center my-4">
                  <span class="spinner-border" role="status" aria-hidden="true"></span>
                  <span>Loading...</span>
                </div>

                <table v-else class="table table-sm table-bordered table-nowrap mt-4">
                  <thead>
                    <tr class="">
                      <th rowspan="2">
                        <input type="checkbox" @click="changeAllSocial" v-model="checkSocial" />
                      </th>
                      <th rowspan="2">Coaching Title</th>
                      <th rowspan="2">Competency</th>
                      <th rowspan="2">Level</th>
                      <th rowspan="2">Gap</th>
                      <th rowspan="2">Methodology</th>
                      <th rowspan="2">Coach Name</th>
                      <th rowspan="2">Type</th>
                      <th rowspan="2">Status</th>
                      <th rowspan="2">Action</th>
                    </tr>
                  </thead>

                  <tbody v-if="socialLearning && socialLearning.length > 0">
                    <tr v-for="(item, index) in socialLearning" :key="index">
                      <td class="text-center">
                        <input
                          type="checkbox"
                          v-if="(item.status === 'draft' || item.status === 'proposed') && item.coaching_title !== null"
                          @click="changeOnceCheckboxSocial(item)"
                          v-model="srSocialLearning"
                          :value="item.id"
                        />
                      </td>
                      <td class="">
                        {{ item.coaching_title }}
                      </td>
                      <td v-if="item.competency !== null">
                        {{ item.competency }}
                      </td>
                      <td class="fw-bold" v-else></td>
                      <td v-if="item.competency">
                        <div class="rectangle-container">
                          <div
                            v-for="n in 5"
                            :key="'proficiency_standard-' + n"
                            :class="[
                              'rectangle',
                              {
                                'filled-target': n <= item.proficiency_standard,
                              },
                            ]"
                          ></div>
                        </div>
                        <div class="rectangle-container mt-1">
                          <div
                            v-for="n in 5"
                            :key="'proficiency-' + n"
                            :class="[
                              'rectangle',
                              {
                                'filled-achievement': n <= item.proficiency,
                              },
                            ]"
                          ></div>
                        </div>
                      </td>
                      <td v-else></td>
                      <td v-if="item.competency">
                        <span v-if="item.difference !== null" :class="getBadgeGap(item.difference)">
                          {{ Math.abs(item.difference) }}
                        </span>
                      </td>
                      <td v-else></td>

                      <td class="">
                        {{ item.coaching_methodology }}
                      </td>
                      <td class="">
                        {{ item.coach_name }}
                      </td>
                      <!-- <td class="">
                          {{ item.training_type }}
                        </td>
                        <td class="">
                          {{ item.training_provider }}
                        </td>
                        <td class="">
                          {{ item.proposed_by }}
                        </td>
                        <td class="text-center" v-if="item.price !== null">
                          {{ formatPrice(item.price) }}
                        </td>
                        <td v-else></td> -->
                      <!-- 
                        <td class="">
                          {{ item.startDate }}
                        </td>
                        <td class="">
                          {{ item.endDate }}
                        </td>
                        <td class="">
                          {{ item.score }}
                        </td> -->
                      <td class="">
                        {{ item.id ? item.coaching_type : "" }}
                      </td>
                      <td class="text-center" v-if="item.coaching_title !== null">
                        <h2>
                          <span :class="getBadgeStatus(item.status)">
                            <i :class="getIconClass(item.status)" class="me-1"></i>
                            {{ capitalizeStatus(item.status) }}
                          </span>
                        </h2>
                      </td>
                      <!-- <td class="">
                          {{ item.score }}
                        </td> -->
                      <td class="text-center">
                        <button
                          v-if="
                            item.status !== null &&
                            item.coaching_title !== null &&
                            listTabMenu &&
                            listTabMenu.tabMenu?.some((item) => item.title === 'Social Learning' && item.privilages.read)
                          "
                          class="btn btn-sm btn-info mx-2"
                          @click="viewDetailSocial(item)"
                          v-b-tooltip.hover="'View Details'"
                        >
                          <span class="fe fe-eye"></span>
                        </button>
                        <!-- <button
                            v-if="item.status === 'enrolled'"
                            class="btn btn-sm btn-primary mx-2">
                            <span class="fe fe-download"></span>
                          </button> -->
                        <button
                          v-if="item.status === 'in progress' && item.is_completed == true"
                          class="btn btn-sm btn-primary mx-2"
                          @click="uploadPresentation(item)"
                          v-b-tooltip.hover="'Upload Presentation Document'"
                        >
                          <span class="fe fe-upload"></span>
                        </button>
                        <!-- <button
                            v-if="item.status === 'submitted'"
                            class="btn btn-sm btn-primary mx-2"
                            @click="enrollTrainingEvent()">
                            <span class="fe fe-rotate-ccw"></span>
                          </button> -->
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td class="text-center" colspan="12">No Data Available</td>
                    </tr>
                  </tbody>
                </table>
                <p class="mt-3">
                  <i> Note: If checked, it will be submitted. If unchecked, it will be rejected. </i>
                </p>
              </div>
              <div class="pagination-controls d-flex justify-content-between align-items-center mt-3">
                <div class="pagination-navigation d-flex align-items-center mt-4">
                  <!-- Previous button -->
                  <b-button
                    @click="prevPageStructure"
                    :disabled="currentPageSocial === 1 || isLoading"
                    size="sm"
                    variant="outline-primary"
                    class="me-2"
                  >
                    <i class="fe fe-chevron-left"></i> Previous
                  </b-button>

                  <!-- Page info -->
                  <span class="mx-3"> Page {{ currentPageSocial }} of {{ totalPagesSocial }} </span>

                  <!-- Next button -->
                  <b-button
                    @click="nextPageSocial"
                    :disabled="currentPageSocial === totalPagesSocial || isLoading"
                    size="sm"
                    variant="outline-primary"
                    class="ms-2"
                  >
                    Next <i class="fe fe-chevron-right"></i>
                  </b-button>
                </div>

                <!-- Page size selector (optional) -->
                <div class="page-size-selector d-flex">
                  <label class="me-2">Show:</label>
                  <select
                    v-model="itemsPerPageSocial"
                    @change="changePageSizeSocial(itemsPerPageSocial)"
                    class="form-select form-select-sm"
                    style="width: auto"
                  >
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </div>
              </div>
              <div class="float-end mb-4">
                <b-button
                  v-if="
                    socialLearning.length > 0 &&
                    listTabMenu &&
                    listTabMenu.tabMenu?.some((item) => item.title === 'Social Learning' && item.privilages.create)
                  "
                  class="mr-3"
                  @click="submitSocial()"
                  variant="primary"
                  :disabled="isSubmittingSocial"
                >
                  <template v-if="isSubmittingSocial">
                    <b-spinner small></b-spinner>
                    Mengirim...
                  </template>
                  <template v-else>
                    <span class="fe fe-save"></span>
                    Submit
                  </template>
                </b-button>
                <!-- <b-button v-else @click="initSocialLearning()" variant="primary"
                  ><span class="fe fe-info"></span>
                  Get Recommendations
                </b-button> -->
              </div>
            </b-tab>
            <b-tab
              title="Experiential Learning"
              v-if="
                listTabMenu &&
                listTabMenu.tabMenu?.some((item) => item.title === 'Experiential Learning' && item.privilages.read)
              "
            >
              <div class="row mt-5">
                <div class="col-12 col-lg-6 col-xl">
                  <!-- Value  -->
                  <div class="card bg-secondary text-white">
                    <div class="card-body">
                      <div class="row align-items-center gx-0">
                        <div class="col">
                          <!-- Title -->
                          <h6 class="text-uppercase text-body-secondary mb-2">Planned</h6>

                          <!-- Heading -->
                          <span class="h2 mb-0">
                            {{
                              personalData?.data?.experentialCount?.planned
                                ? personalData?.data?.experentialCount.planned
                                : 0
                            }}
                          </span>
                        </div>
                        <div class="col-auto">
                          <!-- Icon -->
                          <span class="h2 fe fe-file-text text-body-secondary mb-0"></span>
                        </div>
                      </div>
                      <!-- / .row -->
                    </div>
                  </div>
                </div>
                <div class="col-12 col-lg-6 col-xl">
                  <!-- Value  -->
                  <div class="card bg-warning">
                    <div class="card-body">
                      <div class="row align-items-center gx-0">
                        <div class="col">
                          <!-- Title -->
                          <h6 class="text-uppercase text-body-secondary mb-2">In Progress</h6>

                          <!-- Heading -->
                          <span class="h2 mb-0">
                            {{
                              personalData?.data?.experentialCount?.in_progress
                                ? personalData?.data?.experentialCount.in_progress
                                : 0
                            }}
                          </span>
                        </div>
                        <div class="col-auto">
                          <!-- Icon -->
                          <span class="h2 fe fe-loader text-body-secondary mb-0"></span>
                        </div>
                      </div>
                      <!-- / .row -->
                    </div>
                  </div>
                </div>
                <div class="col-12 col-lg-6 col-xl">
                  <!-- Hours -->
                  <div class="card bg-success text-white">
                    <div class="card-body">
                      <div class="row align-items-center gx-0">
                        <div class="col">
                          <!-- Title -->
                          <h6 class="text-uppercase text-body-secondary mb-2">Completed</h6>

                          <!-- Heading -->
                          <span class="h2 mb-0">
                            {{
                              personalData?.data?.experentialCount?.completed
                                ? personalData?.data?.experentialCount.completed
                                : 0
                            }}
                          </span>
                        </div>
                        <div class="col-auto">
                          <!-- Icon -->
                          <span class="h2 fe fe-check-circle text-body-secondary mb-0"></span>
                        </div>
                      </div>
                      <!-- / .row -->
                    </div>
                  </div>
                </div>
                <div class="col-12 col-lg-6 col-xl">
                  <div class="row align-items-center gx-0">
                    <div class="col-12 col-lg-12">
                      <apexchart
                        type="radialBar"
                        :height="dimensionChart()"
                        :options="chartOption(1)"
                        :series="
                          totals(
                            personalData?.data?.experentialCount?.percentage
                              ? personalData?.data?.experentialCount?.percentage
                              : 0
                          )
                        "
                      ></apexchart>
                      <h3 class="text-center">Overall Fullfillment</h3>
                    </div>
                  </div>
                </div>
              </div>
              <div class="status-flow mb-2 mt-3 d-flex align-items-center">
                <h4 class="fw-bold mt-3 me-3">Status Flow:</h4>

                <!-- Draft Status -->
                <span class="badge bg-warning text-dark px-3 py-2 d-flex align-items-center">
                  <i class="fe fe-file-text me-1"></i> Draft
                </span>

                <!-- Arrow Icon -->
                <i class="fe fe-arrow-right mx-3 text-muted fs-5"></i>

                <!-- Submitted Status -->
                <span class="badge bg-success text-white px-3 py-2 d-flex align-items-center">
                  <i class="fe fe-send me-1"></i> Submitted
                </span>

                <!-- Arrow Icon -->
                <i class="fe fe-arrow-right mx-3 text-muted fs-5"></i>

                <!-- Approved Status -->
                <span class="badge bg-success text-white px-3 py-2 d-flex align-items-center">
                  <i class="fe fe-check me-1"></i> Approved
                </span>

                <!-- Arrow Icon -->
                <i class="fe fe-arrow-right mx-3 text-muted fs-5"></i>

                <!-- In Progress Status -->
                <span class="badge bg-warning text-dark px-3 py-2 d-flex align-items-center">
                  <i class="fe fe-loader me-1"></i> In Progress
                </span>

                <!-- Arrow Icon -->
                <i class="fe fe-arrow-right mx-3 text-muted fs-5"></i>

                <!-- Completed Status -->
                <span class="badge bg-success text-white px-3 py-2 d-flex align-items-center">
                  <i class="fe fe-check-circle me-1"></i> Completed
                </span>
              </div>
              <div class="row">
                <div class="col-4">
                  <v-select
                    v-model="idpPeriod"
                    :options="listIdpPeriod"
                    :reduce="(e) => e"
                    label="label"
                    placeholder="Select IDP Period"
                    @input="selectIdpPeriod"
                  >
                  </v-select>
                </div>
                <div class="col-4">
                  <v-select
                    v-model="filter_competency_experiental"
                    :options="dataCompetency"
                    :reduce="(e) => e"
                    label="competency"
                    placeholder="Filter By Competency"
                    @input="getDataIdpExperiential"
                  >
                  </v-select>
                </div>
                <div class="col-4">
                  <input type="text" class="form-control" v-model="searchExperiential" placeholder="Search..." />
                </div>
              </div>

              <div class="table overflow-scroll">
                <table class="table table-sm table-bordered table-nowrap mt-4">
                  <thead>
                    <tr class="">
                      <!-- <th rowpan="2">#</th> -->
                      <th rowspan="2">Project Name</th>
                      <!-- <th rowspan="2">Competency</th> -->
                      <th rowspan="2">Related Competency</th>
                      <!-- <th rowspan="2">Project Description</th> -->
                      <th rowspan="2">Start Date</th>
                      <th rowspan="2">End Date</th>
                      <th rowspan="2">Duration (Days)</th>
                      <th rowspan="2">Notes manager</th>
                      <th class="text-center" rowspan="2">Status</th>
                      <th rowspan="2">Action</th>
                    </tr>
                  </thead>
                  <tbody v-if="experientialLearning.length > 0">
                    <!-- {{experientialLearning}} -->
                    <tr v-for="(item, index) in experientialLearning" :key="index">
                      <!-- <td class="text-center">
                        <input
                          type="checkbox"
                          v-model="srExperientialLearning"
                          :value="item.id" />
                      </td> -->
                      <td class="text-center">
                        {{ item.project.name }}
                      </td>
                      <!-- <td class="">
                        <ul class="list-unstyled mb-0">
                          <li
                            v-for="(competency, cIndex) in item.competencies"
                            :key="cIndex">
                            {{ competency.competency_name }}
                          </li>
                        </ul>
                      </td> -->
                      <td class="">
                        <ul class="list-unstyled mb-0">
                          <li v-for="(competency, cIndex) in item.competency" :key="cIndex">
                            {{ competency.name }}
                          </li>
                        </ul>
                        <!-- {{ item.competency }} -->
                      </td>
                      <!-- <td class="">
                        {{ item.project.description }}
                      </td> -->
                      <td class="text-center">
                        {{ formatDateTable(item.project.start_date) || "-" }}
                      </td>
                      <td class="text-center">
                        {{ formatDateTable(item.project.end_date) }}
                      </td>
                      <td class="">
                        {{ item.project.duration }}
                      </td>
                      <td class="">
                        {{ item.notes || "-" }}
                      </td>
                      <td class="text-center">
                        <h2>
                          <span :class="getBadgeStatus(item.status)">
                            <i :class="getIconClass(item.status)" class="me-1"></i>
                            {{ capitalizeStatus(item.status) }}</span
                          >
                        </h2>
                      </td>

                      <td class="text-center">
                        <button
                          v-if="
                            listTabMenu &&
                            listTabMenu.tabMenu?.some(
                              (item) => item.title === 'Experiential Learning' && item.privilages.read
                            )
                          "
                          @click="viewActivities(item)"
                          class="btn btn-sm btn-info mx-2"
                          v-b-tooltip.hover="'View Details'"
                        >
                          <span class="fe fe-eye"></span>
                        </button>
                        <button
                          v-if="
                            (item.status == 'draft' || item.status == 'revision') && item.project.created_by == nikByLogin
                          "
                          @click="submitExperiential(item)"
                          class="btn btn-sm btn-primary mx-2"
                          v-b-tooltip.hover="'Submit Project'"
                        >
                          <span class="fe fe-save"></span>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td class="text-center" colspan="12">No Data Available</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="pagination-controls d-flex justify-content-between align-items-center mt-3">
                <div class="pagination-navigation d-flex align-items-center mt-4">
                  <!-- Previous button -->
                  <b-button
                    @click="prevPageStructure"
                    :disabled="currentPageSocial === 1 || isLoading"
                    size="sm"
                    variant="outline-primary"
                    class="me-2"
                  >
                    <i class="fe fe-chevron-left"></i> Previous
                  </b-button>

                  <!-- Page info -->
                  <span class="mx-3"> Page {{ currentPageSocial }} of {{ totalPagesSocial }} </span>

                  <!-- Next button -->
                  <b-button
                    @click="nextPageSocial"
                    :disabled="currentPageSocial === totalPagesSocial || isLoading"
                    size="sm"
                    variant="outline-primary"
                    class="ms-2"
                  >
                    Next <i class="fe fe-chevron-right"></i>
                  </b-button>
                </div>

                <!-- Page size selector (optional) -->
                <div class="page-size-selector d-flex">
                  <label class="me-2">Show:</label>
                  <select
                    v-model="itemsPerPageSocial"
                    @change="changePageSizeSocial(itemsPerPageSocial)"
                    class="form-select form-select-sm"
                    style="width: auto"
                  >
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </div>
              </div>
            </b-tab>
            <b-tab
              title="IDP Examination"
              v-if="
                listTabMenu && listTabMenu.tabMenu?.some((item) => item.title === 'IDP Examination' && item.privilages.read)
              "
            >
              <div class="card-body">
                <div class="col-lg-12 mt-5">
                  <div class="row mt-4">
                    <div class="col-lg-2">
                      <p class="small mt-2">
                        <strong>Name</strong>
                      </p>
                    </div>
                    <div class="col-4">
                      {{ aboutMe.fullname }}
                    </div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-2">
                      <p class="small mt-2">
                        <strong>NIK</strong>
                      </p>
                    </div>
                    <div class="col-4">
                      {{ aboutMe.nik || "-" }}
                    </div>
                  </div>
                  <div class="row mt-4">
                    <div class="col-lg-2">
                      <p class="small mt-2">
                        <strong>Position</strong>
                      </p>
                    </div>
                    <div class="col-4">
                      {{ aboutMe.position || "-" }}
                    </div>
                  </div>
                  <!-- v-if="" -->
                </div>
                <div class="d-flex">
                  <div class="rectangle filled-danger mt-3"></div>
                  <span class="ml-2 mt-2">: Below than Proficiency Standard</span>
                  <div class="rectangle filled-target mt-3 ml-3"></div>
                  <span class="ml-2 mt-2">: Meet Proficiency Standard</span>
                  <div class="rectangle filled-achievement mt-3 ml-3"></div>
                  <span class="ml-2 mt-2">: Above Proficiency Standard</span>
                  <b-button
                    v-b-modal.modal-loading
                    class="btn btn-primary ml-auto mt-5"
                    variant="primary"
                    title="Export IDP Report"
                    @click="exportPdf"
                  >
                    <span class="fe fe-download"></span>
                    IDP Report
                  </b-button>
                </div>
              </div>
              <b-tabs class="px-4">
                <b-tab title="All">
                  <div class="table overflow-scroll">
                    <table class="table table-sm table-bordered table-nowrap mt-4">
                      <thead>
                        <tr class="">
                          <th rowspan="2">Competency</th>
                          <th rowspan="2">Proficiency Standard</th>
                          <th rowspan="2">Assessment Result</th>
                          <th rowspan="2">Gap</th>
                          <th rowspan="2">IDP</th>
                          <th class="text-center" rowspan="2">IDP Status</th>
                          <th rowspan="2">Examination Result</th>
                          <th rowspan="2">New Gap</th>
                          <th rowspan="2">Action</th>
                        </tr>
                      </thead>
                      <tbody v-if="idpExamination.all ? idpExamination.all.length > 0 : false">
                        <tr v-for="(item, index) in idpExamination.all" :key="index">
                          <td>{{ item.competency_name }}</td>
                          <td class="text-center">
                            {{ item.proficiency_standard }}
                          </td>
                          <td class="text-center">{{ item.proficiency }}</td>
                          <td class="text-center">
                            <span
                              v-if="item.proficiency_difference !== null"
                              :class="getBadgeGapExam(item.proficiency_difference)"
                            >
                              {{
                                item.proficiency_difference > 0
                                  ? "" + item.proficiency_difference
                                  : item.proficiency_difference
                              }}
                            </span>
                          </td>
                          <td>
                            <ul class="list-unstyled mb-0">
                              <li class="mb-3" v-for="(learning, lIndex) in item.items" :key="lIndex">
                                {{ learning.learning.name || learning.learning.title }}
                              </li>
                            </ul>
                          </td>
                          <td>
                            <ul class="list-unstyled mb-0">
                              <li class="mb-3" v-for="(learning, lIndex) in item.items" :key="lIndex">
                                <span :class="getBadgeStatus(learning.learning.status)">
                                  <i :class="getIconClass(learning.learning.status)" class="me-1"></i>
                                  {{ capitalizeStatus(learning.learning.status) }}
                                </span>
                              </li>
                            </ul>
                          </td>
                          <td class="text-center">
                            <span
                              v-if="item.proficiency_new !== null"
                              :class="getBadgeResult(item.proficiency_new, item.proficiency_standard)"
                            >
                              {{ item.proficiency_new > 0 ? "" + item.proficiency_new : item.proficiency_new }}
                            </span>
                          </td>
                          <td class="text-center">
                            <span
                              v-if="item.proficiency_difference_new !== null"
                              :class="getBadgeGapExam(item.proficiency_difference_new)"
                            >
                              {{ Math.abs(item.proficiency_difference_new) }}
                            </span>
                          </td>
                          <!-- <td>
                            {{ item.feedback }}
                          </td> -->
                          <td class="text-center">
                            <button
                              v-if="item.items && item.items.length > 0 && item.feedback !== null"
                              class="btn btn-sm btn-info mx-1 my-1"
                              @click="viewFeedback(item)"
                              v-b-tooltip.hover="'View Feedback'"
                            >
                              <span class="fe fe-eye"></span>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                      <tbody v-else>
                        <tr>
                          <td class="text-center" colspan="12">No Data Available</td>
                        </tr>
                      </tbody>
                    </table>
                    <div class="pagination-controls">
                      <label for="itemsPerPage">Items per page:</label>
                      <select id="itemsPerPage" v-model="itemsPerPage">
                        <option v-for="option in itemsPerPageOptions" :key="option" :value="option">
                          {{ option }}
                        </option>
                      </select>
                    </div>
                    <div class="pagination">
                      <button @click="prevPage" :disabled="currentPage === 1">Previous</button>
                      <span>Page {{ currentPage }} of {{ totalPages }}</span>
                      <button @click="nextPage" :disabled="currentPage === totalPages">Next</button>
                    </div>
                  </div>
                </b-tab>
                <b-tab title="Structured Learning">
                  <div class="table-responsive">
                    <table class="table table-sm table-bordered table-nowrap mt-4">
                      <thead>
                        <tr class="">
                          <th rowspan="2">Competency</th>
                          <th rowspan="2">Proficiency Standard</th>
                          <th rowspan="2">Assessment Result</th>
                          <th rowspan="2">Gap</th>
                          <th rowspan="2">IDP</th>
                          <th class="text-center" rowspan="2">IDP Status</th>
                          <th rowspan="2">Examination Result</th>
                          <th rowspan="2">New Gap</th>
                          <th rowspan="2">Action</th>
                        </tr>
                      </thead>
                      <tbody v-if="idpExamination.structured ? idpExamination.structured.length > 0 : false">
                        <tr v-for="(item, index) in idpExamination.structured" :key="index">
                          <td>{{ item.competency_name }}</td>
                          <td class="text-center">
                            {{ item.proficiency_standard }}
                          </td>
                          <td class="text-center">{{ item.proficiency }}</td>
                          <td class="text-center">
                            <span
                              v-if="item.proficiency_difference !== null"
                              :class="getBadgeGapExam(item.proficiency_difference)"
                            >
                              {{
                                item.proficiency_difference > 0
                                  ? "" + item.proficiency_difference
                                  : item.proficiency_difference
                              }}
                            </span>
                          </td>
                          <td>
                            <ul class="list-unstyled mb-0">
                              <li class="mb-3" v-for="(learning, lIndex) in item.items" :key="lIndex">
                                {{ learning.learning.name || learning.learning.title }}
                              </li>
                            </ul>
                          </td>
                          <td>
                            <ul class="list-unstyled mb-0">
                              <li class="mb-3" v-for="(learning, lIndex) in item.items" :key="lIndex">
                                <span :class="getBadgeStatus(learning.learning.status)">
                                  <i :class="getIconClass(learning.learning.status)" class="me-1"></i>
                                  {{ capitalizeStatus(learning.learning.status) }}
                                </span>
                              </li>
                            </ul>
                          </td>
                          <td class="text-center">
                            <span
                              v-if="item.proficiency_new !== null"
                              :class="getBadgeResult(item.proficiency_new, item.proficiency_standard)"
                            >
                              {{ item.proficiency_new > 0 ? "" + item.proficiency_new : item.proficiency_new }}
                            </span>
                          </td>
                          <td class="text-center">
                            <span
                              v-if="item.proficiency_difference_new !== null"
                              :class="getBadgeGapExam(item.proficiency_difference_new)"
                            >
                              {{ Math.abs(item.proficiency_difference_new) }}
                            </span>
                          </td>
                          <td class="text-center">
                            <button
                              v-if="item.items && item.items.length > 0 && item.feedback !== null"
                              class="btn btn-sm btn-info mx-1 my-1"
                              @click="viewFeedback(item)"
                              v-b-tooltip.hover="'View Feedback'"
                            >
                              <span class="fe fe-eye"></span>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                      <tbody v-else>
                        <tr>
                          <td class="text-center" colspan="12">No Data Available</td>
                        </tr>
                      </tbody>
                    </table>
                    <!-- <div class="pagination-controls">
                  <label for="itemsPerPage">Items per page:</label>
                  <select id="itemsPerPage" v-model="itemsPerPage">
                    <option
                      v-for="option in itemsPerPageOptions"
                      :key="option"
                      :value="option">
                      {{ option }}
                    </option>
                  </select>
                </div>
                <div class="pagination">
                  <button @click="prevPage" :disabled="currentPage === 1">
                    Previous
                  </button>
                  <span>Page {{ currentPage }} of {{ totalPages }}</span>
                  <button
                    @click="nextPage"
                    :disabled="currentPage === totalPages">
                    Next
                  </button>
                </div> -->
                  </div>
                </b-tab>
                <b-tab title="Social Learning">
                  <div class="table-responsive">
                    <table class="table table-sm table-bordered table-nowrap mt-4">
                      <thead>
                        <tr class="">
                          <th rowspan="2">Competency</th>
                          <th rowspan="2">Proficiency Standard</th>
                          <th rowspan="2">Assessment Result</th>
                          <th rowspan="2">Gap</th>
                          <th rowspan="2">IDP</th>
                          <th class="text-center" rowspan="2">IDP Status</th>
                          <th rowspan="2">Examination Result</th>
                          <th rowspan="2">New Gap</th>
                          <th rowspan="2">Action</th>
                        </tr>
                      </thead>
                      <tbody v-if="idpExamination.social ? idpExamination.social.length > 0 : false">
                        <tr v-for="(item, index) in idpExamination.social" :key="index">
                          <td>{{ item.competency_name }}</td>
                          <td class="text-center">
                            {{ item.proficiency_standard }}
                          </td>
                          <td class="text-center">{{ item.proficiency }}</td>
                          <td class="text-center">
                            <span
                              v-if="item.proficiency_difference !== null"
                              :class="getBadgeGapExam(item.proficiency_difference)"
                            >
                              {{
                                item.proficiency_difference > 0
                                  ? "" + item.proficiency_difference
                                  : item.proficiency_difference
                              }}
                            </span>
                          </td>
                          <td>
                            <ul class="list-unstyled mb-0">
                              <li class="mb-3" v-for="(learning, lIndex) in item.items" :key="lIndex">
                                {{ learning.learning.name || learning.learning.title }}
                              </li>
                            </ul>
                          </td>
                          <td>
                            <ul class="list-unstyled mb-0">
                              <li class="mb-3" v-for="(learning, lIndex) in item.items" :key="lIndex">
                                <span :class="getBadgeStatus(learning.learning.status)">
                                  <i :class="getIconClass(learning.learning.status)" class="me-1"></i>
                                  {{ capitalizeStatus(learning.learning.status) }}
                                </span>
                              </li>
                            </ul>
                          </td>
                          <td class="text-center">
                            <span
                              v-if="item.proficiency_new !== null"
                              :class="getBadgeResult(item.proficiency_new, item.proficiency_standard)"
                            >
                              {{ item.proficiency_new > 0 ? "" + item.proficiency_new : item.proficiency_new }}
                            </span>
                          </td>
                          <td class="text-center">
                            <span
                              v-if="item.proficiency_difference_new !== null"
                              :class="getBadgeGapExam(item.proficiency_difference_new)"
                            >
                              {{ Math.abs(item.proficiency_difference_new) }}
                            </span>
                          </td>
                          <td class="text-center">
                            <button
                              v-if="item.items && item.items.length > 0 && item.feedback !== null"
                              class="btn btn-sm btn-info mx-1 my-1"
                              @click="viewFeedback(item)"
                              v-b-tooltip.hover="'View Feedback'"
                            >
                              <span class="fe fe-eye"></span>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                      <tbody v-else>
                        <tr>
                          <td class="text-center" colspan="12">No Data Available</td>
                        </tr>
                      </tbody>
                    </table>
                    <!-- <div class="pagination-controls">
                  <label for="itemsPerPage">Items per page:</label>
                  <select id="itemsPerPage" v-model="itemsPerPage">
                    <option
                      v-for="option in itemsPerPageOptions"
                      :key="option"
                      :value="option">
                      {{ option }}
                    </option>
                  </select>
                </div>
                <div class="pagination">
                  <button @click="prevPage" :disabled="currentPage === 1">
                    Previous
                  </button>
                  <span>Page {{ currentPage }} of {{ totalPages }}</span>
                  <button
                    @click="nextPage"
                    :disabled="currentPage === totalPages">
                    Next
                  </button>
                </div> -->
                  </div>
                </b-tab>
                <b-tab title="Experiential Learning">
                  <div class="table-responsive">
                    <table class="table table-sm table-bordered table-nowrap mt-4">
                      <thead>
                        <tr class="">
                          <th rowspan="2">Competency</th>
                          <th rowspan="2">Proficiency Standard</th>
                          <th rowspan="2">Assessment Result</th>
                          <th rowspan="2">Gap</th>
                          <th rowspan="2">IDP</th>
                          <th class="text-center" rowspan="2">IDP Status</th>
                          <th rowspan="2">Examination Result</th>
                          <th rowspan="2">New Gap</th>
                          <th rowspan="2">Action</th>
                        </tr>
                      </thead>
                      <tbody v-if="idpExamination.experential ? idpExamination.experential.length > 0 : false">
                        <tr v-for="(item, index) in idpExamination.experential" :key="index">
                          <td>{{ item.competency_name }}</td>
                          <td class="text-center">
                            {{ item.proficiency_standard }}
                          </td>
                          <td class="text-center">{{ item.proficiency }}</td>
                          <td class="text-center">
                            <span
                              v-if="item.proficiency_difference !== null"
                              :class="getBadgeGapExam(item.proficiency_difference)"
                            >
                              {{
                                item.proficiency_difference > 0
                                  ? "" + item.proficiency_difference
                                  : item.proficiency_difference
                              }}
                            </span>
                          </td>
                          <td>
                            <ul class="list-unstyled mb-0">
                              <li class="mb-3" v-for="(learning, lIndex) in item.items" :key="lIndex">
                                {{ learning.learning.name || learning.learning.title }}
                              </li>
                            </ul>
                          </td>
                          <td>
                            <ul class="list-unstyled mb-0">
                              <li class="mb-3" v-for="(learning, lIndex) in item.items" :key="lIndex">
                                <span :class="getBadgeStatus(learning.learning.status)">
                                  <i :class="getIconClass(learning.learning.status)" class="me-1"></i>
                                  {{ capitalizeStatus(learning.learning.status) }}
                                </span>
                              </li>
                            </ul>
                          </td>
                          <td class="text-center">
                            <span
                              v-if="item.proficiency_new !== null"
                              :class="getBadgeResult(item.proficiency_new, item.proficiency_standard)"
                            >
                              {{ item.proficiency_new > 0 ? "" + item.proficiency_new : item.proficiency_new }}
                            </span>
                          </td>
                          <td class="text-center">
                            <span
                              v-if="item.proficiency_difference_new !== null"
                              :class="getBadgeGapExam(item.proficiency_difference_new)"
                            >
                              {{ Math.abs(item.proficiency_difference_new) }}
                            </span>
                          </td>
                          <td class="text-center">
                            <button
                              v-if="item.items && item.items.length > 0 && item.feedback !== null"
                              class="btn btn-sm btn-info mx-1 my-1"
                              @click="viewFeedback(item)"
                              v-b-tooltip.hover="'View Feedback'"
                            >
                              <span class="fe fe-eye"></span>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                      <tbody v-else>
                        <tr>
                          <td class="text-center" colspan="12">No Data Available</td>
                        </tr>
                      </tbody>
                    </table>
                    <!-- <div class="pagination-controls">
                  <label for="itemsPerPage">Items per page:</label>
                  <select id="itemsPerPage" v-model="itemsPerPage">
                    <option
                      v-for="option in itemsPerPageOptions"
                      :key="option"
                      :value="option">
                      {{ option }}
                    </option>
                  </select>
                </div>
                <div class="pagination">
                  <button @click="prevPage" :disabled="currentPage === 1">
                    Previous
                  </button>
                  <span>Page {{ currentPage }} of {{ totalPages }}</span>
                  <button
                    @click="nextPage"
                    :disabled="currentPage === totalPages">
                    Next
                  </button>
                </div> -->
                  </div>
                </b-tab>
              </b-tabs>
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>
    <!-- MODAL HERE -->
    <!-- View Feedback -->
    <b-modal v-model="isModalViewFeedback" title="Current Competency Proficiency after IDP" size="lg" hide-footer>
      <div class="form-group">
        <div class="row">
          <!-- Kompetensi -->
          <div class="row justify-content-center mb-4">
            <div class="col-12">
              <table class="table table-bordered text-center">
                <thead class="table-light">
                  <tr>
                    <th>Competency</th>
                    <th>Old Proficiency</th>
                    <th>Standart Proficiency</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ bodyFeedbackExam.competency }}</td>
                    <td>{{ bodyFeedbackExam.old_proficiency }}</td>
                    <td>{{ bodyFeedbackExam.standartd_proficiency }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Proficiency Saat Ini -->
          <div class="col-md-6 col-12 mb-3">
            <label class="form-label">New Proficiency</label>
            <input
              v-model="bodyFeedbackExam.proficiency"
              type="number"
              class="form-control"
              placeholder="Nilai Saat Ini"
              disabled
            />
          </div>

          <!-- Feedback (textarea) -->
          <div class="col-md-6 col-12 mb-3">
            <label class="form-label">Feedback</label>
            <textarea
              v-model="bodyFeedbackExam.feedback"
              class="form-control"
              rows="4"
              placeholder="Tulis feedback lebih lengkap..."
              disabled
            ></textarea>
          </div>
        </div>
      </div>
      <!-- <b-button class="float-end" variant="primary" @click="submitFeedback()"
        >Submit
      </b-button> -->
    </b-modal>
    <b-modal id="modal-loading" size="sm" centered hide-header hide-footer no-close-on-backdrop no-close-on-esc>
      <b class="d-flex justify-content-center mb-3">Please wait</b>
      <div class="d-flex justify-content-center">
        <b-spinner variant="primary" label="Loading"></b-spinner>
      </div>
    </b-modal>
    <b-modal v-model="isEditProficiency" title="Update Proficiency" size="lg" hide-footer>
      <div class="form-group">
        <div class="row">
          <div class="col-12">
            <label>Proficiency</label>
            <input v-model="bodyProficiency.proficiency" type="text" class="form-control" placeholder="Proficiency" />
          </div>
        </div>
      </div>
      <b-button 
        class="float-end" 
        variant="primary" 
        @click="submitEditProficiency()"
        :disabled="isSubmittingEditProficiency"
      >
        <template v-if="isSubmittingEditProficiency">
          <b-spinner small></b-spinner>
          Mengirim...
        </template>
        <template v-else>
          Submit
        </template>
      </b-button>
    </b-modal>
    <!-- Modal Activity -->
    <b-modal v-model="isModalActivities" title="Project Milestone" size="xl" hide-footer @hide="clearBodyActivities">
      <!-- {{ selectedRow }} -->
      <b-card>
        <b-card-body>
          <b-row>
            <b-col md="3">
              <b-card-title>Project Name</b-card-title>
              <b-card-text v-if="selectedRowExperiential">{{ selectedRowExperiential.project.name }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="3">
              <b-card-title>Project Description</b-card-title>
              <b-card-text v-if="selectedRowExperiential">{{ selectedRowExperiential.project.description }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="3">
              <b-card-title>Duration</b-card-title>
              <b-card-text v-if="selectedRowExperiential">{{ selectedRowExperiential.project.duration }} Days</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="3" class="">
              <b-card-title>Status</b-card-title>
              <b-card-text v-if="selectedRowExperiential">
                <h2>
                  <span :class="getBadgeStatus(selectedRowExperiential.status)">
                    <i :class="getIconClass(selectedRowExperiential.status)" class="me-1"></i>
                    {{ capitalizeStatus(selectedRowExperiential.status) }}</span
                  >
                </h2>
              </b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="3" class="mt-4">
              <b-card-title>Start Date</b-card-title>
              <b-card-text v-if="selectedRowExperiential">{{
                formatDateTable(selectedRowExperiential.project.start_date)
              }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="3" class="mt-4">
              <b-card-title>End Date</b-card-title>
              <b-card-text v-if="selectedRowExperiential">{{
                formatDateTable(selectedRowExperiential.project.end_date)
              }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <!-- <b-col md="3" class="mt-4">
              <b-card-title>Involvement</b-card-title>
              <b-card-text v-if="selectedRowExperiential">{{
                selectedRowExperiential.project.involment
              }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="3" class="mt-4">
              <b-card-title>Project Team</b-card-title>
              <b-card-text v-if="selectedRowExperiential">{{
                selectedRowExperiential.project.subordinate
              }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col> -->
            <b-col md="3" class="mt-4">
              <b-card-title>Bussiness Need</b-card-title>
              <b-card-text v-if="selectedRowExperiential">{{ selectedRowExperiential.project.business_need }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="3" class="mt-4">
              <b-card-title>Objectives</b-card-title>
              <b-card-text v-if="selectedRowExperiential">{{
                selectedRowExperiential.project?.objectives || "-"
              }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="3" class="mt-4">
              <b-card-title>Goals</b-card-title>
              <b-card-text v-if="selectedRowExperiential">{{ selectedRowExperiential.project.goals }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="3" class="mt-4">
              <b-card-title>Scope</b-card-title>
              <b-card-text v-if="selectedRowExperiential">{{ selectedRowExperiential.project.scope }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="3" class="mt-4">
              <b-card-title>Constraints</b-card-title>
              <b-card-text v-if="selectedRowExperiential">{{ selectedRowExperiential.project.constraints }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="3" class="mt-4">
              <b-card-title>Deliverables</b-card-title>
              <b-card-text v-if="selectedRowExperiential">{{ selectedRowExperiential.project.deliverables }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="3" class="mt-4">
              <b-card-title>Impact A</b-card-title>
              <b-card-text v-if="selectedRowExperiential">{{ selectedRowExperiential.project.impact_a }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="3" class="mt-4">
              <b-card-title>Impact</b-card-title>
              <b-card-text v-if="selectedRowExperiential">{{ selectedRowExperiential.project.impact }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="3" class="mt-4">
              <b-card-title>Impact B</b-card-title>
              <b-card-text v-if="selectedRowExperiential">{{ selectedRowExperiential.project.impact_b }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="3" class="mt-4">
              <b-card-title>Created By</b-card-title>
              <b-card-text v-if="selectedRowExperiential">
                {{ selectedRowExperiential.creator?.nik }} -
                {{ selectedRowExperiential.creator?.employee_name }}
              </b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12" class="mt-4">
              <b-card-title>Project Teams</b-card-title>
              <b-card-text v-if="selectedRowExperiential">
                <table class="table table-sm table-bordered">
                  <thead>
                    <tr>
                      <th>Role</th>
                      <th>NIK</th>
                      <th>Name</th>
                      <th>Department</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in selectedRowExperiential?.teams" :key="index">
                      <td>{{ item.role }}</td>
                      <td>{{ item.nik }}</td>
                      <td>{{ item.employee_name }}</td>
                      <td>{{ item.department }}</td>
                    </tr>
                  </tbody>
                </table>
              </b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
          </b-row>
          <b-row class="mt-4">
            <b-col v-if="selectedRowExperiential">
              <b-card-title>Attachments</b-card-title>
              <img
                :src="
                  selectedRowExperiential.project?.attachments ? selectedRowExperiential.project.attachments[0]?.url : ''
                "
                :style="{ width: '300px', height: 'auto' }"
                alt="Certificate"
                class="img-fluid"
              />
            </b-col>
          </b-row>
          <!-- <b-row md="4" class="mt-4" v-if="selectedRow">
            <b-col v-if="selectedRow.project.attachment">
              <b-card-title>Certificate</b-card-title>
              <img
                :src="certificateUrl"
                :style="{ width: '300px', height: 'auto' }"
                alt="Certificate"
                class="img-fluid" />
            </b-col>
          </b-row> -->
        </b-card-body>
      </b-card>

      <div v-if="selectedRowExperiential" class="mt-4 float-end mb-4">
        <b-button
          v-if="
            (selectedRowExperiential.status == 'draft' || selectedRowExperiential.status == 'revision') &&
            selectedRowExperiential.project.created_by == nikByLogin
          "
          @click="addActivities"
          variant="primary"
          ><span class="fe fe-plus"></span>Add Milestone</b-button
        >
      </div>

      <!-- Activities Table -->
      <div class="mt-4">
        <h4>Milestone</h4>
        <table class="table table-sm table-bordered">
          <thead>
            <tr>
              <!-- <th>#</th> -->
              <th>Task</th>
              <th>Start Date</th>
              <th>End Date</th>
              <!-- <th>Predecessor</th> -->
              <th>Actual Start Date</th>
              <th>Actual End Date</th>
              <th>Progress (%)</th>
              <!-- <th>Percentage (%)</th> -->
              <th>Status</th>
              <th>Evidence File</th>
              <th>Feedback</th>
              <th>Assigned</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody v-if="dataActivities.length != 0">
            <tr v-for="(item, index) in dataActivities" :key="index">
              <td>{{ item.task }}</td>
              <td>{{ formatDateTable(item.start_date) }}</td>
              <td>{{ formatDateTable(item.end_date) }}</td>
              <!-- <td>{{ item.predecessor || "-" }}</td> -->
              <td>{{ formatDateTable(item.actual_start_date) || "-" }}</td>
              <td>{{ formatDateTable(item.actual_end_date) || "-" }}</td>
              <td>{{ item.new_progress }}</td>
              <!-- <td>{{ item.percentage }}</td> -->
              <td class="text-center">
                <h2>
                  <span :class="getBadgeStatus(item.status)">
                    <i :class="getIconClass(item.status)" class="me-1"></i>
                    {{ capitalizeStatus(item.status) }}
                  </span>
                </h2>
              </td>
              <td>
                <a v-if="item.evidence && item.evidence.length > 0" :href="item.evidence[0].url" target="_blank"> Files </a>
                <span v-else>-</span>
              </td>
              <td>
                <ul>
                  <li v-for="(feedback, fIndex) in item.feedback" :key="fIndex">
                    {{ feedback.feedback }}
                  </li>
                </ul>
              </td>
              <td>
                <ul>
                  <li v-for="(employee, fIndex) in item.employee" :key="fIndex">
                    {{ employee.employee_name }}
                  </li>
                </ul>
              </td>
              <td class="text-center">
                <button
                  v-if="item.status != 'completed'"
                  class="btn btn-sm btn-warning mx-1 my-1"
                  @click="editActivities(item)"
                  v-b-tooltip.hover="'Edit'"
                >
                  <span class="fe fe-edit"></span>
                </button>
                <button
                  v-if="
                    (selectedRowExperiential.status == 'submitted' ||
                      selectedRowExperiential.status == 'draft' ||
                      selectedRowExperiential.status == 'revision') &&
                    selectedRowExperiential.project.created_by == nikByLogin
                  "
                  class="btn btn-sm btn-danger mx-1 my-1"
                  @click="deleteActivities(item)"
                  v-b-tooltip.hover="'Delete'"
                >
                  <span class="fe fe-trash"></span>
                </button>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td class="text-center" colspan="12">No Data Available</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Modal Add Activities -->
      <b-modal v-model="isAddActivities" title="Add Project Milestone" size="lg" hide-footer @hide="clearBodyActivities">
        <div class="form-group">
          <div class="row">
            <div class="col-12 mt-4">
              <label class="form-label">Task</label>
              <input v-model="bodyActivities.task" type="text" class="form-control" placeholder="Task" />
            </div>

            <div class="col-6 mt-4">
              <p class="form-label">Start Date</p>
              <input type="date" class="form-control" placeholder="Pilih Tanggal" v-model="bodyActivities.startDate" />
            </div>
            <div class="col-6 mt-4">
              <p class="form-label">End Date</p>
              <input type="date" class="form-control" placeholder="Pilih Tanggal" v-model="bodyActivities.endDate" />
            </div>
            <div class="col-12 mt-4">
              <label>Percentage</label>
              <input v-model="bodyActivities.percentage" type="number" class="form-control" placeholder="Percentage" />
            </div>
            <div class="col-12 mt-4">
              <label>Assignee</label>

              <v-select
                multiple
                v-model="bodyActivities.assignee"
                :options="selectTeams"
                label="label"
                :reduce="(e) => e.nik"
                placeholder="Assignee"
              />
            </div>
          </div>
          <div class="mt-4">
            <b-button 
              class="float-end" 
              @click="submitActivities" 
              variant="primary"
              :disabled="isSubmittingActivities"
            >
              <template v-if="isSubmittingActivities">
                <b-spinner small></b-spinner>
                Adding...
              </template>
              <template v-else>
                Add
              </template>
            </b-button>
          </div>
        </div>
      </b-modal>
      <!-- Modal Edit Activities -->
      <b-modal v-model="isEditActivities" title="Edit Project Milestone" size="lg" hide-footer @hide="clearBodyActivities">
        <div class="form-group">
          <div class="row">
            <div class="col-12 mt-4">
              <label class="form-label">Task</label>
              <input
                v-model="bodyEditActivities.task"
                type="text"
                class="form-control"
                placeholder="Task"
                :disabled="disableActivitiForm"
              />
            </div>

            <div class="col-6 mt-4">
              <p class="form-label">Start Date</p>
              <input
                type="date"
                class="form-control"
                placeholder="Pilih Tanggal"
                v-model="bodyEditActivities.startDate"
                :disabled="disableActivitiForm"
              />
            </div>
            <div class="col-6 mt-4">
              <p class="form-label">End Date</p>
              <input
                type="date"
                class="form-control"
                placeholder="Pilih Tanggal"
                v-model="bodyEditActivities.endDate"
                :disabled="disableActivitiForm"
              />
            </div>
            <div class="col-12 mt-4">
              <label>Percentage (%)</label>
              <input
                v-model="bodyEditActivities.percentage"
                type="number"
                class="form-control"
                placeholder="Percentage"
                :disabled="disableActivitiForm"
              />
            </div>
            <div class="col-12 mt-4">
              <label>Assignee</label>

              <v-select
                multiple
                v-model="bodyEditActivities.assignee"
                :options="selectTeams"
                label="label"
                :disabled="disableActivitiForm"
                :reduce="(e) => e.nik"
                placeholder="Assignee"
              />
            </div>

            <div v-if="this.projectStatus !== 'draft'" class="col-12 mt-4">
              <!-- <label class="form-label">Status</label>
              <v-select
                v-model="bodyEditActivities.status"
                :options="statusActivities"
                label="name"
                :reduce="(e) => e.id"
                placeholder="Select Status"></v-select> -->
            </div>
            <!-- {{ this.projectStatus }} -->
            <div v-if="this.projectStatus !== 'draft'" class="col-10 mt-4">
              <p class="form-label">Actual Start Date</p>
              <input
                type="date"
                class="form-control"
                placeholder="Pilih Tanggal"
                v-model="bodyEditActivities.actualStartDate"
              />
            </div>
            <div v-if="this.projectStatus !== 'draft'" class="col-2 mt-4">
              <b-button class="mt-4" @click="setActualStartDate" variant="primary" :disabled="isUpdateProject"
                >Start</b-button
              >
            </div>
            <div v-if="this.projectStatus !== 'draft'" class="col-12 mt-4">
              <h4>
                Progress Task
                <b-button
                  v-if="this.progressPercentage != 100 && bodyEditActivities.status == 'in progress'"
                  class="my-2 float-end"
                  @click="showAddProgress"
                  variant="primary"
                  :disabled="isUpdateProject"
                  ><span class="fe fe-plus"></span>Add Progress</b-button
                >
              </h4>

              <table class="table table-sm table-bordered">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Date</th>
                    <th>Progress (%)</th>
                  </tr>
                </thead>
                <tbody v-if="milestone.length != 0">
                  <tr v-for="(item, index) in milestone" :key="index">
                    <td>{{ item.name }}</td>
                    <td>{{ formatDateTable(item.date) }}</td>
                    <td>{{ item.progress }}</td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td class="text-center" colspan="12">No Data Available</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-if="this.projectStatus !== 'draft' && bodyEditActivities.status != 'to do'" class="col-12 mt-4">
              <label class="form-label">Progress</label>
              <input
                type="range"
                min="0"
                max="100"
                step="1"
                v-model="progressPercentage"
                class="form-control-range mt-2"
                @mousedown.prevent
                @touchstart.prevent
              />
              <p class="mt-2">{{ progressPercentage }}%</p>
            </div>

            <!-- <div v-if="progressPercentage == 100" class="col-10 mt-4">
              <p class="form-label">Actual End Date</p>
              <input
                type="date"
                class="form-control"
                placeholder="Pilih Tanggal"
                v-model="bodyEditActivities.actualEndDate" />
            </div>
            <div v-if="progressPercentage == 100" class="col-2 mt-4">
              <b-button class="mt-4" @click="setActualEndDate" variant="primary"
                >Finish</b-button
              >
            </div> -->
            <div v-if="progressPercentage == 100" class="col-12 mt-4">
              <label class="form-label">Attachment</label>
              <input type="file" @change="handleFileChange" class="form-control" accept=".jpg,.jpeg,.png" />
            </div>
          </div>
          <div class="mt-4">
            <b-button 
              class="float-end" 
              @click="submitEditActivities" 
              variant="primary" 
              :disabled="isUpdateProject || isSubmittingEditActivities"
            >
              <template v-if="isSubmittingEditActivities">
                <b-spinner small></b-spinner>
                Updating...
              </template>
              <template v-else>
                Update
              </template>
            </b-button>
          </div>
        </div>
      </b-modal>
      <!-- <div class="mt-4 float-end">
        <b-button
          class="mr-3"
          @click="isAddActivities = false"
          variant="secondary"
          >Cancel</b-button
        >
        <b-button @click="submitEnroll" variant="primary"
          ><span class="fe fe-save mr-1"></span>Submit</b-button
        >
      </div> -->
    </b-modal>
    <!-- Modal Upload Certificate -->
    <b-modal v-model="isUploadCertificate" title="Upload Certificate" size="lg" hide-footer>
      <div class="form-group">
        <div class="row">
          <div class="col-12">
            <label class="form-label">Training Title</label>
            <input
              v-model="bodyUploadCertificate.trainingTitle"
              type="text"
              class="form-control"
              placeholder="Training Title"
            />
          </div>
          <div class="col-12 mt-4">
            <label class="form-label">Upload Certificate</label>
            <input type="file" @change="handleFileChange" class="form-control" accept=".jpg,.jpeg,.png" />
          </div>
        </div>
      </div>
      <b-button 
        class="float-end" 
        variant="primary" 
        @click="submitCertificate()"
        :disabled="isSubmittingCertificate"
      >
        <template v-if="isSubmittingCertificate">
          <b-spinner small></b-spinner>
          Mengirim...
        </template>
        <template v-else>
          Submit
        </template>
      </b-button>
    </b-modal>
    <!-- Modal Create Summary -->
    <b-modal v-model="isCreateSummary" title="Submit Summary" size="lg" hide-footer>
      <div class="form-group">
        <div class="row">
          <div class="col-12 mt-4">
            <label class="form-label">Summary <span class="text-danger">*</span></label>
            <textarea v-model="bodySummary.summary" type="text" class="form-control" placeholder="Summary" />
          </div>

          <div class="col-12 mt-4">
            <p class="form-label">Follow up <span class="text-danger">*</span></p>
            <textarea type="text" class="form-control" placeholder="Follow up" v-model="bodySummary.follow_up" />
          </div>
          <div class="col-12 mt-4">
            <p class="form-label">Feedback<span class="text-danger ml-2">*Read only</span></p>
            <textarea disabled type="text" class="form-control" placeholder="Feedback" v-model="bodySummary.feedback" />
          </div>
          <div class="col-12 mt-4">
            <label class="form-label">Attachment</label>
            <input type="file" @change="handleFileChange" class="form-control" accept=".jpg,.jpeg,.png" />
          </div>
        </div>
        <div class="mt-4">
          <b-button 
            class="float-end" 
            @click="submitSummary" 
            variant="primary"
            :disabled="isSubmittingSummary"
          >
            <template v-if="isSubmittingSummary">
              <b-spinner small></b-spinner>
              Adding...
            </template>
            <template v-else>
              Add
            </template>
          </b-button>
        </div>
      </div>
    </b-modal>
    <!-- Modal Complete Summary -->
    <b-modal v-model="isCompleteSummary" title="View Summary" size="lg" hide-footer>
      <div class="form-group">
        <div class="row">
          <div class="col-12 mt-4">
            <label class="form-label">Summary</label>
            <textarea readonly v-model="bodySummary.summary" type="text" class="form-control" placeholder="Summary" />
          </div>

          <div class="col-12 mt-4">
            <p class="form-label">Follow up</p>
            <textarea readonly type="text" class="form-control" placeholder="Follow up" v-model="bodySummary.follow_up" />
          </div>
          <div class="col-12 mt-4">
            <p class="form-label">Feedback</p>
            <textarea readonly type="text" class="form-control" placeholder="Feedback" v-model="bodySummary.feedback" />
          </div>
          <!-- <div class="col-12 mt-4">
            <label class="form-label">Attachment</label>
            <input
              type="file"
              @change="handleFileChange"
              class="form-control"
              accept=".jpg,.jpeg,.png" />
          </div> -->
        </div>
        <!-- <div class="mt-4">
          <b-button class="float-end" @click="submitSummary" variant="primary"
            >Add</b-button
          >
        </div> -->
      </div>
    </b-modal>
    <!-- Modal Add Progress -->
    <b-modal v-model="isAddProgress" title="Add Progress" size="lg" hide-footer>
      <div class="form-group">
        <div class="row">
          <div class="col-12 mt-4">
            <label>Name</label>
            <input v-model="bodyProgress.name" type="text" class="form-control" placeholder="Name" />
          </div>
          <div class="col-12 mt-4">
            <label>Date</label>
            <input v-model="bodyProgress.date" type="date" class="form-control" placeholder="Date" />
          </div>
          <div class="col-12 mt-4">
            <label>Progress</label>
            <input v-model="bodyProgress.progress" type="number" class="form-control" placeholder="Progress" />
          </div>
        </div>
      </div>
      <b-button 
        class="float-end" 
        variant="primary" 
        @click="submitProgress()"
        :disabled="isSubmittingProgress"
      >
        <template v-if="isSubmittingProgress">
          <b-spinner small></b-spinner>
          Mengirim...
        </template>
        <template v-else>
          Submit
        </template>
      </b-button>
    </b-modal>
    <!-- Modal Upload Presentation -->
    <b-modal v-model="isUploadPresentation" title="Upload Coaching/Mentoring Evidence" size="lg" hide-footer>
      <div class="form-group">
        <div class="row">
          <!-- <div class="col-12">
            <label class="form-label">Training Title</label>
            <input
              v-model="bodyUploadCertificate.trainingTitle"
              type="text"
              class="form-control"
              placeholder="Training Title" />
          </div> -->
          <div class="col-12 mt-4">
            <label class="form-label">Upload Coaching/Mentoring Evidence</label>
            <input type="file" @change="handleFileChange" class="form-control" accept=".pdf,.doc,.docx,.jpg,.jpeg,.png" />
          </div>
        </div>
      </div>
      <b-button 
        class="float-end" 
        variant="primary" 
        @click="submitPresentation()"
        :disabled="isSubmittingPresentation"
      >
        <template v-if="isSubmittingPresentation">
          <b-spinner small></b-spinner>
          Mengirim...
        </template>
        <template v-else>
          Submit
        </template>
      </b-button>
    </b-modal>
    <!-- Modal Detail Structured -->
    <b-modal class="modal-xl" v-model="isModalStructured" title="Detail View" size="xl" @hide="clearSelectedRow">
      <b-card>
        <b-card-body>
          <b-row>
            <!-- <b-col md="3">
              <b-card-title>Competency</b-card-title>
              <b-card-text v-if="selectedRowStructured">{{
                selectedRowStructured.competency
              }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col> -->
            <b-col md="3">
              <b-card-title>Training Title</b-card-title>
              <b-card-text v-if="selectedRowStructured">{{ selectedRowStructured.training_title }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="3">
              <b-card-title>Training Type</b-card-title>
              <b-card-text v-if="selectedRowStructured">{{ selectedRowStructured.training_type }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="3">
              <b-card-title>Training Method</b-card-title>
              <b-card-text v-if="selectedRowStructured">{{ selectedRowStructured.training_method }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="3" class="">
              <b-card-title>Status</b-card-title>
              <b-card-text v-if="selectedRowStructured">
                <h2>
                  <span :class="getBadgeStatus(selectedRowStructured.status)">
                    <i :class="getIconClass(selectedRowStructured.status)" class="me-1"></i>
                    {{ capitalizeStatus(selectedRowStructured.status) }}</span
                  >
                </h2>
              </b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="3" class="mt-4">
              <b-card-title>Proposed By</b-card-title>
              <b-card-text v-if="selectedRowStructured">{{ selectedRowStructured.proposed_by }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <!-- <b-col md="3" class="mt-4">
              <b-card-title>Score</b-card-title>
              <b-card-text v-if="selectedRowStructured">{{
                selectedRowStructured.score || "-"
              }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col> -->
            <b-col md="3" class="mt-4">
              <b-card-title>Training Provider</b-card-title>
              <b-card-text v-if="selectedRowStructured">{{ selectedRowStructured.training_provider }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="3" class="mt-4">
              <b-card-title>Price</b-card-title>
              <b-card-text v-if="selectedRowStructured">{{ formatPrice(selectedRowStructured.price) }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
          </b-row>
          <!-- <b-row>
            <b-col md="3" class="">
              <b-card-title>Status</b-card-title>
              <b-card-text v-if="selectedRowStructured">
                <h2>
                  <span
                    :class="
                      getBadgeStatus(selectedRowStructured.status)
                    ">
                    {{ capitalizeStatus(selectedRowStructured.status) }}</span
                  >
                </h2>
              </b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
          </b-row> -->
          <b-row md="4" class="mt-4" v-if="selectedRowStructured">
            <b-col v-if="selectedRowStructured.certificate">
              <b-card-title>Certificate</b-card-title>
              <img :src="certificateUrl" alt="Certificate" class="img-fluid" />
              <!-- <b-button
                class="btn btn-primary"
                variant="primary"
                @click="downloadCertificate()">
                <span class="fe fe-download"></span>
                Download Certificate
              </b-button> -->
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </b-modal>
    <!-- Modal Enroll Structured -->
    <b-modal v-model="isModalEnrollStructured" title="Detail View" size="xl" @hide="clearSelectedRow">
      <b-card>
        <b-card-body>
          <b-row>
            <!-- <b-col md="3">
              <b-card-title>Competency</b-card-title>
              <b-card-text v-if="selectedRowStructured">{{
                selectedRowStructured.competency
              }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col> -->
            <b-col md="3">
              <b-card-title>Training Title</b-card-title>
              <b-card-text v-if="selectedRowStructured">{{ selectedRowStructured.training_title }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="3">
              <b-card-title>Training Type</b-card-title>
              <b-card-text v-if="selectedRowStructured">{{ selectedRowStructured.training_type }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="3">
              <b-card-title>Training Method</b-card-title>
              <b-card-text v-if="selectedRowStructured">{{ selectedRowStructured.training_method }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="3" class="">
              <b-card-title>Status</b-card-title>
              <b-card-text v-if="selectedRowStructured">
                <h2>
                  <span :class="getBadgeStatus(selectedRowStructured.status)">
                    <i :class="getIconClass(selectedRowStructured.status)" class="me-1"></i>
                    {{ capitalizeStatus(selectedRowStructured.status) }}</span
                  >
                </h2>
              </b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
          </b-row>
          <b-row>
            <!-- <b-col md="3" class="mt-4">
              <b-card-title>Score</b-card-title>
              <b-card-text v-if="selectedRowStructured">{{
                selectedRowStructured.score || "-"
              }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col> -->
            <b-col md="3" class="mt-4">
              <b-card-title>Feedback</b-card-title>
              <b-card-text v-if="selectedRowStructured">{{ selectedRowStructured.feedback || "-" }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="3" class="mt-4">
              <b-card-title>Training Provider</b-card-title>
              <b-card-text v-if="selectedRowStructured">{{ selectedRowStructured.training_provider }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="3" class="mt-4">
              <b-card-title>Platform</b-card-title>
              <b-card-text v-if="selectedRowStructured">{{ selectedRowStructured.training_platform }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="3" class="mt-4">
              <b-card-title>Proposed By</b-card-title>
              <b-card-text v-if="selectedRowStructured">{{ selectedRowStructured.proposed_by }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="3" class="mt-4">
              <b-card-title>Price</b-card-title>
              <b-card-text v-if="selectedRowStructured">
                {{ selectedRowStructured.training_currency }}
                {{ formatterNumber(selectedRowStructured.training_price) }}
              </b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="3" class="mt-4" v-if="selectedRowStructured && selectedRowStructured?.proposed_time !== null">
              <b-card-title>Propossed Time</b-card-title>
              <b-card-text v-if="selectedRowStructured">
                {{ selectedRowStructured?.proposed_time }}
              </b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="6" class="mt-4">
              <b-card-title>Description</b-card-title>
              <textarea
                class="form-control form-control-flush form-control-auto"
                data-autosize
                rows="6"
                v-if="selectedRowStructured && selectedRowStructured.training_description != ''"
              >
                {{ selectedRowStructured.training_description || "-" }}
              </textarea>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="3" class="mt-4">
              <b-card-title>Proficiency</b-card-title>
              <!-- {{ selectedRowStructured?.com }} -->
              <b-card-text v-if="selectedRowStructured?.com">
                <b-row v-for="com in selectedRowStructured.com" class="mb-3">
                  <span class="me-2">{{ com.competency }}</span>
                  <div class="button-container">
                    <div
                      v-for="num in 5"
                      :key="num"
                      class="button"
                      :class="{
                        active: selectedRowStructured?.proficiency === num,
                      }"
                    >
                      {{ num }}
                    </div>
                  </div>
                </b-row>
              </b-card-text>
              <!-- <div class="button-container">
                <div
                  v-for="num in 5"
                  :key="num"
                  class="button"
                  :class="{
                    active: selectedRowStructured?.proficiency === num
                  }">
                  {{ num }}
                </div>
              </div> -->
            </b-col>
            <b-col
              md="3"
              class="mt-4"
              v-if="selectedRowStructured && selectedRowStructured.training_platform == 'My Learning'"
            >
              <b-card-title>Website</b-card-title>
              <a
                :href="selectedRowStructured.training_url"
                target="_blank"
                v-if="selectedRowStructured && selectedRowStructured.training_url != ''"
              >
                <b-button class="float-start my-2" variant="primary"
                  ><span class="fe fe-link"></span> Link to website
                </b-button>
              </a>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
          </b-row>
          <b-row md="4" class="mt-4" v-if="selectedRowStructured">
            <b-col v-if="selectedRowStructured.certificate">
              <b-card-title>Certificate</b-card-title>
              <img :src="certificateUrl" :style="{ width: '300px', height: 'auto' }" alt="Certificate" class="img-fluid" />
              <!-- <b-button
                class="btn btn-primary"
                variant="primary"
                @click="downloadCertificate()">
                <span class="fe fe-download"></span>
                Download Certificate
              </b-button> -->
            </b-col>
          </b-row>
        </b-card-body>
        <div v-if="selectedRowStructured && selectedRowStructured.training_platform == 'Other'" class="table-responsive">
          <div>
            <div class="row">
              <div class="col">
                <h3 class="mt-5">Batch List</h3>
              </div>
              <div class="col" v-if="selectedRowStructured">
                <b-button
                  v-if="eventList.length < 1 && selectedRowStructured.status !== 'proposed'"
                  class="float-end my-2"
                  @click="showModalProposed(selectedRowStructured.id)"
                  variant="primary"
                  ><span class="fe fe-plus"></span>Add Proposed</b-button
                >
              </div>
            </div>

            <table class="table table-sm table-bordered table-nowrap mt-4">
              <thead>
                <tr class="">
                  <th rowspan="2">Batch</th>
                  <th rowspan="2">Penyelenggara</th>
                  <th rowspan="2">Quota</th>
                  <!-- <th rowspan="2">Remaining Quota</th> -->
                  <th rowspan="2">Enrolled Participants</th>
                  <th colspan="3" class="text-center">Schedule</th>
                  <th rowspan="2">Assignee</th>
                  <th rowspan="2">Status</th>
                  <th class="text-center" rowspan="2">Action</th>
                </tr>
                <tr>
                  <th>Date</th>
                  <th>Start Time</th>
                  <th>End Time</th>
                </tr>
              </thead>
              <tbody v-if="eventList.length > 0">
                <tr v-for="(item, index) in eventList" :key="index">
                  <td class="">
                    {{ item.batch }}
                  </td>
                  <td>{{ item.penyelenggara || '-' }}</td>
                  <td class="">
                    {{ item.quota }}
                  </td>
                  <!-- <td class="">
                    {{ item.remaining_quota }}
                  </td> -->
                  <td class="">
                    {{ item.used_quota }}
                  </td>

                  <td>
                    <ul class="list-unstyled mb-0">
                      <li v-for="(schedule, sIndex) in item.schedule" :key="sIndex">
                        {{ formatDateTable(schedule.date) }}
                      </li>
                    </ul>
                    <!-- <div>{{ formatDateTable(schedule.date) }}</div> -->
                  </td>
                  <td>
                    <ul class="list-unstyled mb-0">
                      <li v-for="(schedule, sIndex) in item.schedule" :key="sIndex">
                        {{ formatTime(schedule.start_time) }}
                      </li>
                    </ul>
                    <!-- <div>{{ formatTime(schedule.start_time) }}</div> -->
                  </td>
                  <td>
                    <ul class="list-unstyled mb-0">
                      <li v-for="(schedule, sIndex) in item.schedule" :key="sIndex">
                        {{ formatTime(schedule.end_time) }}
                      </li>
                    </ul>
                    <!-- <div>{{ formatTime(schedule.end_time) }}</div> -->
                  </td>
                  <td>
                    <ul class="list-unstyled mb-0">
                      <li v-for="(assignee, aIndex) in item.participants" :key="aIndex">
                        {{ assignee.employee_name }}
                      </li>
                    </ul>
                    <!-- <div>{{ formatTime(schedule.end_time) }}</div> -->
                  </td>
                  <td class="text-center">
                    <h2>
                      <span :class="getBadgeStatus(item.status)">
                        <i :class="getIconClass(item.status)" class="me-1"></i>
                        {{ capitalizeStatus(item.status) }}
                      </span>
                    </h2>
                  </td>
                  <td class="text-center">
                    <!-- Check if no event is enrolled -->
                    <template v-if="!anyEventEnrolled && item.is_enrolled === false">
                      <button
                        class="btn btn-sm btn-danger mx-1 my-1"
                        @click="enrollTrainingEvent(item)"
                        :disabled="selectedRowStructured.status == 'rejected' ? true : false || isEnrollingTraining"
                      >
                        <template v-if="isEnrollingTraining">
                          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                          Enrolling...
                        </template>
                        <template v-else>
                          <span class="fe fe-rotate-ccw"></span> Enroll
                        </template>
                      </button>
                    </template>
                    <!-- Display message if already enrolled -->
                    <template v-else-if="item.is_enrolled === true">
                      <p>You Already Enrolled to this batch</p>
                    </template>
                    <!-- Show Edit button if status is not active -->
                    <template v-if="item.status != 'active'">
                      <button class="btn btn-sm btn-warning mx-1 my-1" @click="showEditEvent(item)">
                        <span class="fe fe-edit"></span> Edit
                      </button>
                    </template>
                  </td>

                  <!-- <td class="">
                    {{ item.score }}
                  </td>
                  <td class="">
                    {{ item.certificate }}
                  </td> -->
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td class="text-center" colspan="12">No Data Available</td>
                </tr>
              </tbody>
            </table>
            <!-- <div class="float-end mt-4">
              <b-button @click="showCreateEvent()" variant="primary">
                <span class="fe fe-plus"></span>
                Create Event
              </b-button>
            </div> -->
          </div>
        </div>
      </b-card>
    </b-modal>
    <!-- Modal Detail Social -->
    <b-modal v-model="isModalSocial" title="Detail View" size="xl" @hide="clearSelectedRow">
      <b-card>
        <b-card-body>
          <b-row>
            <b-col md="3">
              <b-card-title>Coaching/Mentoring Title</b-card-title>
              <b-card-text v-if="selectedRowSocial">{{ selectedRowSocial.coaching_title }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="3">
              <b-card-title>Category</b-card-title>
              <b-card-text v-if="selectedRowSocial">{{ selectedRowSocial.coaching_type }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="3">
              <b-card-title>Methodology</b-card-title>
              <b-card-text v-if="selectedRowSocial">{{ selectedRowSocial.coaching_methodology }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
            <b-col md="3">
              <b-card-title>Coach/Mentor Name</b-card-title>
              <b-card-text v-if="selectedRowSocial">{{ selectedRowSocial.coach_name }}</b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
          </b-row>

          <b-row class="mt-4">
            <b-col md="3" class="">
              <b-card-title>Status</b-card-title>
              <b-card-text v-if="selectedRowSocial">
                <h2>
                  <span :class="getBadgeStatus(selectedRowSocial.status)">
                    <i :class="getIconClass(selectedRowSocial.status)" class="me-1"></i>
                    {{ capitalizeStatus(selectedRowSocial.status) }}</span
                  >
                </h2>
              </b-card-text>
              <b-card-text v-else>No data available</b-card-text>
            </b-col>
          </b-row>

          <div class="mt-4">
            <div class="row">
              <div class="col">
                <h4>Schedule</h4>
              </div>
              <div class="col" v-if="selectedRowSocial">
                <b-button
                  v-if="selectedRowSocial.status == 'approved'"
                  class="float-end my-2"
                  @click="showScheduleModal"
                  variant="primary"
                  ><span class="fe fe-plus"></span>Add Schedule</b-button
                >
              </div>
            </div>
            <table class="table table-sm table-bordered">
              <thead>
                <tr>
                  <th style="width: 110px">Date</th>
                  <th style="width: 50px">Start Time</th>
                  <th style="width: 50px">End Time</th>
                  <th>Summary</th>
                  <th>Feedback</th>
                  <th>Status</th>
                  <!-- <th>Follow Up</th> -->
                  <th style="width: 50px">Attachments</th>
                  <!-- <th>Feedback</th> -->
                  <th style="width: 50px">Action</th>
                </tr>
              </thead>
              <tbody>
                <template v-if="scheduleSocial.length === 0">
                  <tr>
                    <td class="text-center" colspan="7">No Data Available</td>
                  </tr>
                </template>
                <template v-else>
                  <tr v-for="(item, index) in scheduleSocial" :key="index">
                    <td>{{ formatDateTable(item.date) }}</td>
                    <td>{{ formatTime(item.start_time) }}</td>
                    <td>{{ formatTime(item.end_time) }}</td>

                    <!-- Summaries -->
                    <td>
                      <ul>
                        <li v-for="(feedback, feedbackIndex) in item.feedback" :key="'summary-' + feedbackIndex">
                          {{ feedback.summary }}
                        </li>
                        <template v-if="item.feedback.length === 0">
                          <li>No summaries available</li>
                        </template>
                      </ul>
                    </td>
                    <td>
                      <ul>
                        <li v-for="(feedback, feedbackIndex) in item.feedback" :key="'summary-' + feedbackIndex">
                          {{ feedback.feedback }}
                        </li>
                        <template v-if="item.feedback.length === 0">
                          <li>No summaries available</li>
                        </template>
                      </ul>
                    </td>
                    <td>
                      <span :class="getBadgeStatus(item.status)">
                        <i :class="getIconClass(item.status)" class="me-1"></i>
                        {{ capitalizeStatus(item.status) }}</span
                      >
                    </td>

                    <!-- Follow Ups -->
                    <!-- <td>
                      <ul>
                        <li
                          v-for="(feedback, feedbackIndex) in item.feedback"
                          :key="'followup-' + feedbackIndex">
                          {{ feedback.follow_up }}
                        </li>
                        <template v-if="item.feedback.length === 0">
                          <li>No follow-ups available</li>
                        </template>
                      </ul>
                    </td> -->

                    <!-- Attachments -->
                    <td>
                      <ul>
                        <li v-for="(feedback, feedbackIndex) in item.feedback" :key="'attachment-' + feedbackIndex">
                          <a
                            v-for="(attachment, attachmentIndex) in feedback.attachments"
                            :key="'attachment-file-' + attachmentIndex"
                            :href="attachment.url"
                            target="_blank"
                          >
                            Files
                          </a>
                        </li>
                        <template v-if="item.feedback.length === 0">
                          <li>No attachments available</li>
                        </template>
                      </ul>
                    </td>
                    <!-- <td>
                      <ul>
                        <li
                          v-for="(feedback, feedbackIndex) in item.feedback"
                          :key="'followup-' + feedbackIndex">
                          {{ feedback.feedback }}
                        </li>
                        <template v-if="item.feedback.length === 0">
                          <li>No Feedback available</li>
                        </template>
                      </ul>
                    </td> -->

                    <!-- Action Button -->
                    <td>
                      <button
                        v-if="projectStatus != 'completed'"
                        class="btn btn-sm btn-warning mx-2"
                        @click="showModalSummary(item)"
                        v-b-tooltip.hover="'Input Coaching Result'"
                      >
                        <span class="fe fe-edit"></span>
                      </button>
                      <button
                        v-if="projectStatus == 'completed'"
                        class="btn btn-sm btn-info mx-2"
                        @click="showCompleteSummary(item)"
                        v-b-tooltip.hover="'View Coaching Result'"
                      >
                        <span class="fe fe-eye"></span>
                      </button>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </b-card-body>
      </b-card>
    </b-modal>

    <!-- Modal Proposed -->
    <b-modal v-model="isModalProposed" title="Add Proposed" size="small" hide-footer @hide="clearScheduleModal">
      <form @submit.prevent="saveAddProposed()">
        <div class="form-group">
          <p class="form-label">Date</p>
          <v-date-picker
            style="width: 350px"
            v-model="bodyAddProposed.date"
            type="date"
            format="DD-MM-YYYY"
            placeholder="Select Date"
          />
        </div>
        <div class="mt-4">
          <button
            style="margin-left: auto; float: right"
            class="mt-4 btn btn-primary"
            type="submit"
            v-if="isLoading == false"
          >
            Save
          </button>
          <button style="margin-left: auto; float: right" class="mt-4 btn btn-primary" type="button" disabled v-else>
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            Loading...
          </button>
        </div>
      </form>
    </b-modal>

    <!-- Modal Schedule -->
    <b-modal v-model="isScheduleModalVisible" title="Add Schedule" size="xl" hide-footer @hide="clearScheduleModal">
      <div class="form-group">
        <div class="row">
          <div class="col-4">
            <p class="form-label">Date</p>
            <v-date-picker v-model="schedule.date" type="date" format="DD-MM-YYYY" placeholder="Select Date" />
          </div>
          <div class="col-4" v-if="schedule.date">
            <p class="form-label">Start Time</p>
            <v-date-picker v-model="schedule.startTime" type="time" format="HH:mm" placeholder="Select Start Time" />
          </div>
          <div class="col-4" v-if="schedule.date">
            <p class="form-label">End Time</p>
            <v-date-picker v-model="schedule.endTime" type="time" format="HH:mm" placeholder="Select End Time" />
          </div>
        </div>
        <div class="mt-4">
          <b-button 
            class="float-end my-3" 
            @click="addSchedule" 
            variant="primary"
            :disabled="isAddingSchedule"
          >
            <template v-if="isAddingSchedule">
              <b-spinner small></b-spinner>
              Adding...
            </template>
            <template v-else>
              Add
            </template>
          </b-button>
        </div>
        <h4>The schedule will be added:</h4>
        <table class="table table-sm table-bordered">
          <thead>
            <tr>
              <th>Date</th>
              <th>Start Time</th>
              <th>End Time</th>
              <th style="width: 50px">Action</th>
            </tr>
          </thead>
          <tbody>
            <template v-if="scheduleList.length === 0">
              <tr>
                <td class="text-center" colspan="4">No Data Available</td>
              </tr>
            </template>
            <template v-else>
              <tr v-for="(item, index) in scheduleList" :key="index">
                <td>{{ item.date }}</td>
                <td>{{ item.startTime }}</td>
                <td>{{ item.endTime }}</td>
                <td>
                  <button @click="removeSchedule(index)" class="btn btn-sm btn-danger">
                    <span class="fe fe-trash"></span>
                  </button>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
        <div class="mt-4">
          <b-button 
            class="float-end" 
            @click="saveSchedule" 
            variant="primary" 
            :disabled="isSavingSchedule"
          >
            <template v-if="isSavingSchedule">
              <b-spinner small></b-spinner>
              Saving...
            </template>
            <template v-else>
              <span class="fe fe-save"></span>Save
            </template>
          </b-button>
        </div>
      </div>
    </b-modal>
    <!-- Modal Add Training -->
    <b-modal v-model="isAddTraining" title="Buat Pelatihan Aspiration" hide-footer size="xl" centered>
      <div class="form-group">
        <div class="row">
          <div class="col-6">
            <label class="form-label"
              >Competency
              <span class="text-danger">(* Proficiency level is below standard)</span>
            </label>
            <v-select
              v-model="bodyAdd.competency"
              :options="dataCompetency"
              label="competency"
              :reduce="(e) => e.competency_id"
              placeholder="Select Competency"
              multiple
            />
          </div>
        </div>
        <hr />
        <div class="row">
          <!-- Bagian 1 -->
          <div class="col-6">
            <label class="form-label">Provider</label>
            <v-select
              v-model="bodyAdd.provider"
              :options="dataProvider"
              label="name"
              @input="selectProvider"
              :reduce="(e) => e.id"
              placeholder="Select Provider"
            />
          </div>
          <div class="col-6">
            <label class="form-label">Provider Name</label>
            <input
              id="provid"
              v-model="bodyAdd.providerName"
              type="text"
              class="form-control"
              placeholder="Provider Name"
              :disabled="bodyDisAdd.providerName"
              ref="providerNameRef"
            />
          </div>
          <div class="col-6 mt-3">
            <label class="form-label">Address</label>
            <input
              id="address"
              type="text"
              v-model="bodyAdd.address"
              class="form-control"
              placeholder="Address"
              :disabled="bodyDisAdd.address"
            />
          </div>
          <div class="col-6 mt-3">
            <label class="form-label">Website</label>
            <input
              type="text"
              v-model="bodyAdd.websiteProvider"
              class="form-control"
              placeholder="Website"
              :disabled="bodyDisAdd.websiteProvider"
            />
          </div>
          <div class="col-6 mt-3">
            <label class="form-label">Contact Person</label>
            <input
              type="text"
              v-model="bodyAdd.contactPerson"
              class="form-control"
              placeholder="Contact Person"
              :disabled="bodyDisAdd.contactPerson"
            />
          </div>
          <div class="col-6 mt-3">
            <label class="form-label">Email</label>
            <input
              type="text"
              v-model="bodyAdd.email"
              class="form-control"
              placeholder="Email"
              :disabled="bodyDisAdd.email"
            />
          </div>
          <div class="col-6 mt-3">
            <label class="form-label">Phone</label>
            <input
              type="number"
              class="form-control"
              v-model="bodyAdd.phone"
              placeholder="Phone"
              :disabled="bodyDisAdd.phone"
            />
          </div>
          <!-- <div class="col-12 mt-4">
            <label class="form-label">Schedule</label>
          </div>
          <div class="col-6">
            <p class="form-label">Start Date</p>
            <v-date-picker style="width: 530px" />
          </div>
          <div class="col-6">
            <p class="form-label">End Date</p>
            <v-date-picker style="width: 530px" />
          </div> -->
        </div>
        <div class="mt-3">
          <hr />
        </div>
        <div class="row">
          <!-- Bagian 2 -->
          <div class="col-6 mt-2">
            <label for=""
              >Training
              <span class="text-danger">(* Search Training If Exist)</span>
            </label>
            <v-select
              v-model="selectedLearning"
              :options="dataTraining"
              label="title"
              @input="selectTraining"
              placeholder="Search Training"
            >
              <!-- <span slot="no-options">Search Learning Title</span> -->
            </v-select>
          </div>
          <div class="col-6 mt-2">
            <label class="form-label">Training Name</label>
            <input type="text" class="form-control" v-model="bodyAdd.trainingName" placeholder="Training Name" />
          </div>
          <div class="col-6 mt-4">
            <label class="form-label">Training Method</label>
            <v-select
              v-model="bodyAdd.learningMethod"
              :options="dataTrainingMethod"
              label="name"
              :reduce="(e) => e.id"
              placeholder="Select Training Method"
            />
          </div>
          <div class="col-6 mt-4">
            <label class="form-label">Training Type</label>
            <v-select
              v-model="bodyAdd.learningType"
              :options="dataTrainingType"
              label="name"
              :reduce="(e) => e.id"
              placeholder="Select Training Type"
            />
          </div>
          <div class="col-6 mt-3">
            <label class="form-label">Price</label>
            <div class="d-flex">
              <v-select style="width: 140px; color: gray" :options="currencies" v-model="bodyAdd.currency" class="mr-2" />
              <input v-model="bodyAdd.price" type="number" class="form-control" placeholder="Input Price (Numeric)" />
            </div>
          </div>
          <div class="col-6 mt-3">
            <label class="form-label">Website</label>
            <input type="text" class="form-control" v-model="bodyAdd.websiteTraining" placeholder="Website" />
          </div>
          <div class="col-6 mt-3">
            <label class="form-label">Hours</label>
            <input v-model="bodyAdd.hours" type="number" class="form-control" placeholder="Input Hours" />
          </div>
          <div class="col-6 mt-3">
            <label class="form-label">Description</label>
            <textarea v-model="bodyAdd.description" type="text" class="form-control" placeholder="Input Description" />
          </div>
        </div>
        <div class="mt-3">
          <hr />
        </div>
        <div class="mt-2">
          <label class="form-label">
            Explain the competencies of current employees or prospective participants<br />
            Jelaskan kompetensi karyawan atau calon peserta saat ini:
          </label>
          <textarea type="text" class="form-control" v-model="bodyAdd.background_1" placeholder="" />
        </div>
        <div class="mt-2">
          <label class="form-label">
            Explain the expected competencies by attending this training<br />
            Jelaskan kompetensi yang diharapkan dengan mengikuti pelatihan ini:
          </label>
          <textarea type="text" class="form-control" v-model="bodyAdd.background_2" placeholder="" />
        </div>
        <div class="mt-2">
          <label class="form-label">
            Describe the action plan for improving employee performance that will be carried out after attending this
            training<br />
            Uraikan rencana kegiatan untuk peningkatan kinerja karyawan yang akan dilakukan setelah mengikuti pelatihan ini:
          </label>
          <textarea type="text" class="form-control" v-model="bodyAdd.background_3" placeholder="" />
        </div>
        <div class="mt-4">
          <label class="form-label">Supporting Document</label>
          <input type="file" @change="handleFileChange" class="form-control" accept=".pdf,.doc,.docx,.jpg,.jpeg,.png" />
        </div>
        <div class="row">
          <div class="col-6 mt-3">
            <p>Start Date</p>
            <v-date-picker
              style="width: 350px"
              v-model="bodyAdd.startDate"
              type="date"
              format="DD-MM-YYYY"
              :disabled-date="disablePastDates"
              placeholder="Select Date"
              v-validate="'required'"
              name="Start Date"
            />
            <span class="text-sm text-danger" v-show="errors.has('Start Date')">{{ errors.first("Start Date") }}</span>
          </div>
          <div class="col-6 mt-3">
            <p>End Date</p>
            <v-date-picker
              style="width: 350px"
              v-model="bodyAdd.endDate"
              type="date"
              format="DD-MM-YYYY"
              :disabled-date="disablePastDates"
              placeholder="Select Date"
              v-validate="'required'"
              name="Start Date"
            />
            <span class="text-sm text-danger" v-show="errors.has('Start Date')">{{ errors.first("Start Date") }}</span>
          </div>
        </div>
      </div>
      <b-button 
        class="float-end" 
        variant="primary" 
        @click="createTraining()"
        :disabled="isCreatingTraining"
      >
        <template v-if="isCreatingTraining">
          <b-spinner small></b-spinner>
          Mengirim...
        </template>
        <template v-else>
          Submit
        </template>
      </b-button>
    </b-modal>
    <!-- Modal Add Coaching -->
    <b-modal v-model="isAddCoaching" title="Add Social Learning" hide-footer size="xl" centered>
      <div class="form-group">
        <div class="row">
          <!-- Bagian 1 -->
          <div class="col-12">
            <label class="form-label"
              >Competency <span class="text-danger">(* Proficiency level is below standard)</span></label
            >
            <v-select
              v-model="bodyAdd.competency"
              :options="dataCompetency"
              label="competency"
              :reduce="(e) => e.competency_id"
              placeholder="Select Competency"
            />
          </div>
          <div class="col-12 mt-3">
            <label class="form-label">Coaching/Mentoring</label>
            <v-select
              v-model="bodyAdd.coaching"
              :options="dataCoaching"
              label="coaching_title"
              :reduce="(e) => e.coaching_id"
              placeholder="Select Coaching/Mentoring"
            />
          </div>
          <!-- <div class="col-6 mt-3">
            <label class="form-label">Provider Name</label>
            <input
              v-model="bodyAdd.providerName"
              type="text"
              class="form-control"
              placeholder="Provider Name" />
          </div>
          <div class="col-6 mt-3">
            <label class="form-label">Address</label>
            <input
              type="text"
              v-model="bodyAdd.address"
              class="form-control"
              placeholder="Address" />
          </div>
          <div class="col-6 mt-3">
            <label class="form-label">Website</label>
            <input
              type="text"
              v-model="bodyAdd.websiteProvider"
              class="form-control"
              placeholder="Website" />
          </div>
          <div class="col-6 mt-3">
            <label class="form-label">Contact Person</label>
            <input
              type="text"
              v-model="bodyAdd.contactPerson"
              class="form-control"
              placeholder="Contact Person" />
          </div>
          <div class="col-6 mt-3">
            <label class="form-label">Email</label>
            <input
              type="text"
              v-model="bodyAdd.email"
              class="form-control"
              placeholder="Email" />
          </div>
          <div class="col-6 mt-3">
            <label class="form-label">Phone</label>
            <input
              type="number"
              class="form-control"
              v-model="bodyAdd.phone"
              placeholder="Phone" />
          </div> -->

          <!-- Bagian 2 -->
          <!-- <div class="col-6 mt-4">
            <label for="">Training</label>
            <v-select
              v-model="selectedLearning"
              :options="dataTraining"
              label="title"
              @input="selectTraining"
              @search="searchTraining"
              placeholder="Search Training">
             
            </v-select>
          </div> -->
          <!-- <div class="col-6 mt-4">
            <label class="form-label">Training Name</label>
            <input
              type="text"
              class="form-control"
              v-model="bodyAdd.trainingName"
              placeholder="Training Name" />
          </div>
          <div class="col-6 mt-4">
            <label class="form-label">Training Method</label>
            <v-select
              v-model="bodyAdd.learningMethod"
              :options="dataTrainingMethod"
              label="name"
              :reduce="(e) => e.id"
              placeholder="Select Training Method" />
          </div>
          <div class="col-6 mt-4">
            <label class="form-label">Training Type</label>
            <v-select
              v-model="bodyAdd.learningType"
              :options="dataTrainingType"
              label="name"
              :reduce="(e) => e.id"
              placeholder="Select Training Type" />
          </div>
          <div class="col-6 mt-3">
            <label class="form-label">Price</label>
            <div class="d-flex">
              <v-select
                style="width: 140px; color: gray"
                :options="currencies"
                v-model="bodyAdd.currency"
                class="mr-2" />
              <input
                v-model="bodyAdd.price"
                type="number"
                class="form-control"
                placeholder="Input Price (Numeric)" />
            </div>
          </div>
          <div class="col-6 mt-3">
            <label class="form-label">Website</label>
            <input
              type="text"
              class="form-control"
              v-model="bodyAdd.websiteTraining"
              placeholder="Website" />
          </div>
          <div class="col-12 mt-3">
            <label class="form-label">Description</label>
            <textarea
              v-model="bodyAdd.description"
              type="text"
              class="form-control"
              placeholder="Input Description" />
          </div> -->
          <!-- <div class="col-12 mt-4">
            <label class="form-label">Schedule</label>
          </div>
          <div class="col-6">
            <p class="form-label">Start Date</p>
            <v-date-picker style="width: 530px" />
          </div>
          <div class="col-6">
            <p class="form-label">End Date</p>
            <v-date-picker style="width: 530px" />
          </div> -->
        </div>
      </div>
      <b-button 
        class="float-end" 
        variant="primary" 
        @click="createCoaching()"
        :disabled="isCreatingCoaching"
      >
        <template v-if="isCreatingCoaching">
          <b-spinner small></b-spinner>
          Mengirim...
        </template>
        <template v-else>
          Submit
        </template>
      </b-button>
    </b-modal>
    <!-- Modal Add Project Experiential Learning -->
    <b-modal v-model="isAddProject" centered hide-footer title="Add Project" size="lg">
      <form @submit.prevent="saveAdd()">
        <div class="form-group">
          <div class="row">
            <div class="col-12 mt-3">
              <label>Related Competency</label>
              <v-select
                multiple
                v-model="bodyAdd.relatedCompetency"
                :options="dataCompetency"
                label="competency"
                :reduce="(e) => e.competency_id"
                placeholder="Select Related Competency"
                v-validate="'required'"
                name="Related Company"
              />
              <span class="text-sm text-danger" v-show="errors.has('Related Company')">{{
                errors.first("Related Company")
              }}</span>
            </div>
            <div class="col-6 mt-3">
              <p>Start Date</p>
              <v-date-picker
                style="width: 350px"
                v-model="bodyAdd.startDate"
                type="date"
                format="DD-MM-YYYY"
                :disabled-date="disablePastDates"
                placeholder="Select Date"
                v-validate="'required'"
                name="Start Date"
              />
              <span class="text-sm text-danger" v-show="errors.has('Start Date')">{{ errors.first("Start Date") }}</span>
            </div>
            <div class="col-6 mt-3">
              <p>End Date</p>
              <v-date-picker
                style="width: 350px"
                v-model="bodyAdd.endDate"
                type="date"
                format="DD-MM-YYYY"
                :disabled-date="disablePastDates"
                placeholder="Select Date"
                v-validate="'required'"
                name="End Date"
              />
              <span class="text-sm text-danger" v-show="errors.has('End Date')">{{ errors.first("End Date") }}</span>
            </div>
            <div class="col-12 mt-3">
              <label>Project Name</label>
              <input
                v-validate="'required'"
                name="Name"
                type="text"
                v-model="bodyAdd.projectName"
                class="form-control"
                placeholder="Project Name"
              />
              <span class="text-sm text-danger" v-show="errors.has('Name')">{{ errors.first("Name") }}</span>
            </div>
            <div class="col-12 mt-3">
              <label>Project Description</label>
              <textarea
                type="text"
                v-model="bodyAdd.projectDescription"
                class="form-control"
                placeholder="Project Description"
                v-validate="'required'"
                name="Description"
              />
              <span class="text-sm text-danger" v-show="errors.has('Description')">{{ errors.first("Description") }}</span>
            </div>

            <div class="col-12 mt-3">
              <label>Bussiness Need</label>
              <textarea
                type="text"
                v-model="bodyAdd.bussinessNeed"
                class="form-control"
                placeholder="Bussiness Need"
                v-validate="'required'"
                name="Bussiness Need"
              />
              <span class="text-sm text-danger" v-show="errors.has('Bussiness Need')">{{
                errors.first("Bussiness Need")
              }}</span>
            </div>
            <div class="col-12 mt-3">
              <label>Objectives</label>
              <textarea
                type="text"
                v-model="bodyAdd.objectives"
                class="form-control"
                placeholder="Objectives"
                v-validate="'required'"
                name="Objectives"
              />
              <span class="text-sm text-danger" v-show="errors.has('Objectives')">{{ errors.first("Objectives") }}</span>
            </div>
            <div class="col-12 mt-3">
              <label>Goals</label>
              <textarea
                type="text"
                v-model="bodyAdd.goals"
                class="form-control"
                placeholder="Goals"
                v-validate="'required'"
                name="Goals"
              />
              <span class="text-sm text-danger" v-show="errors.has('Goals')">{{ errors.first("Goals") }}</span>
            </div>
            <div class="col-12 mt-3">
              <label>Project Scope</label>
              <v-select
                :options="['Accross BU', 'Across Dept./Div. ( Within BU)', 'Within Dept./Div.']"
                v-model="bodyAdd.scope"
                placeholder="Select Project Scope"
                v-validate="'required'"
                name="Project Scope"
              />
              <span class="text-sm text-danger" v-show="errors.has('Project Scope')">{{
                errors.first("Project Scope")
              }}</span>
            </div>
            <div class="col-12 mt-3">
              <label>Constraints</label>
              <textarea
                type="text"
                v-model="bodyAdd.constraints"
                class="form-control"
                placeholder="Constraints"
                v-validate="'required'"
                name="Constraints"
              />
              <span class="text-sm text-danger" v-show="errors.has('Constraints')">{{ errors.first("Constraints") }}</span>
            </div>
            <div class="col-12 mt-3">
              <label>Deliverables</label>
              <textarea
                type="text"
                v-model="bodyAdd.deliverables"
                class="form-control"
                placeholder="Deliverables"
                v-validate="'required'"
                name="Deliverables"
              />
              <span class="text-sm text-danger" v-show="errors.has('Deliverables')">{{ errors.first("Deliverables") }}</span>
            </div>
            <!-- <div class="col-12 mt-3">
              <label>Role</label>
              <v-select
                :options="[
                  'Project Leader',
                  'Project Member/Co. Leader',
                  'Project Sponsor'
                ]"
                v-model="bodyAdd.projectInvolvement"
                placeholder="Select Project Involvement"
                v-validate="'required'"
                name="Project Involvement" />
              <span
                class="text-sm text-danger"
                v-show="errors.has('Project Involvement')"
                >{{ errors.first("Project Involvement") }}</span
              >
            </div> -->
            <div class="row mt-5 mb-5">
              <div class="d-flex justify-content-between">
                <h3 class="mt-2">Project Team</h3>
                <b-button variant="primary" @click="addProjectTeams">
                  <span class="fe fe-file-plus"></span>
                  Add Project Teams
                </b-button>
              </div>
              <template v-for="(item, index) in bodyAdd.teams">
                <div class="col-5 mt-3">
                  <label>Role</label>
                  <v-select
                    :options="['Project Leader', 'Project Member/Co. Leader', 'Project Sponsor']"
                    v-model="item.role"
                    placeholder="Select Role"
                    v-validate="'required'"
                    name="Role"
                  />
                  <span class="text-sm text-danger" v-show="errors.has('Role')">{{ errors.first("Role") }}</span>
                </div>
                <div class="col-5 mt-3">
                  <label>Employee</label>
                  <v-select
                    :options="listKaryawan"
                    label="employee_name"
                    :reduce="(e) => e.employee_nik"
                    v-model="item.nik"
                    placeholder="Select Employee"
                    v-validate="'required'"
                    name="Employee"
                  />
                  <span class="text-sm text-danger" v-show="errors.has('Employee')">{{ errors.first("Employee") }}</span>
                </div>
                <div class="col-2 mb-3" v-if="index != 0">
                  <label></label>
                  <b-button variant="primary" @click="delProjectTeams(index)" class="mt-5">
                    <span class="fe fe-trash"></span>
                  </b-button>
                </div>
              </template>
            </div>
            <!-- <div class="col-12 mt-3">
              <label>Project Team</label>
              <textarea
                type="text"
                v-model="bodyAdd.subordinate"
                class="form-control"
                placeholder="Project Team"
                v-validate="'required'"
                name="Project Team" />
              <span
                class="text-sm text-danger"
                v-show="errors.has('Project Team')"
                >{{ errors.first("Project Team") }}</span
              >
            </div> -->
            <div class="col-12 mt-3">
              <label>Project Impact A</label>
              <v-select
                :options="['Tangible', 'Intangible']"
                v-model="bodyAdd.projectImpactA"
                placeholder="Select Project Impact A"
                v-validate="'required'"
                name="Project Impact A"
              />
              <span class="text-sm text-danger" v-show="errors.has('Project Impact A')">{{
                errors.first("Project Impact A")
              }}</span>
            </div>
            <div class="col-12 mt-3">
              <label>Impact</label>
              <textarea
                type="text"
                v-model="bodyAdd.impact"
                class="form-control"
                placeholder="Impact"
                v-validate="'required'"
                name="Impact"
              />
              <span class="text-sm text-danger" v-show="errors.has('Impact')">{{ errors.first("Impact") }}</span>
            </div>
            <div class="col-12 mt-3">
              <label>Project Impact B</label>
              <v-select
                :options="[
                  'Percentage (actual/target) > 100%',
                  'Percentage (actual/target) = 100%',
                  'Percentage (actual/target) < 100%',
                ]"
                v-model="bodyAdd.projectImpactB"
                placeholder="Select Project Impact B"
                v-validate="'required'"
                name="Project Impact B"
              />
              <span class="text-sm text-danger" v-show="errors.has('Project Impact B')">{{
                errors.first("Project Impact B")
              }}</span>
            </div>

            <!-- <div class="mt-4">
              <b-button @click="showRoleModal" variant="primary"
                ><span class="fe fe-plus"></span>Add Role</b-button
              >
            </div> -->

            <!-- Schedule Table -->
            <!-- <div class="mt-4 col-12">
              <label>Role</label>
              <table class="table table-sm table-bordered">
                <thead>
                  <tr>
                    <th>Employee Name</th>
                    <th>Position</th>
                    <th>Total</th>
                    <th style="width: 50px">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="roleList.length === 0">
                    <td class="text-center" colspan="4">No Data Available</td>
                  </tr>
                  <tr v-else v-for="(item, index) in roleList" :key="index">
                    <td>{{ item.employeeName }}</td>
                    <td>{{ item.position }}</td>
                    <td>{{ item.total }}</td>
                    <td>
                      <button
                        @click="removeRole(index)"
                        class="btn btn-sm btn-danger">
                        <span class="fe fe-trash"></span>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div> -->
            <div class="col-12 mt-3">
              <label>Attachment</label>
              <input
                type="file"
                @change="handleFileChange"
                class="form-control"
                accept=".jpg,.jpeg,.png"
                v-validate="'required'"
                name="Attachment"
              />
              <span class="text-sm text-danger" v-show="errors.has('Attachment')">{{ errors.first("Attachment") }}</span>
            </div>
            <!-- <div class="col-12 mt-3">
              <label>Related Competency</label>
              <v-select
                multiple
                v-model="bodyAdd.relatedCompetency"
                :options="dataCompetency"
                label="competency"
                :reduce="(e) => e.competency_id"
                placeholder="Select Related Competency"
                v-validate="'required'"
                name="Related Company" />
              <span
                class="text-sm text-danger"
                v-show="errors.has('Related Company')"
                >{{ errors.first("Related Company") }}</span
              >
            </div> -->

            <!-- <b-modal
              v-model="isRoleModalVisible"
              title="Add Role"
              size="lg"
              hide-footer
              @hide="clearRoleModal">
              <div class="form-group">
                <div class="row">
                  <div class="col-6">
                    <label class="form-label">Employee Name</label>
                    <v-select
                      v-model="role.employeeName"
                      :options="projectRole"
                      label="name"
                      :reduce="(e) => e.id"
                      placeholder="Select Employee Name" />
                  </div>
                  <div class="col-6">
                    <label class="form-label">Position</label>
                    <v-select
                      v-model="role.position"
                      :options="projectRole"
                      label="name"
                      :reduce="(e) => e.id"
                      placeholder="Select Role" />
                  </div>
                  <div class="col-6 mt-2">
                    <label class="form-label">Total</label>
                    <input
                      v-validate="'required'"
                      name="Total"
                      type="number"
                      v-model="role.total"
                      class="form-control"
                      placeholder="Total" />
                  </div>
                </div>
                <div class="mt-4">
                  <b-button class="float-end" @click="addRole" variant="primary"
                    >Add</b-button
                  >
                </div>
              </div>
            </b-modal> -->
          </div>
        </div>
        <div class="form-group">
          <button
            style="margin-left: auto; float: right"
            class="mt-4 btn btn-primary"
            type="submit"
            v-if="isLoading == false"
          >
            Save
          </button>
          <button style="margin-left: auto; float: right" class="mt-4 btn btn-primary" type="button" disabled v-else>
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            Loading...
          </button>
        </div>
      </form>
    </b-modal>
    <!-- Modal Confirmation  Structured Learning-->
    <b-modal
      centered
      ref="confirmationModalStructured"
      id="confirmation-modal"
      title="Submit Training"
      @ok="confirmSubmissionStructured"
    >
      <div>
        <h5>Will be submitted:</h5>
        <ul v-if="checkSTructuredLearning && checkSTructuredLearning.length > 0">
          <li v-for="item in checkSTructuredLearning" :key="item.id" class="text-success">
            {{ item.training_title }}
          </li>
        </ul>
        <p v-else>No items to be submitted.</p>
        <!-- <ul v-if="approvedItems && approvedItems.length > 0">
          <li v-for="item in approvedItems" :key="item.id" class="text-success">
            {{ item.training_title }}
          </li>
        </ul>
        <p v-else>No items to be submitted.</p> -->

        <!-- <h5>Will be rejected:</h5>
        <ul v-if="rejectedItems && rejectedItems.length > 0">
          <li v-for="item in rejectedItems" :key="item.id" class="text-danger">
            {{ item.training_title }}
          </li>
        </ul>
        <p v-else>No items to be rejected.</p> -->
      </div>
    </b-modal>
    <!-- Confirmation Social Learning -->
    <b-modal
      centered
      ref="confirmationModalSocial"
      id="confirmation-modal"
      title="Submit Coaching/Mentoring"
      @ok="confirmSubmissionSocial"
    >
      <div>
        <h5>Will be submitted:</h5>
        <ul v-if="checkSocialLearning && checkSocialLearning.length > 0">
          <li v-for="item in checkSocialLearning" :key="item.id" class="text-success">
            {{ item.coaching_title }}
          </li>
        </ul>
        <p v-else>No items to be submitted.</p>
        <!-- <ul v-if="approvedItems && approvedItems.length > 0">
          <li v-for="item in approvedItems" :key="item.id" class="text-success">
            {{ item.coaching_title }}
          </li>
        </ul>
        <p v-else>No items to be submitted.</p> -->

        <!-- <h5>Will be rejected:</h5>
        <ul v-if="rejectedItems && rejectedItems.length > 0">
          <li v-for="item in rejectedItems" :key="item.id" class="text-danger">
            {{ item.coaching_title }}
          </li>
        </ul>
        <p v-else>No items to be rejected.</p> -->
      </div>
    </b-modal>
    <!-- Modal Report -->
    <ReportModal v-model:visible="isShowReport" :listIdpPeriod="listIdpPeriod" role="employee" @export="handleExport" />
  </div>
</template>

<script>
import axiosIns from "@/api/axios";
import moment from "moment";
import "../../assets/js/theme.bundle";
import "../../assets/js/vendor.bundle";
import ReportModal from "@/components/ReportModal.vue";
import { EXPORT_COMMON_REPORT, getReportFilename } from "@/api/common/reports";

export default {
  name: "myIdp",
  components: {
    ReportModal,
  },
  data() {
    return {
      idpPeriod: "",
      listIdpPeriod: [],
      summary: "",
      searchStructure: "",
      filter_competency_struckture: "",
      filter_type_struckture: "",
      filter_platform_struckture: "",
      currentPageStructure: 1,
      itemsPerPageStructure: 10,
      totalPagesStructure: 1,
      searchSocial: "",
      filter_competency_social: "",
      filter_type_social: "",
      currentPageSocial: 1,
      itemsPerPageSocial: 10,
      totalPagesSocial: 1,
      searchExperiential: "",
      filter_competency_experiental: "",
      currentPageExperiential: 1,
      itemsPerPageExperiential: 10,
      totalPagesExperiential: 1,
      assigneeData: "",
      currentPage: 1,
      itemsPerPage: 10,
      itemsPerPageOptions: [5, 10, 20, 50],
      nik: "",
      nikByLogin: localStorage.getItem("nik"),
      nikManager: "",
      name: "",
      position: "",
      listTabMenu: [],
      menuData: "",
      idpExamination: [],
      employee: "",
      listEmployee: [],
      listKaryawan: [],
      isEditProficiency: false,
      disableActivitiForm: true,
      isAddProgress: false,
      isScheduleModalVisible: false,
      isUpdateProject: false,
      schedule: {
        date: null,
        startTime: null,
        endTime: null,
      },
      milestone: [],
      bodyDisAdd: {
        providerName: false,
        address: false,
        websiteProvider: false,
        contactPerson: false,
        email: false,
        phone: false,
      },
      bodyProficiency: {
        id: "",
        proficiency: "",
      },
      bodyProgress: {
        id: "",
        name: "",
        date: "",
        progress: "",
      },
      bodySummary: {
        summary: "",
        follow_up: "",
        feedback: "",
      },
      idCoaching: "",
      idIdpSocial: "",
      scheduleSocial: [],
      projectStatus: "",
      progressPercentage: 0,
      certificateUrl: "",
      bodyEnroll: {
        id: "",
        nik: "",
        isl_id: "",
      },
      role: {
        employeeName: "",
        position: "",
        total: "",
      },
      trainingId: "",
      eventList: [],
      roleList: [],
      projectRole: [],
      dataActivities: [],
      isModalProposed: false,
      isAddTraining: false,
      isAddCoaching: false,
      isAddProject: false,
      isShowReport: false,
      isCreateSummary: false,
      isCompleteSummary: false,
      isRoleModalVisible: false,
      isEditActivities: false,
      isAddActivities: false,
      isModalActivities: false,
      isModalViewFeedback: false,
      checkStructured: false,
      checkSocial: false,
      stl_rekom: false,
      sol_rekom: false,
      certificateName: "",
      selectedFile: null,
      uploadUrl: "",
      uploadedFiles: [],
      bodyAddProposed: {
        id: "",
        date: "",
      },
      bodyUploadCertificate: {
        id: "",
        trainingTitle: "",
        certificate: "",
      },
      bodyUploadPresentation: {
        id: "",
        presentation: "",
      },
      bodyActivities: {
        id_learning: "",
        id: "",
        task: "",
        startDate: "",
        endDate: "",
        predecessor: "",
        actualStartDate: "",
        actualEndDate: "",
        percentage: "",
        status: "",
        evidenceFile: "",
        assignee: "",
      },
      bodyEditActivities: {
        id_learning: "",
        id: "",
        task: "",
        startDate: "",
        endDate: "",
        predecessor: "",
        actualStartDate: "",
        actualEndDate: "",
        progress: "",
        status: "",
        evidenceFile: "",
        assignee: [],
        percentage: "",
      },
      bodyAdd: {
        relatedCompetency: "",
        projectName: "",
        projectDescription: "",
        startDate: "",
        endDate: "",
        projectInvolvement: "",
        subordinate: "",
        bussinessNeed: "",
        objectives: "",
        goals: "",
        scope: "",
        constraints: "",
        deliverables: "",
        projectImpactA: "",
        impact: "",
        projectImpactB: "",
        projectImpact: "",
        attachment: [],
        coaching: "",
        competency: "",
        provider: "",
        providerName: "",
        address: "",
        websiteProvider: "",
        contactPerson: "",
        email: "",
        phone: "",
        training: "",
        trainingName: "",
        learningMethod: "",
        learningType: "",
        currency: "IDR",
        price: "",
        websiteTraining: "",
        description: "",
        hours: "",
        background_1: "",
        background_2: "",
        background_3: "",
        startDate: "",
        endDate: "",
        teams: [
          {
            role: "",
            nik: localStorage.getItem("nik"),
          },
        ],
      },
      selectedLearning: null,
      searchTimeout: null,
      isModalStructured: false,
      isModalEnrollStructured: false,
      isModalSocial: false,
      isUploadCertificate: false,
      isUploadPresentation: false,
      bodyFeedback: {
        id: "",
        nik: "",
        summary: "",
        follow_up: "",
        feedback: "",
        viewFeedback: "",
      },
      bodyFeedbackExam: {
        competency: "",
        old_proficiency: "",
        standartd_proficiency: "",
        proficiency: "",
        feedback: "",
      },
      dataCoaching: [],
      dataTraining: [],
      dataProvider: [],
      dataCompetency: [],
      dataTrainingMethod: [],
      dataTrainingType: [],
      dataEmployee: [],
      structuredLearning: [],
      socialLearning: [],
      experientialLearning: [],
      selectedRowStructured: null,
      selectedRowSocial: null,
      selectedRowExperiential: null,
      selectTeams: null,
      srStructuredLearning: [],
      checkSTructuredLearning: [],
      checkSocialLearning: [],
      srExperientialLearning: [],
      srSocialLearning: [],
      approvedItems: [],
      rejectedItems: [],
      scheduleList: [],
      currencies: ["USD", "IDR"],
      selectedCurrency: "IDR",
      isLoading: true,
      isSavingSchedule: false,
      isSubmittingStructured: false,
      isSubmittingSocial: false,
      isSubmittingEditProficiency: false,
      isSubmittingActivities: false,
      isSubmittingEditActivities: false,
      isSubmittingCertificate: false,
      isSubmittingSummary: false,
      isSubmittingProgress: false,
      isSubmittingPresentation: false,
      isCreatingTraining: false,
      isCreatingCoaching: false,
      isEnrollingTraining: false,
      isAddingSchedule: false,
      isEmpty: false,
      currentTab: 0,
      tabTitles: ["Progress Summary", "Structured Learning", "Social Learning", "Experiential Learning", "IDP Examination"],
      statusActivities: [
        { id: "to do", name: "To Do" },
        { id: "in progress", name: "In Progress" },
        { id: "completed", name: "Completed" },
      ],
    };
  },
  computed: {
    totalPages() {
      return this.idpExamination && this.idpExamination.all
        ? Math.ceil(this.idpExamination.all.length / this.itemsPerPage)
        : 0;
    },
    paginatedItems() {
      if (this.idpExamination && this.idpExamination.all) {
        const start = (this.currentPage - 1) * this.itemsPerPage;
        const end = start + this.itemsPerPage;
        return this.idpExamination.all.slice(start, end);
      }
      return [];
    },
    aboutMe() {
      return this.$store.getters["users/profiles"];
    },
    anyEventEnrolled() {
      return this.eventList.some((event) => event.is_enrolled === true);
    },
    hasTrainingTitle() {
      return this.structuredLearning.some((item) => item.training_title !== null);
    },
    hasCoachingTitle() {
      return this.socialLearning.some((item) => item.coaching_title !== null);
    },
    activeTabTitle() {
      return this.tabTitles[this.currentTab];
    },
    personalData() {
      let datas = this.$store.getters["dashboard/personalDashboard"];
      return datas;
    },
  },
  watch: {
    searchStructure: {
      handler: "onSearchStructure",
      immediate: false,
    },
    searchSocial: {
      handler: "onSearchSocial",
      immediate: false,
    },
    searchExperiential: {
      handler: "onSearchExperiential",
      immediate: false,
    },

    selectedRowStructured(newVal) {
      if (newVal && newVal.certificate) {
        this.updateCertificateUrl();
      }
    },
    selectedLearning(newVal) {
      if (newVal) {
        this.bodyAdd.training = newVal.id;
      } else {
        this.bodyAdd.training = null;
      }
    },
    "bodyAdd.provider": "fetchTrainingData",
    "bodyAdd.competency": "fetchCoaching",
  },
  methods: {
    selectIdpPeriod(e) {
      this.idpPeriod = e;
      this.getDataIdpStructured();
      this.getDataIdpSocial();
      this.getDataIdpExperiential();
    },
    getIdpPeriod() {
      this.$store.dispatch("idpPeriod/getIdpPeriod").then((res) => {
        this.listIdpPeriod = res.data.map((item) => {
          if (item.status === "open") {
            this.idpPeriod = {
              id: item.id,
              status: item.status,
              label: `${item.start_date} - ${item.end_date}`,
              start_date: item.start_date,
              end_date: item.end_date,
              min_hours: item.min_hours,
            };
            this.getPersonalData();
          }
          return {
            id: item.id,
            status: item.status,
            label: `${item.start_date} - ${item.end_date}`,
            start_date: item.start_date,
            end_date: item.end_date,
            min_hours: item.min_hours,
          };
        });
      });
    },
    onSearchStructure() {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      this.searchTimeout = setTimeout(() => {
        this.getDataIdpStructured();
      }, 500);
    },
    onSearchSocial() {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      this.searchTimeout = setTimeout(() => {
        this.getDataIdpSocial(1, this.searchSocial);
      }, 500);
    },
    onSearchExperiential() {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      this.searchTimeout = setTimeout(() => {
        this.getDataIdpExperiential();
      }, 500);
    },
    changePageSizeStructured(newSize) {
      this.itemsPerPageStructure = newSize;
      this.getDataIdpStructured();
    },
    changePageSizeSocial(newSize) {
      this.itemsPerPageSocial = newSize;
      this.getDataIdpSocial(1, this.searchSocial);
    },
    changePageSizeExperiential(newSize) {
      this.itemsPerPageExperiential = newSize;
      this.getDataIdpExperiential();
    },
    addProjectTeams() {
      let body = {
        role: "",
        nik: "",
      };
      this.bodyAdd.teams.push(body);
    },
    delProjectTeams(index) {
      this.bodyAdd.teams.splice(index, 1);
    },
    getEmployees() {
      this.$store.dispatch("employee/getEmployees").then((response) => {
        // console.log("karyawan",response.data)
        this.listKaryawan = response.data;
      });
    },
    viewFeedback(item) {
      this.bodyFeedback.viewFeedback = item.feedback;
      this.bodyFeedbackExam = {
        proficiency: item.proficiency_new,
        competency: item.competency_name,
        old_proficiency: item.proficiency,
        standartd_proficiency: item.proficiency_standard,
        feedback: item.feedback,
      };
      this.isModalViewFeedback = true;
    },
    dimensionChart() {
      // let width = [800, 1024, 1366, 1600, 1920]
      if (window.innerWidth <= 800) {
        return "500";
      } else if (window.innerWidth <= 1024) {
        return "400";
      } else if (window.innerWidth <= 1366) {
        return "280";
      } else if (window.innerWidth <= 1600) {
        return "300";
      } else if (window.innerWidth < 1920) {
        return "400";
      }
    },
    chartOption(e) {
      let col = ["#F44336", "#00d97e", "#39afd1", "#00d97e"];
      // let chart = ""
      if (window.innerWidth <= 800) {
        this.chartSize = 250;
      } else if (window.innerWidth <= 1024) {
        this.chartSize = 250;
      } else if (window.innerWidth <= 1366) {
        this.chartSize = 250;
      } else if (window.innerWidth <= 1600) {
        this.chartSize = 250;
      } else if (window.innerWidth < 1920) {
        this.chartSize = 250;
      }

      let bodys = {
        chart: {
          height: this.chartSize,
          type: "radialBar",
          offsetY: -20,
        },
        plotOptions: {
          radialBar: {
            startAngle: -90,
            endAngle: 90,
            track: {
              background: "#e7e7e7",
              strokeWidth: "97%",
              margin: 3, // margin is in pixels
              dropShadow: {
                enabled: true,
                top: 2,
                left: 0,
                color: "#999",
                opacity: 1,
                blur: 2,
              },
            },
            dataLabels: {
              name: {
                show: false,
              },
              value: {
                offsetY: -1,
                fontSize: "32px",
              },
            },
          },
        },
        grid: {
          padding: {
            top: -10,
          },
        },
        fill: {
          type: "fill",
          colors: col[e],
          gradient: {
            shade: "light",
            shadeIntensity: 0.4,
            inverseColors: false,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 50, 53, 91],
          },
        },
        labels: ["Average Results"],
      };

      return bodys;
    },
    totals(e) {
      return [e];
    },
    exportPdf() {
      this.$bvModal.show("modal-loading");
      axiosIns
        .get(`${axiosIns.defaults.baseURL}/idp-report?nik=${this.aboutMe.nik}`, {
          responseType: "blob",
        })
        .then((resp) => {
          // console.log(resp);
          const url = window.URL.createObjectURL(new Blob([resp.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `IDP-Report-${this.aboutMe.fullname}.pdf`);
          document.body.appendChild(link);
          link.click();
          link.remove();
          this.$bvModal.hide("modal-loading");
        })
        .catch((resp) => {
          this.$swal("Error", `${resp.response.data.error}`, "error");
          // this.load = false;
          this.$bvModal.hide("modal-loading");
        });
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    getBadgeResult(value, proficiency_standard) {
      if (value > proficiency_standard) {
        return "badge bg-success";
      } else if (value < proficiency_standard) {
        return "badge bg-danger";
      } else {
        return "badge bg-warning";
      }
    },
    getBadgeGapExam(value) {
      if (value > 0) {
        return "badge bg-danger";
      } else if (value < 0) {
        return "badge bg-success";
      } else if (value == 0) {
        return "badge bg-warning";
      } else {
        return "badge bg-success";
      }
    },
    getEmployee() {
      this.$store.dispatch("idpExamination/getEmployeeByManager", this.aboutMe.nik).then((res) => {
        this.listEmployee = res.data;
      });
    },
    getIdpExamination() {
      let nik = localStorage.getItem("nik");
      this.$store.dispatch("idpExamination/getIdpExaminationByNik", nik).then((res) => {
        const groupedData = res.data.reduce(
          (acc, item) => {
            // Tambahkan kompetensi ke kategori "all"
            if (!acc.all) acc.all = [];
            let allCompetency = acc.all.find((c) => c.id === item.id);
            if (!allCompetency) {
              allCompetency = { ...item, items: [...item.items] };
              acc.all.push(allCompetency);
            }

            // Pisahkan berdasarkan idp_type
            item.items.forEach((learning) => {
              const type = learning.idp_type || "unknown";

              if (!acc[type]) {
                acc[type] = [];
              }

              let existingCompetency = acc[type].find((c) => c.id === item.id);
              if (!existingCompetency) {
                existingCompetency = { ...item, items: [] };
                acc[type].push(existingCompetency);
              }

              existingCompetency.items.push(learning);
            });

            return acc;
          },
          { structured: [], social: [], experential: [], all: [] }
        );
        this.idpExamination = groupedData;
      });
    },
    showScheduleModal() {
      this.isScheduleModalVisible = true;
    },
    clearScheduleModal() {
      this.schedule = { date: null, startTime: null, endTime: null };
    },
    addSchedule() {
      if (this.schedule.date && this.schedule.startTime && this.schedule.endTime) {
      // Prevent backdate (date before today)
      const today = this.$moment().startOf("day");
      const selectedDate = this.$moment(this.schedule.date).startOf("day");
      if (selectedDate.isBefore(today)) {
        this.$swal("Error", "Tidak boleh memilih tanggal mundur.", "error");
        return;
      }

      const startTimeMoment = this.$moment(this.schedule.startTime, "HH:mm");
      const endTimeMoment = this.$moment(this.schedule.endTime, "HH:mm");

      if (startTimeMoment.isAfter(endTimeMoment)) {
        this.$swal("Error", "Waktu mulai tidak boleh lebih besar dari waktu selesai.", "error");
        return;
      }
      const formattedSchedule = {
        date: this.$moment(this.schedule.date).format("DD MMM YYYY"),
        startTime: this.$moment(this.schedule.startTime).format("HH:mm"),
        endTime: this.$moment(this.schedule.endTime).format("HH:mm"),
      };
      this.scheduleList.push(formattedSchedule);
      this.clearScheduleModal();
      } else {
      this.$swal("Error", "Lengkapi semua kolom.", "error");
      }
    },
    removeSchedule(index) {
      this.scheduleList.splice(index, 1);
    },
    saveSchedule() {
      this.isSavingSchedule = true;
      
      const scheduleData = this.scheduleList.map((item) => ({
        date: this.$moment(item.date, "DD MMM YYYY").format("YYYY-MM-DD"),
        start_time: this.$moment(item.startTime, "HH:mm").format("HH:mm:ss+07"),
        end_time: this.$moment(item.endTime, "HH:mm").format("HH:mm:ss+07"),
      }));

      const payload = {
        data: scheduleData,
      };

      this.$store
        .dispatch("myIdp/createCoachingSchedule", {
          id: this.idIdpSocial,
          args: payload,
        })
        .then((response) => {
          this.$swal("Success", "Jadwal berhasil disimpan", "success");
          this.isScheduleModalVisible = false;
          this.scheduleList = [];
          this.getScheduleSocial();
        })
        .catch((error) => {
          this.$swal("Error", "Jadwal belum berhasil disimpan", "error");
          console.error("Error saving schedule:", error);
        })
        .finally(() => {
          this.isSavingSchedule = false;
        });
    },
    submitProgress() {
      let data = {
        id: this.bodyProgress.id,
        name: this.bodyProgress.name,
        date: this.bodyProgress.date,
        progress: this.bodyProgress.progress,
      };
      this.$store
        .dispatch("myIdp/addProgressActivity", data)
        .then((response) => {
          this.$swal
            .fire({
              icon: "success",
              title: "Success",
              text: "Progress berhasil ditambahkan.",
            })
            .then(() => {
              this.getProjectActivities();
              this.isEditActivities = false;
              this.isAddProgress = false;
              this.bodyProgress.id = "";
              this.bodyProgress.name = "";
              this.bodyProgress.date = "";
              this.bodyProgress.progress = "";
            });
        })
        .catch((error) => {
          this.$swal.fire({
            icon: "error",
            title: "Error",
            text: "Terjadi kesalahan saat menambah progress aktivitas.",
          });
        });
    },
    showAddProgress() {
      this.isAddProgress = true;
    },
    submitSummary() {
      let formData = new FormData();
      formData.append("id", this.idCoaching);
      formData.append("summary", this.bodySummary.summary);
      formData.append("follow_up", this.bodySummary.follow_up);

      // Append files
      if (this.selectedFile) {
        formData.append("files", this.selectedFile);
      }

      this.$store
        .dispatch("myIdp/createSummary", formData)
        .then((response) => {
          this.$swal("Success", "Ringkasan berhasil dibuat", "success");
          this.isCreateSummary = false;
          this.getScheduleSocial();
          this.getDataIdpSocial();
          this.bodySummary.summary = "";
          this.bodySummary.follow_up = "";
          this.selectedFile = null;
        })
        .catch((error) => {
          this.$swal("Error", "Ringkasan belum berhasil dibuat: " + (error.response?.data?.message || error.message), "error");
        });
    },
    showModalSummary(item) {
      const lastIndex = item.feedback.length - 1;
      this.idCoaching = item.id;
      this.isCreateSummary = true;
      this.bodySummary.summary = item.feedback[lastIndex]?.summary;
      this.bodySummary.follow_up = item.feedback[lastIndex]?.follow_up;
      this.bodySummary.feedback = item.feedback[lastIndex]?.feedback;
    },
    showCompleteSummary(item) {
      const lastIndex = item.feedback.length - 1;
      this.idCoaching = item.id;
      this.isCompleteSummary = true;
      this.bodySummary.summary = item.feedback[lastIndex]?.summary;
      this.bodySummary.follow_up = item.feedback[lastIndex]?.follow_up;
      this.bodySummary.feedback = item.feedback[lastIndex]?.feedback;
    },
    getScheduleSocial() {
      this.$store.dispatch("myIdp/getSocialById", this.idIdpSocial).then((res) => {
        this.scheduleSocial = res.data.schedule;
      });
    },
    setActualStartDate() {
      this.bodyEditActivities.actualStartDate = this.getCurrentDate();
    },

    setActualEndDate() {
      this.bodyEditActivities.actualEndDate = this.getCurrentDate();
    },
    getCurrentDate() {
      const today = new Date();
      return this.formatDate(today);
    },
    getBadgeGap(value) {
      if (value > 0) {
        return "badge bg-success";
      } else if (value < 0) {
        return "badge bg-danger";
      } else {
        return "badge bg-success";
      }
    },
    showAddTraining() {
      this.isAddTraining = true;
      this.fetchCoaching();
      this.fetchTrainingData();
    },
    showAddCoaching() {
      this.isAddCoaching = true;
    },
    showAddProject() {
      this.isAddProject = true;
    },
    showReportModal() {
      this.isShowReport = true;
    },
    saveAdd() {
      this.$validator.validateAll().then(async (res) => {
        if (!res) return false;
        try {
          this.$swal({
            title: "Buat Proyek",
            text: "Apakah Anda yakin ingin membuat proyek ini?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#00D97E",
            cancelButtonColor: "#E63757",
            confirmButtonText: "Ya",
            cancelButtonText: "Batal",
          }).then((result) => {
            if (result.isConfirmed) {
              let formData = new FormData();
              formData.append("name", this.bodyAdd.projectName);
              formData.append("description", this.bodyAdd.projectDescription);
              formData.append("start_date", this.formatDate(this.bodyAdd.startDate));
              formData.append("end_date", this.formatDate(this.bodyAdd.endDate));
              formData.append("involment", this.bodyAdd.projectInvolvement);
              formData.append("subordinate", this.bodyAdd.subordinate);
              formData.append("business_need", this.bodyAdd.bussinessNeed);
              formData.append("objectives", this.bodyAdd.objectives);
              formData.append("goals", this.bodyAdd.goals);
              formData.append("scope", this.bodyAdd.scope);
              formData.append("constraints", this.bodyAdd.constraints);
              formData.append("deliverables", this.bodyAdd.deliverables);
              formData.append("impact_a", this.bodyAdd.projectImpactA);
              formData.append("impact", this.bodyAdd.impact);
              formData.append("impact_b", this.bodyAdd.projectImpactB);
              formData.append("competency", JSON.stringify(this.bodyAdd.relatedCompetency));
              formData.append("teams", JSON.stringify(this.bodyAdd.teams));
              // Append files
              if (this.selectedFile) {
                formData.append("files", this.selectedFile);
              }
              this.$store
                .dispatch("myIdp/createProject", formData)
                .then((response) => {
                  this.$swal("Success", "Proyek berhasil dibuat", "success");
                  this.isAddProject = false;
                  this.isShowReport = false;
                  this.getDataIdpExperiential();
                  this.bodyAdd.projectName = "";
                  this.bodyAdd.projectDescription = "";
                  this.bodyAdd.startDate = "";
                  this.bodyAdd.endDate = "";
                  this.bodyAdd.projectInvolvement = "";
                  this.bodyAdd.subordinate = "";
                  this.bodyAdd.bussinessNeed = "";
                  this.bodyAdd.objectives = "";
                  this.bodyAdd.goals = "";
                  this.bodyAdd.scope = "";
                  this.bodyAdd.constraints = "";
                  this.bodyAdd.deliverables = "";
                  this.bodyAdd.projectImpactA = "";
                  this.bodyAdd.impact = "";
                  this.bodyAdd.projectImpactB = "";
                  this.bodyAdd.projectImpact = "";
                  this.bodyAdd.teams = [
                    {
                      role: "",
                      nik: localStorage.getItem("nik"),
                    },
                  ];
                  this.selectedFile = null;
                })
                .catch((error) => {
                  this.$swal(
                    "Error",
                    "Proyek belum berhasil dibuat: " + (error.response?.data?.error || error.message),
                    "error"
                  );
                });
            }
          });
        } catch (resp) {
          // console.log(resp);
        }
      });
    },
    findRoleDetails(positionId) {
      const role = this.projectRole.find((role) => role.id === positionId);
      return role ? { name: role.name, id: role.id } : { name: "", id: null };
    },
    addRole() {
      const roleDetails = this.findRoleDetails(this.role.position);
      const body = {
        position: roleDetails.name,
        total: this.role.total,
        positionId: roleDetails.id,
      };
      this.roleList.push(body);
      this.clearRoleModal();
      this.isRoleModalVisible = false;
    },
    getRole() {
      this.$store.dispatch("projectRole/getProjectRole").then((res) => {
        this.projectRole = res.data;
      });
    },
    clearRoleModal() {
      this.role = { position: "", total: "" };
    },
    removeRole(index) {
      this.roleList.splice(index, 1);
    },
    showRoleModal() {
      this.isRoleModalVisible = true;
    },
    getEventByEmp() {
      this.isLoading = true;
      this.$store
        .dispatch("myIdp/getEventByEmp", { id: this.trainingId })
        .then((res) => {
          this.eventList = res.data;
          this.isEmpty = !this.eventList || this.eventList.length === 0;
          this.isLoading = false;
        })
        .catch((error) => {
          console.error("Error get event data:", error);
          this.isLoading = false;
          this.isEmpty = true;
        });
    },
    ensureArray(input) {
      if (typeof input === "string") {
        return input.split(",");
      }
      return Array.isArray(input) ? input : [input];
    },
    editActivities(item) {
      this.milestone = item.milestone;
      this.bodyProgress.id = item.id;
      this.bodyEditActivities.id = item.id;
      this.bodyEditActivities.task = item.task;
      this.bodyEditActivities.startDate = item.start_date;
      this.bodyEditActivities.endDate = item.end_date;
      this.bodyEditActivities.percentage = item.percentage;
      this.bodyEditActivities.status = item.status;
      this.bodyEditActivities.assignee = this.ensureArray(item.nik);
      this.bodyEditActivities.actualStartDate = item.actual_start_date;
      this.bodyEditActivities.actualEndDate = item.actual_end_date;
      this.progressPercentage = item.new_progress ? item.new_progress : "0";
      this.isEditActivities = true;
      // console.log("nik", item.nik);
      if (
        (this.selectedRowExperiential.status == "submitted" ||
          this.selectedRowExperiential.status == "draft" ||
          this.selectedRowExperiential.status == "revision") &&
        this.selectedRowExperiential.project.created_by == this.nikByLogin
      ) {
        this.disableActivitiForm = false;
        this.isUpdateProject = false;
      } else {
        this.disableActivitiForm = true;
        this.isUpdateProject = true;
      }

      const nik = this.ensureArray(item.nik);

      if (
        (this.selectedRowExperiential.status == "approved" || this.selectedRowExperiential.status == "in progress") &&
        nik.includes(this.nikByLogin)
      ) {
        this.isUpdateProject = false;
      } else if (
        (this.selectedRowExperiential.status == "approved" || this.selectedRowExperiential.status == "in progress") &&
        !nik.includes(this.nikByLogin)
      ) {
        this.isUpdateProject = true;
      }
      // console.log(
      //   this.selectedRowExperiential.project.created_by,
      //   this.nikByLogin
      // );
    },
    clearBodyActivities() {
      this.bodyActivities = {
        id: this.bodyActivities.id,
        id_learning: this.bodyActivities.id_learning,
        task: "",
        startDate: "",
        endDate: "",
        status: "",
        assignee: "",
      };
      this.bodyEditActivities = {
        task: "",
        startDate: "",
        endDate: "",
        status: "",
        actualStartDate: "",
        actualEndDate: "",
      };
    },
    updateCertificateUrl() {
      this.certificateUrl = `${axiosIns.defaults.baseURL}/certificate/${this.certificateName}`;
    },
    downloadCertificate() {
      let datas = `${axiosIns.defaults.baseURL}/certificate/${this.certificateName}`;
      window.open(datas);
    },
    submitCertificate() {
      this.$store
        .dispatch("myIdp/uploadCertificateStructuredLearning", {
          id: this.bodyUploadCertificate.id,
          file: this.selectedFile,
        })
        .then((response) => {
          this.$swal.fire(
            "Success",
            "Data upload certificate akan divalidasi oleh HR. Status training akan menjadi 'Completed' setelah verifikasi HR selesai.",
            "success"
          );
          this.isUploadCertificate = false;
          this.clearUploadCertificate();
          // this.getDataIdpLearning("structuredLearning");
          // this.getDataIdpLearning("socialLearning");
          this.getDataIdpStructured();
          this.getDataIdpSocial();
        })
        .catch((error) => {
          // console.log(error);
          this.$swal.fire("Error", "Sertifikat belum berhasil diunggah", "error");
          // this.$swal.fire('Error', 'Sertifikat belum berhasil diunggah: ' + (error.response?.data?.message || error.message), 'error');
        });
    },
    submitPresentation() {
      this.$store
        .dispatch("myIdp/uploadPresentationSocialLearning", {
          id: this.bodyUploadPresentation.id,
          file: this.selectedFile,
        })
        .then((response) => {
          this.$swal.fire("Success", "Dokumen presentasi berhasil diunggah", "success");
          this.isUploadPresentation = false;
          this.clearUploadPresentation();
          // this.getDataIdpLearning("structuredLearning");
          // this.getDataIdpLearning("socialLearning");
          this.getDataIdpStructured();
          this.getDataIdpSocial();
        })
        .catch((error) => {
          //  console.log(error);
          this.$swal.fire("Error", "Dokumen presentasi belum berhasil diunggah", "error");
          // this.$swal.fire('Error', 'Sertifikat belum berhasil diunggah: ' + (error.response?.data?.message || error.message), 'error');
        });
    },
    uploadFile(file) {
      const formData = new FormData();
      formData.append("files", file);

      // Construct URL with dynamic ID
      // const url = `/idp/upload-structured-learning/${this.bodyUploadCertificate.id}`;

      // fetch(url, {
      //   method: 'POST',
      //   body: formData
      // })
      // .then(response => {
      //   if (!response.ok) {
      //     throw new Error('Network response was not ok');
      //   }
      //   return response.json();
      // })
      // .then(data => {
      //   console.log('File berhasil diunggah:', data);
      //   this.$swal.fire({
      //     icon: 'success',
      //     title: 'Success',
      //     text: 'Sertifikat berhasil diunggah.'
      //   });
      //   this.isUploadCertificate = false;
      // })
      // .catch(error => {
      //   console.error('File upload error:', error);
      //   this.$swal.fire({
      //     icon: 'error',
      //     title: 'Error',
      //     text: 'Sertifikat belum berhasil diunggah.'
      //   });
      // });
    },
    clearUploadCertificate() {
      this.selectedFile = null;
      this.bodyUploadCertificate.trainingTitle = "";
    },
    clearUploadPresentation() {
      this.selectedFile = null;
    },
    handleFileChange(event) {
      this.selectedFile = event.target.files[0];
    },
    uploadCertificate(item) {
      this.bodyUploadCertificate.id = item.id;
      this.bodyUploadCertificate.trainingTitle = item.training_title;
      this.isUploadCertificate = true;
    },
    uploadPresentation(item) {
      this.bodyUploadPresentation.id = item.id;
      this.isUploadPresentation = true;
    },
    preselectRows() {
      // this.srStructuredLearning = this.structuredLearning.filter((item) => item.status === "draft" || item.status === "submitted" || item.status === "proposed").map((item) => item.id);
      // this.srSocialLearning     = this.socialLearning.filter((item) => item.status === "draft" || item.status === "submitted").map((item) => item.id);
    },
    changeOnceCheckboxStructured(item) {
      const position = this.checkSTructuredLearning.findIndex((data) => data.id === item.id);
      if (position === -1) {
        this.checkSTructuredLearning.push({
          id: item.id,
          training_title: item.training_title,
        });
      } else {
        this.checkSTructuredLearning.splice(position, 1);
      }
    },
    changeOnceCheckboxSocial(item) {
      const position = this.checkSocialLearning.findIndex((data) => data.id === item.id);
      if (position === -1) {
        this.checkSocialLearning.push({
          id: item.id,
          coaching_title: item.coaching_title,
        });
      } else {
        this.checkSocialLearning.splice(position, 1);
      }
    },
    changeAllStructur() {
      this.checkStructured = !this.checkStructured;
      this.$nextTick(() => {
        if (this.checkStructured) {
          this.srStructuredLearning = this.structuredLearning
            .filter((item) => ["draft", "submitted", "proposed"].includes(item.status))
            .map((item) => item.id);
        } else {
          this.srStructuredLearning = [];
        }
      });
    },
    changeAllSocial() {
      this.checkSocial = !this.checkSocial;
      this.$nextTick(() => {
        //  console.log("Checkbox state:", this.checkSocial);
        if (this.checkSocial) {
          this.srSocialLearning = this.socialLearning
            .filter((item) => item.status === "draft" || item.status === "submitted")
            .map((item) => item.id);
        } else {
          this.srSocialLearning = [];
        }
      });
    },
    resetForm() {
      this.bodyAdd = {
        coaching: "",
        competency: "",
        provider: "",
        providerName: "",
        address: "",
        website: "",
        contactPerson: "",
        email: "",
        phone: "",
        trainingName: "",
        learningMethod: "",
        learningType: "",
        currency: "",
        price: "",
        description: "",
      };
      this.selectedLearning = null;
      this.isAddTraining = false;
      this.isAddCoaching = false;
      // this.$refs.modalTrainingAspiration.hide();
      // this.$refs.modalCoaching.hide();
    },
    createCoaching() {
      let body = {
        coaching_id: this.bodyAdd.coaching,
        competency_id: this.bodyAdd.competency,
      };
      this.$store
        .dispatch("myIdp/createSocialLearning", body)
        .then((response) => {
          this.$swal
            .fire({
              icon: "success",
              title: "Success",
              text: "Coaching berhasil dibuat.",
            })
            .then(() => {
              // this.$refs.modalCoaching.hide();
              // this.getDataIdpLearning("structuredLearning");
              // this.getDataIdpLearning("socialLearning");
              this.getDataIdpSocial();
              this.getDataIdpStructured();
              this.resetForm();
            });
        })
        .catch((error) => {
          this.$swal.fire({
            icon: "error",
            title: "Error",
            text: "Terjadi kesalahan saat membuat coaching.",
          });
        });
    },
    createTraining() {
      this.$swal({
        title: "Buat Pelatihan",
        text: "Apakah Anda yakin ingin membuat pelatihan ini?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00D97E",
        cancelButtonColor: "#E63757",
        confirmButtonText: "Ya",
        cancelButtonText: "Batal",
      }).then((result) => {
        if (result.isConfirmed) {
          let formData = new FormData();
          formData.append("competency", JSON.stringify(this.bodyAdd.competency));
          console.log("body provider", this.bodyAdd.provider);
          console.log("selected learning", this.selectedLearning);
          if (this.bodyAdd.provider !== "Other" && this.selectedLearning) {
            console.log("kondisi 0");

            formData.append("provider", this.bodyAdd.provider);
            formData.append("training", this.bodyAdd.training);
            let background = {
              background_1: this.bodyAdd.background_1,
              background_2: this.bodyAdd.background_2,
              background_3: this.bodyAdd.background_3,
              start_date: this.bodyAdd.startDate,
              end_date: this.bodyAdd.endDate,
            };
            formData.append("background", JSON.stringify(background));
            if (this.selectedFile) {
              formData.append("files", this.selectedFile);
            }
          } else if (this.bodyAdd.provider !== "Other" && !this.selectedLearning) {
            console.log("kondisi 1");

            formData.append("provider", this.bodyAdd.provider);

            let training = {
              title: this.bodyAdd.trainingName,
              training_type: this.bodyAdd.learningType,
              training_method: this.bodyAdd.learningMethod,
              currency: this.bodyAdd.currency,
              price: this.bodyAdd.price,
              website: this.bodyAdd.websiteProvider,
              description: this.bodyAdd.description,
              hours: this.bodyAdd.hours,
            };
            let background = {
              background_1: this.bodyAdd.background_1,
              background_2: this.bodyAdd.background_2,
              background_3: this.bodyAdd.background_3,
              start_date: this.bodyAdd.startDate,
              end_date: this.bodyAdd.endDate,
            };
            formData.append("training", JSON.stringify(training));
            formData.append("background", JSON.stringify(background));
            if (this.selectedFile) {
              formData.append("files", this.selectedFile);
            }
          } else if (!this.bodyAdd.provider && !this.selectedLearning) {
            console.log("kondisi 2");

            let provider = {
              name: this.bodyAdd.providerName,
              address: this.bodyAdd.address,
              website: this.bodyAdd.websiteProvider,
              contact_person: this.bodyAdd.contactPerson,
              email: this.bodyAdd.email,
              phone: this.bodyAdd.phone,
            };

            let training = {
              title: this.bodyAdd.trainingName,
              training_type: this.bodyAdd.learningType,
              training_method: this.bodyAdd.learningMethod,
              currency: this.bodyAdd.currency,
              price: this.bodyAdd.price,
              website: this.bodyAdd.websiteTraining,
              description: this.bodyAdd.description,
              hours: this.bodyAdd.hours,
            };

            let background = {
              background_1: this.bodyAdd.background_1,
              background_2: this.bodyAdd.background_2,
              background_3: this.bodyAdd.background_3,
              start_date: this.bodyAdd.startDate,
              end_date: this.bodyAdd.endDate,
            };

            formData.append("provider", JSON.stringify(provider));
            formData.append("training", JSON.stringify(training));
            formData.append("background", JSON.stringify(background));

            if (this.selectedFile) {
              formData.append("files", this.selectedFile);
            }
          } else if (this.bodyAdd.provider == "Other" && !this.selectedLearning) {
            console.log("kondisi 3");
            let provider = {
              name: this.bodyAdd.providerName,
              address: this.bodyAdd.address,
              website: this.bodyAdd.websiteProvider,
              contact_person: this.bodyAdd.contactPerson,
              email: this.bodyAdd.email,
              phone: this.bodyAdd.phone,
            };

            let training = {
              title: this.bodyAdd.trainingName,
              training_type: this.bodyAdd.learningType,
              training_method: this.bodyAdd.learningMethod,
              currency: this.bodyAdd.currency,
              price: this.bodyAdd.price,
              website: this.bodyAdd.websiteTraining,
              description: this.bodyAdd.description,
              hours: this.bodyAdd.hours,
            };

            let background = {
              background_1: this.bodyAdd.background_1,
              background_2: this.bodyAdd.background_2,
              background_3: this.bodyAdd.background_3,
              start_date: this.bodyAdd.startDate,
              end_date: this.bodyAdd.endDate,
            };

            formData.append("provider", JSON.stringify(provider));
            formData.append("training", JSON.stringify(training));
            formData.append("background", JSON.stringify(background));

            if (this.selectedFile) {
              formData.append("files", this.selectedFile);
            }
          } else if (this.bodyAdd.provider == "Other" && this.selectedLearning) {
            console.log("kondisi 4");

            let provider = {
              name: this.bodyAdd.providerName,
              address: this.bodyAdd.address,
              website: this.bodyAdd.websiteProvider,
              contact_person: this.bodyAdd.contactPerson,
              email: this.bodyAdd.email,
              phone: this.bodyAdd.phone,
            };

            let background = {
              background_1: this.bodyAdd.background_1,
              background_2: this.bodyAdd.background_2,
              background_3: this.bodyAdd.background_3,
              start_date: this.bodyAdd.startDate,
              end_date: this.bodyAdd.endDate,
            };

            formData.append("provider", JSON.stringify(provider));
            formData.append("training", JSON.stringify(training));
            formData.append("background", JSON.stringify(background));

            if (this.selectedFile) {
              formData.append("files", this.selectedFile);
            }
          }
          // console.log("req data => ",requestData)
          this.$store
            .dispatch("myIdp/createStructuredLearning", formData)
            .then((response) => {
              this.$swal
                .fire({
                  icon: "success",
                  title: "Success",
                  text: "Aspirasi pelatihan berhasil dibuat.",
                })
                .then(() => {
                  // this.$refs.modalTrainingAspiration.hide();
                  // this.getDataIdpLearning("structuredLearning");
                  // this.getDataIdpLearning("socialLearning");
                  this.getDataIdpSocial();
                  this.getDataIdpStructured();
                  this.resetForm();
                });
            })
            .catch((error) => {
              this.$swal.fire({
                icon: "error",
                title: "Error",
                text: "Terjadi kesalahan saat membuat aspirasi pelatihan.",
              });
            });
        }
      });
    },

    selectTraining(training) {
      // console.log("isi training:", training);
      if (training) {
        this.bodyAdd.learningMethod = training.training_method;
        this.bodyAdd.learningType = training.training_type;
        this.bodyAdd.currency = training.currency;
        this.bodyAdd.price = training.price;
        this.bodyAdd.trainingName = training.title;
        this.bodyAdd.websiteTraining = training.website;
        this.bodyAdd.description = training.description || "";
        this.bodyAdd.provider = training.provider_id;
        this.bodyAdd.hours = training.hour;
        if (training.competencies && Array.isArray(training.competencies)) {
          this.bodyAdd.competency = training.competencies
            .map((comp) => {
              const found = this.dataCompetency.find((item) => item.competency_id === comp);
              return found ? found.competency_id : comp;
            })
            .filter((comp) => comp);
        } else {
          this.bodyAdd.competency = [];
        }

        // Add Provider Data
        const providerdata = this.dataProvider.find((provider) => provider.id === training.provider_id);
        this.bodyAdd.providerName = providerdata.name;
        this.bodyAdd.address = providerdata.address;
        this.bodyAdd.websiteProvider = providerdata.website;
        this.bodyAdd.contactPerson = providerdata.contact_person;
        this.bodyAdd.email = providerdata.email;
        this.bodyAdd.phone = providerdata.phone;
      } else {
        this.bodyAdd.learningMethod = null;
        this.bodyAdd.learningType = null;
        this.bodyAdd.currency = "IDR";
        this.bodyAdd.price = null;
        this.bodyAdd.trainingName = "";
        this.bodyAdd.websiteTraining = "";
        this.bodyAdd.description = "";
      }
    },
    async fetchCoaching(competencyId) {
      //    console.log("competency id", competencyId);
      if (competencyId) {
        // const dataCompetencyId = competencyId
        //   ?.filter((item) => typeof item === "string")
        //   .join(",");
        this.fetchProviderByCompetency(competencyId);
        try {
          const args = {};
          const res = await this.$store.dispatch("coaching/getCoachingByCompetency", {
            competencyId,
            args,
          });
          // Format the data to match v-select expectations
          this.dataCoaching = res.data.map(item => ({
            coaching_id: item.id,
            coaching_title: item.title,
            coach_name: item.coach_name,
            type: item.type,
            type_name: item.type_name,
            hour: item.hour,
            cover_image: item.cover_image
          }));
        } catch (err) {
          console.error(err);
          this.dataCoaching = [];
        }
      } else {
        this.fetchProviderByCompetency();
        this.dataCoaching = [];
      }
    },
    async fetchProviderByCompetency(competencyID) {
      if (competencyID) {
        try {
          const args = {};
          await this.$store.dispatch("trainingProvider/getProviderByCompentency", competencyID);
          // console.log(this.$store.state.trainingProvider.trainingByProviderByCompetency);
          this.dataProvider = this.$store.state.trainingProvider.trainingByProviderByCompetency;
          this.dataProvider.push({
            id: "Other",
            name: "Other",
            address: null,
            contact_person: null,
            email: null,
            phone: null,
            website: null,
          });
        } catch (err) {
          this.dataProvider = [];
        }
      } else {
        const competency = "";
        await this.$store.dispatch("trainingProvider/getProviderByCompentency", competency);
        this.dataProvider = this.$store.state.trainingProvider.trainingByProviderByCompetency;
        this.dataProvider.push({
          id: "Other",
          name: "Other",
          address: null,
          contact_person: null,
          email: null,
          phone: null,
          website: null,
        });
        // this.dataProvider = [];
      }
      await this.fetchTrainingData(null);
    },
    async fetchTrainingDatax(providerId) {
      if (providerId && this.bodyAdd.competency) {
        try {
          const dataCompetendyId = this.bodyAdd.competency?.filter((item) => typeof item === "string").join(",");
          // console.log(dataCompetendyId);
          // await this.$store.dispatch("trainingProvider/getTrainingByProvider", {
          //   providerId,
          //   args
          // });
          await this.$store.dispatch("training/getTrainingByProviderByCompentency", {
            providerId,
            competency: dataCompetendyId,
          });
          // console.log(this.$store.state.training.trainingProviderCompetency)
          this.dataTraining = this.$store.state.training.trainingProviderCompetency;
        } catch (err) {
          console.error(err);
          this.dataTraining = [];
        }
      } else {
        const providerId = "";
        const competency = "";
        await this.$store.dispatch("training/getTrainingByProviderByCompentency", {
          providerId,
          competency: competency,
        });
        // console.log(this.$store.state.training.trainingProviderCompetency)
        this.dataTraining = this.$store.state.training.trainingProviderCompetency;
        // this.dataTraining = [];
      }
    },
    async fetchTrainingData(providerId) {
      try {
        const competency = (this.bodyAdd.competency || []).filter((item) => typeof item === "string").join(",");

        await this.$store.dispatch("training/getTrainingByProviderByCompentency", {
          providerId: providerId || "",
          competency: competency || "",
        });

        this.dataTraining = this.$store.state.training.trainingProviderCompetency;
      } catch (err) {
        console.error(err);
        this.dataTraining = [];
      }
    },
    async searchCoaching(search) {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      this.searchTimeout = setTimeout(async () => {
        if (search.length >= 2 && this.bodyAdd.competency) {
          try {
            await this.$store.dispatch("coaching/getCoachingByCompetency", {
              providerId: this.bodyAdd.competency,
              search,
            });
            this.dataTraining = this.$store.state.coaching.getCoachingByCompetency;
          } catch (err) {
            console.error(err);
            this.dataTraining = [];
          }
        } else {
          this.dataTraining = [];
        }
      }, 300);
    },

    async searchTraining(search) {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      this.searchTimeout = setTimeout(async () => {
        if (search.length >= 2 && this.bodyAdd.provider) {
          try {
            await this.$store.dispatch("trainingProvider/getTrainingByProvider", {
              providerId: this.bodyAdd.provider,
              search,
            });
            this.dataTraining = this.$store.state.trainingProvider.trainingByProvider;
          } catch (err) {
            console.error(err);
            this.dataTraining = [];
          }
        } else {
          this.dataTraining = [];
        }
      }, 300);
    },
    selectProvider(selectedProviderId) {
      const selectedProvider = this.dataProvider.find((provider) => provider.id === selectedProviderId);
      if (selectedProvider) {
        this.bodyAdd.providerName = selectedProviderId === 0 || selectedProviderId == "Other" ? "" : selectedProvider.name;
        this.bodyAdd.address = selectedProvider.address;
        this.bodyAdd.websiteProvider = selectedProvider.website;
        this.bodyAdd.contactPerson = selectedProvider.contactPerson;
        this.bodyAdd.email = selectedProvider.email;
        this.bodyAdd.phone = selectedProvider.phone;
        if (selectedProviderId === 0 || selectedProviderId == "Other") {
          this.bodyDisAdd.providerName = false;
          this.bodyDisAdd.address = false;
          this.bodyDisAdd.websiteProvider = false;
          this.bodyDisAdd.contactPerson = false;
          this.bodyDisAdd.email = false;
          this.bodyDisAdd.phone = false;
          this.$nextTick(() => {
            this.$refs.providerNameRef.focus();
          });
        } else {
          this.bodyDisAdd.providerName = true;
          this.bodyDisAdd.address = true;
          this.bodyDisAdd.websiteProvider = true;
          this.bodyDisAdd.contactPerson = true;
          this.bodyDisAdd.email = true;
          this.bodyDisAdd.phone = true;
        }
        // if (selectedProvider.providerName || selectedProviderId !== 0) {
        //   this.bodyDisAdd.providerName = true;
        // }
        // if (selectedProvider.address || selectedProviderId !== 0) {
        //   this.bodyDisAdd.address = true;
        // }
        // if (selectedProvider.website || selectedProviderId !== 0) {
        //   this.bodyDisAdd.websiteProvider = true;
        // }
        // if (selectedProvider.contactPerson || selectedProviderId !== 0) {
        //   this.bodyDisAdd.contactPerson = true;
        // }
        // if (selectedProvider.email || selectedProviderId !== 0) {
        //   this.bodyDisAdd.email = true;
        // }
        // if (selectedProvider.phone || selectedProviderId !== 0) {
        //   this.bodyDisAdd.phone = true;
        // }
      }
    },
    getProjectActivities() {
      this.isLoading = true;
      this.$store
        .dispatch("myIdp/getProjectByUser", {
          id: this.bodyActivities.id_learning,
        })
        .then((res) => {
          this.isLoading = false;
          this.dataActivities = res.data.activities;
        });
    },
    editProficiency(item) {
      this.isEditProficiency = true;
      this.bodyProficiency = {
        id: item.id,
        proficiency: item.proficiency,
      };
    },
    submitEditProficiency() {
      this.isSubmittingEditProficiency = true;
      
      let request = {
        id: this.bodyProficiency.id,
        data: {
          proficiency: Number(this.bodyProficiency.proficiency),
        },
      };
      this.$store
        .dispatch("idpExamination/editProficiencyIdp", request)
        .then((response) => {
          this.$swal("Success", "Proficiency berhasil diubah", "success");
          this.isEditProficiency = false;
        })
        .catch((error) => {
          this.$swal("Error", "Gagal mengubah proficiency: " + (error.response?.data?.message || error.message), "error");
        })
        .finally(() => {
          this.isSubmittingEditProficiency = false;
        });
    },
    viewActivities(item) {
      this.selectedRowExperiential = item;
      this.selectTeams = this.selectedRowExperiential.teams.map((e) => {
        return {
          nik: e.nik,
          label: `${e.role} - ${e.employee_name}`,
        };
      });
      this.projectStatus = item.status;
      this.bodyActivities.id = item.id;
      this.assigneeData = item.employee;
      this.bodyActivities.id_learning = item.id;
      this.getProjectActivities();
      this.isModalActivities = true;
    },
    addActivities() {
      this.isAddActivities = true;
    },
    formatDate(date) {
      if (!date) return "";
      return this.$moment(date).format("YYYY-MM-DD");
    },
    formatDateTable(date) {
      if (!date || !this.$moment(date).isValid()) {
        return "-";
      }
      return this.$moment(date).format("DD-MM-YYYY");
    },
    formatTime(time) {
      return this.$moment(time, "HH:mm:ssZ").format("HH:mm");
    },
    showModalProposed(id) {
      this.bodyAddProposed.id = id;
      this.isModalProposed = true;
    },
    saveAddProposed() {
      this.isLoading = true;
      let bodyAdd = {
        isl_id: this.bodyAddProposed.id,
        date: moment(this.bodyAddProposed.date).format("YYYY-MM-DD"),
      };
      this.$store
        .dispatch("myIdp/createPropossed", bodyAdd)
        .then((response) => {
          this.$swal("Success", "Usulan berhasil ditambahkan", "success");
          this.isModalEnrollStructured = false;
          this.isModalProposed = false;
          // this.getDataIdpLearning("structuredLearning");
          this.getDataIdpStructured();
        })
        .catch((error) => {
          this.$swal("Error", "Aktivitas belum berhasil ditambahkan: " + (error.response?.data?.error || error.message), "error");
        });
    },
    submitActivities() {
      this.isSubmittingActivities = true;
      
      let bodyAdd = {
        iel_id: this.bodyActivities.id,
        task: this.bodyActivities.task,
        start_date: this.formatDate(this.bodyActivities.startDate),
        end_date: this.formatDate(this.bodyActivities.endDate),
        percentage: this.bodyActivities.percentage,
        nik: this.bodyActivities.assignee,
      };
      this.$store
        .dispatch("myIdp/createProjectActivities", bodyAdd)
        .then((response) => {
          this.$swal("Success", "Milestone proyek berhasil ditambahkan", "success");
          this.isAddActivities = false;
          this.getProjectActivities();
          this.clearBodyActivities();
          // this.clearProjectModal();
          // this.getProject();
        })
        .catch((error) => {
          this.$swal("Error", "Aktivitas belum berhasil ditambahkan: " + (error.response?.data?.error || error.message), "error");
        })
        .finally(() => {
          this.isSubmittingActivities = false;
        });
    },
    submitEditActivities() {
      this.isSubmittingEditActivities = true;
      
      const formData = new FormData();

      formData.append("id", this.bodyEditActivities.id);
      formData.append("task", this.bodyEditActivities.task);
      formData.append("start_date", this.formatDate(this.bodyEditActivities.startDate));
      formData.append("end_date", this.formatDate(this.bodyEditActivities.endDate));
      formData.append("percentage", this.bodyEditActivities.percentage);
      formData.append("nik", JSON.stringify(this.bodyEditActivities.assignee));
      formData.append("status", this.bodyEditActivities.status);
      formData.append("actual_start_date", this.formatDate(this.bodyEditActivities.actualStartDate));
      formData.append("actual_end_date", this.formatDate(this.bodyEditActivities.actualEndDate));
      formData.append("progress", this.progressPercentage);

      // Attach the file if it exists
      if (this.selectedFile) {
        formData.append("files", this.selectedFile);
      }

      this.$store
        .dispatch("myIdp/editProjectActivities", {
          id: this.bodyEditActivities.id,
          formData,
        })
        .then((response) => {
          this.$swal("Success", "Milestone proyek berhasil diubah", "success");
          this.isEditActivities = false;
          this.getProjectActivities();
          this.clearBodyActivities();
        })
        .catch((error) => {
          this.$swal("Error", "Gagal mengubah aktivitas: " + (error.response?.data?.error || error.message), "error");
        })
        .finally(() => {
          this.isSubmittingEditActivities = false;
        });
    },
    deleteActivities(item) {
      let idActivities = item.id;
      this.$swal({
        title: "Hapus Aktivitas",
        text: "Apakah Anda yakin ingin menghapus aktivitas yang dipilih?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00D97E",
        cancelButtonColor: "#E63757",
        confirmButtonText: "Ya",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("myIdp/deleteProjectActivities", idActivities)
            .then((response) => {
              this.$swal("Terhapus", "Aktivitas Anda telah dihapus.", "success");
              this.getProjectActivities();
            })
            .catch((error) => {
              this.$swal("Error", "Hapus gagal. Silakan coba lagi.", "error");
              // console.error("Submission failed:", error);
            });
        }
      });
    },
    viewDetailStructured(row) {
      this.bodyEnroll.isl_id = row.id;
      // this.bodyEnroll.id = row.training_id
      this.trainingId = row.training_id;
      this.certificateName = row.certificate;
      this.selectedRowStructured = row;
      this.isModalEnrollStructured = true;
      // console.log(row);
      this.getEventByEmp();
    },
    viewDetailSocial(row) {
      this.projectStatus = row.status;
      this.idIdpSocial = row.id;
      this.selectedRowSocial = row;
      this.isModalSocial = true;
      this.getScheduleSocial();
    },
    clearSelectedRow() {
      this.selectedRowStructured = null;
      this.selectedRowSocial = null;
    },

    getCoaching() {
      this.$store.dispatch("coaching/getCoaching").then((res) => {
        // console.log("provid", res.data);
        // Format the data to match v-select expectations
        this.dataCoaching = res.data.map(item => ({
          coaching_id: item.id,
          coaching_title: item.title,
          coach_name: item.coach_name,
          type: item.type,
          type_name: item.type_name,
          hour: item.hour,
          cover_image: item.cover_image
        }));
      });
    },
    getProvider() {
      this.$store.dispatch("trainingProvider/getTrainingProviders").then((res) => {
        let data = res.data;
        data.push({
          id: 0,
          name: "Other",
        });
        this.dataProvider = data;
      });
    },
    getCompetency() {
      this.$store.dispatch("competency/getDataCompetencyByNik").then((res) => {
        // console.log("competen", res.data);
        this.dataCompetency = res.data;
      });
    },
    getTrainingMethod() {
      this.$store.dispatch("trainingMethod/getTrainingMethod").then((res) => {
        // console.log("trainMe", res.data);
        this.dataTrainingMethod = res.data;
      });
    },
    getTrainingType() {
      this.$store.dispatch("trainingType/getTrainingType").then((res) => {
        // console.log("trainType", res.data);
        this.dataTrainingType = res.data;
      });
    },
    getPersonalData() {
      this.$store.dispatch("dashboard/getDashboardPersonalData");
    },

    getDataIdpStructured() {
      this.isLoading = true;
      const idpPeriod = this.idpPeriod || { id: null };
      const params = {
        pageNumber: this.currentPageStructure,
        pageSize: this.itemsPerPageStructure || 10,
        search: this.searchStructure,
        filter_competency: this.filter_competency_struckture?.competency_id || "",
        filter_type: this.filter_type_struckture,
        filter_platform: this.filter_platform_struckture,
        ...(idpPeriod.id && { idp_id: idpPeriod.id }),
      };

      this.$store
        .dispatch("myIdp/getMyStructured", params)
        .then((res) => {
          const strukturData = res.data.data || [];

          this.structuredLearning = strukturData.flatMap((item) => {
            if (!item.competency || item.competency.length === 0) {
              return [
                {
                  competency: null,
                  proficiency: null,
                  proficiency_standard: null,
                  difference: 0,
                  id: item.id,
                  idp_id: item.idp_id,
                  competency_id: item.competency_id,
                  training_id: item.training_id,
                  certificate: item.certificate,
                  score: item.score,
                  proposed_by: item.proposed_by,
                  status: item.status,
                  isAllowedAction: item.isAllowedAction,
                  feedback: item.feedback,
                  training_title: item.training_title,
                  training_description: item.training_description,
                  training_hours: item.training_hours,
                  training_url: item.training_url,
                  training_type: item.training_type,
                  training_provider: item.training_provider,
                  training_platform: item.training_platform,
                  training_currency: item.training_currency,
                  training_price: item.training_price,
                  training_method: item.training_method,
                  proposed_time: item.proposed_time,
                  have_schedule: item.have_schedule,
                },
              ];
            }

            return item.competency.map((comp, index) => ({
              com: item.competency,
              competency: comp.competency,
              proficiency: comp.proficiency,
              proficiency_standard: comp.proficiency_standard,
              difference: comp.proficiency - comp.proficiency_standard,
              id: index === 0 ? item.id : null,
              idp_id: index === 0 ? item.idp_id : null,
              competency_id: index === 0 ? item.competency_id : null,
              training_id: index === 0 ? item.training_id : null,
              certificate: index === 0 ? item.certificate : null,
              score: index === 0 ? item.score : null,
              proposed_by: index === 0 ? item.proposed_by : null,
              status: item.status,
              isAllowedAction: item.isAllowedAction,
              feedback: index === 0 ? item.feedback : null,
              training_title: index === 0 ? item.training_title : null,
              training_description: index === 0 ? item.training_description : null,
              training_hours: index === 0 ? item.training_hours : null,
              training_url: index === 0 ? item.training_url : null,
              training_type: index === 0 ? item.training_type : null,
              training_provider: index === 0 ? item.training_provider : null,
              training_platform: index === 0 ? item.training_platform : null,
              training_currency: index === 0 ? item.training_currency : null,
              training_price: index === 0 ? item.training_price : null,
              training_method: index === 0 ? item.training_method : null,
              proposed_time: index === 0 ? item.proposed_time : null,
              have_schedule: item.have_schedule,
            }));
          });

          this.currentPageStructure = res.data.currentPage || res.data.current_page || page;
          this.itemsPerPageStructure = res.data.pageSize || res.data.per_page || 10;
          this.totalPagesStructure = res.data.totalPages || res.data.last_page || 1;
          this.totalItemsStructure = res.data.totalItems || res.data.total || 0;

          this.isEmpty = !this.structuredLearning || this.structuredLearning.length === 0;
          this.preselectRows();
          this.isLoading = false;
        })
        .catch((error) => {
          console.error("Error fetching idp data:", error);
          this.isLoading = false;
          this.isEmpty = true;
          this.structuredLearning = [];
          this.currentPageStructure = 1;
          this.totalPagesStructure = 1;
          this.totalItemsStructure = 0;
        });
    },
    getDataIdpSocial() {
      this.isLoading = true;
      const idpPeriod = this.idpPeriod || { id: null };

      const params = {
        pageNumber: this.currentPageSocial,
        pageSize: this.itemsPerPageSocial || 10,
        search: this.searchSocial,
        filter_competency: this.filter_competency_social?.competency_id || "",
        filter_type: this.filter_type_social,
        ...(idpPeriod.id && { idp_id: idpPeriod.id }),
      };
      this.$store
        .dispatch("myIdp/getMySocial", params)
        .then((res) => {
          const socialData = res.data.data || [];
          // this.sol_rekom = res.data[0].sol_recomend;
          this.socialLearning = socialData.flatMap((item) => {
            return item.competency.map((comp, index) => {
              const gap =
                comp.proficiency > comp.proficiency_standard
                  ? comp.proficiency - comp.proficiency_standard
                  : comp.proficiency < comp.proficiency_standard
                  ? -(comp.proficiency_standard - comp.proficiency)
                  : 0;
              return {
                competency: comp.competency,
                proficiency: comp.proficiency,
                proficiency_standard: comp.proficiency_standard,
                difference: gap,
                id: index === 0 ? item.id : null,
                idp_id: index === 0 ? item.idp_id : null,
                coaching_id: index === 0 ? item.coaching_id : null,
                coaching_title: index === 0 ? item.coaching_title : null,
                coaching_methodology: index === 0 ? item.coaching_methodology : null,
                is_completed: index === 0 ? item.is_completed : null,
                coach_name: index === 0 ? item.coach_name : null,
                coaching_hour: index === 0 ? item.coaching_hour : null,
                status: item.status,
                coaching_type: item.coach_type,
              };
            });
          });
          this.currentPageSocial = res.data.currentPage || res.data.current_page || page;
          this.itemsPerPageSocial = res.data.pageSize || res.data.per_page || 10;
          this.totalPagesSocial = res.data.totalPages || res.data.last_page || 1;
          this.totalItemsSocial = res.data.totalItems || res.data.total || 0;

          this.isEmpty = !this.socialLearning || this.socialLearning.length === 0;
          this.isLoading = false;
          this.preselectRows();
        })
        .catch((error) => {
          console.error("Error fetching idp data:", error);
          this.isLoading = false;
          this.isEmpty = true;
        });
    },
    getDataIdpExperiential() {
      this.isLoading = true;
      const idpPeriod = this.idpPeriod || { id: null };

      const params = {
        pageNumber: this.currentPageExperiential,
        pageSize: this.itemsPerPageExperiential || 10,
        search: this.searchExperiential,
        filter_competency: this.filter_competency_experiential?.competency_id || "",
        ...(idpPeriod.id && { idp_id: idpPeriod.id }),
      };

      this.$store
        .dispatch("myIdp/getMyExperiential", params)
        .then((res) => {
          const experientialData = res.data.data || [];

          this.experientialLearning = experientialData.map((item) => ({
            id: item.id,
            idp_id: item.idp_id,
            notes: item.notes,
            project_id: item.project_id,
            status: item.status,
            project: item.project,
            competency: item.competency,
            teams: item.teams,
            creator: item.creator,
          }));
          this.currentPageExperiential = res.data.currentPage || res.data.current_page || page;
          this.itemsPerPageExperiential = res.data.pageSize || res.data.per_page || 10;
          this.totalPagesExperiential = res.data.totalPages || res.data.last_page || 1;
          this.totalItemsExperiential = res.data.totalItems || res.data.total || 0;

          this.isEmpty = !this.experientialLearning || this.experientialLearning.length === 0;
          this.isLoading = false;
        })
        .catch((error) => {
          console.error("Error fetching idp data:", error);
          this.isLoading = false;
          this.isEmpty = true;
        });
    },

    initStructuredLearning() {
      this.$store
        .dispatch("myIdp/initIdpStructuredLearning")
        .then((res) => {
          this.getDataIdpSocial();
          this.getDataIdpStructured();
        })
        .catch((error) => {
          console.error("Error fetching idp data:", error);
        });
    },
    initSocialLearning() {
      this.$store
        .dispatch("myIdp/initIdpSocialLearning")
        .then((res) => {
          // this.getDataIdpLearning("structuredLearning");
          this.getDataIdpSocial();
          // this.getDataIdpLearning("socialLearning");
        })
        .catch((error) => {
          console.error("Error fetching idp data:", error);
        });
    },

    getBadgeSummary(value) {
      if (value === "Completed") {
        return "badge bg-success";
      } else if (value === "In Progress") {
        return "badge bg-warning";
      }
    },
    getBadgeStatus(value) {
      if (!value) return "";
      const status = value.toLowerCase();

      if (status === "completed") {
        return "badge bg-success  align-items-center";
      } else if (status === "draft") {
        return "badge bg-warning text-dark  align-items-center";
      } else if (status === "registered") {
        return "badge bg-secondary  align-items-center";
      } else if (status === "rejected") {
        return "badge bg-danger  align-items-center";
      } else if (status === "submitted") {
        return "badge bg-success  align-items-center";
      } else if (status === "approved_manager") {
        return "badge bg-success  align-items-center";
      } else if (status === "approved") {
        return "badge bg-success  align-items-center";
      } else if (status === "enrolled") {
        return "badge bg-success  align-items-center";
      } else if (status === "assigned") {
        return "badge bg-success  align-items-center";
      } else if (status === "in progress" || status === "in_progress") {
        return "badge bg-warning text-dark  align-items-center";
      } else if (status === "to do" || status === "to_do") {
        return "badge bg-danger  align-items-center";
      } else if (status === "active") {
        return "badge bg-success  align-items-center";
      } else if (status === "in review") {
        return "badge bg-info  align-items-center";
      } else if (status === "closed") {
        return "badge bg-secondary  align-items-center";
      } else if (status === "submit") {
        return "badge bg-success  align-items-center";
      } else if (status === "revision") {
        return "badge bg-danger  align-items-center";
      } else if (value === "scheduled") {
        return "badge bg-warning";
      } else if (value === "enrollment pending") {
        return "badge bg-warning";
      } else if (value === "proposed") {
        return "badge bg-info";
      }

      return "";
    },
    getIconClass(value) {
      if (!value) return "";
      const status = value.toLowerCase();
      switch (status) {
        case "completed":
          return "fe fe-check-circle";
        case "draft":
          return "fe fe-file-text";
        case "registered":
          return "fe fe-user-check";
        case "rejected":
          return "fe fe-x";
        case "submitted":
          return "fe fe-send";
        case "approved_manager":
          return "fe fe-check";
        case "approved":
          return "fe fe-check";
        case "enrolled":
          return "fe fe-user-plus";
        case "assigned":
          return "fe fe-user-check";
        case "in progress":
        case "in_progress":
          return "fe fe-loader";
        case "to do":
        case "to_do":
          return "fe fe-list";
        case "active":
          return "fe fe-activity";
        case "in review":
          return "fe fe-eye";
        case "closed":
          return "fe fe-lock";
        case "submit":
          return "fe fe-arrow-up-circle";
        case "revision":
          return "fe fe-edit";
        case "scheduled":
          return "fe fe-calendar";
        case "enrollment pending":
        case "enrollment_pending":
          return "fe fe-loader";
        case "proposed":
          return "fe fe-loader";
        default:
          return "";
      }
    },

    modifyStatus(status) {
      switch (status) {
        case "submitted":
          return "Waiting Approval Manager";
        case "approved_manager":
          return "Waiting Approval HR";
        default:
          return this.capitalizeStatus(status);
      }
    },

    capitalizeStatus(value) {
      if (!value) {
        return null;
      }
      return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
    },
    formatPrice(price) {
      return new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(price);
    },
    formatterNumber(val) {
      if (val === "") return "";
      if (!val) return 0;
      return `${val}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".").replace(/\.(?=\d{0,2}$)/g, ",");
    },
    enrollTrainingEvent(item) {
      this.bodyEnroll.id = item.id;
      this.$swal({
        title: "Daftar Pelatihan",
        text: "Apakah Anda yakin ingin mendaftar pelatihan yang dipilih?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00D97E",
        cancelButtonColor: "#E63757",
        confirmButtonText: "Ya",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("myIdp/enrollTrainingEvent", this.bodyEnroll)
            .then((response) => {
              this.$swal("Terdaftar", "Pelatihan Anda berhasil didaftarkan.", "success");
              // this.getDataIdpLearning("structuredLearning");
              // this.getDataIdpLearning("socialLearning");
              this.getDataIdpStructured();
              this.isModalEnrollStructured = false;
            })
            .catch((error) => {
              this.$swal("Error", "Pendaftaran gagal. Silakan coba lagi.", "error");
              console.error("Enroll failed:", error);
            });
        }
      });
    },
    confirmSubmissionStructured() {
      this.isSubmittingStructured = true;
      
      // const approved = this.approvedItems.map((item) => item.id);
      // const rejected = this.rejectedItems.map((item) => item.id);
      const approved = this.checkSTructuredLearning.map((item) => item.id);
      const rejected = [];
      const reqBody = {
        id: approved,
        reject_id: rejected,
      };

      this.$store
        .dispatch("myIdp/submitStructuredLearning", reqBody)
        .then((response) => {
          this.$swal("Terkirim", "Pembelajaran Anda telah dikirim.", "success");
          this.$refs.confirmationModalStructured.hide();
          // this.getDataIdpLearning("structuredLearning");
          // this.getDataIdpLearning("socialLearning");
          this.getDataIdpSocial();
          this.getDataIdpStructured();
          this.checkSTructuredLearning = [];
        })
        .catch((error) => {
          const errorMessage =
            error.response && error.response.data && error.response.data.error
              ? error.response.data.error
              : "Pengiriman gagal. Silakan coba lagi.";
          this.$swal("Error", errorMessage, "error");
          console.error("Submission failed:", error);
        })
        .finally(() => {
          this.isSubmittingStructured = false;
        });
    },
    confirmSubmissionSocial() {
      this.isSubmittingSocial = true;
      
      // const approved = this.approvedItems.map((item) => item.id);
      // const rejected = this.rejectedItems.map((item) => item.id);
      const approved = this.checkSocialLearning.map((item) => item.id);
      const rejected = [];
      const reqBody = {
        id: approved,
        reject_id: rejected,
      };

      this.$store
        .dispatch("myIdp/submitSocialLearning", reqBody)
        .then((response) => {
          this.$swal("Terkirim", "Pembelajaran Anda telah dikirim.", "success");
          this.$refs.confirmationModalSocial.hide();
          // this.getDataIdpLearning("structuredLearning");
          // this.getDataIdpLearning("socialLearning");
          this.getDataIdpSocial();
          this.getDataIdpStructured();
          this.checkSocialLearning = [];
        })
        .catch((error) => {
          const errorMessage =
            error.response && error.response.data && error.response.data.error
              ? error.response.data.error
              : "Pengiriman gagal. Silakan coba lagi.";
          this.$swal("Error", errorMessage, "error");
          console.error("Submission failed:", error);
        })
        .finally(() => {
          this.isSubmittingSocial = false;
        });
    },
    submitExperiential(item) {
      const idActivities = item.id;
      const status = "submitted";
      this.$swal({
        title: "Kirim Proyek",
        text: `Apakah Anda yakin ingin mengirim proyek?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00D97E",
        cancelButtonColor: "#E63757",
        confirmButtonText: "Ya",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("myIdp/updateProjectStatus", { id: idActivities, status })
            .then((response) => {
              this.$swal("Terkirim", `Proyek telah dikirim.`, "success");
              this.getDataIdpExperiential();
            })
            .catch((error) => {
              console.log(error.response.data.error);
              this.$swal("Error", error?.response?.data?.error, "error");
            });
        }
      });
    },
    submitStructured() {
      const ids = this.srStructuredLearning.map((row) => row.id);
      const requestBody = { id: ids };
      const cleanedSelectedRows = this.srStructuredLearning.filter((id) => typeof id === "number");
      this.approvedItems = this.structuredLearning.filter(
        (item) => cleanedSelectedRows.includes(item.id) && ["draft", "proposed"].includes(item.status)
        // cleanedSelectedRows.includes(item.id) && item.status === "draft"
      );
      this.rejectedItems = this.structuredLearning.filter(
        (item) => !cleanedSelectedRows.includes(item.id) && item.status === "draft"
      );
      this.$refs.confirmationModalStructured.show();
    },
    submitSocial() {
      const ids = this.srSocialLearning.map((row) => row.id);
      const requestBody = { id: ids };
      const cleanedSelectedRows = this.srSocialLearning.filter((id) => typeof id === "number");
      this.approvedItems = this.socialLearning.filter(
        (item) => cleanedSelectedRows.includes(item.id) && item.status === "draft"
      );
      this.rejectedItems = this.socialLearning.filter(
        (item) => !cleanedSelectedRows.includes(item.id) && item.status === "draft"
      );
      this.$refs.confirmationModalSocial.show();
    },
    disablePastDates(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0); // Reset time to the start of the day
      return date < today; // Disable dates before today
    },
    nextPageStructure() {
      if (this.currentPageStructure < this.totalPagesStructure) {
        this.currentPageStructure = this.currentPageStructure + 1;
        this.getDataIdpStructured();
      }
    },
    prevPageStructure() {
      if (this.currentPageStructure > 1) {
        this.currentPageStructure = this.currentPageStructure - 1;
        this.getDataIdpStructured();
      }
    },
    nextPageSocial() {
      if (this.currentPageSocial < this.totalPagesSocial) {
        this.currentPageSocial = this.currentPageSocial + 1;
        this.getDataIdpSocial();
      }
    },
    prevPageSocial() {
      if (this.currentPageSocial > 1) {
        this.currentPageSocial = this.currentPageSocial - 1;
        this.getDataIdpSocial();
      }
    },
    nextPageExperiential() {
      if (this.currentPageExperiential < this.totalPagesExperiential) {
        this.currentPageExperiential = this.currentPageExperiential + 1;
        this.getDataIdpExperiential();
      }
    },
    prevPageExperiential() {
      if (this.currentPageExperiential > 1) {
        this.currentPageExperiential = this.currentPageExperiential - 1;
        this.getDataIdpExperiential();
      }
    },
    handleExport(data) {
      this.$bvModal.show("modal-loading");

      const type = data.type;
      const startDateLabel = data.start_date ? data.start_date.replace(/-/g, "") : null;
      const endDateLabel = data.end_date ? data.end_date.replace(/-/g, "") : null;
      const name =
        data.status === "enrolled"
          ? "Enrollment-Report.xlsx"
          : getReportFilename(type, startDateLabel, endDateLabel);

      EXPORT_COMMON_REPORT(data)
        .then((resp) => {
          const url = window.URL.createObjectURL(
            new Blob([resp.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", name);
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
          this.isShowReport = false;
        })
        .catch(async (error) => {
          try {
            if (error.response?.data instanceof Blob) {
              const errText = await error.response.data.text();
              const errJson = JSON.parse(errText);
              this.$swal("Error", errJson.error || errJson.message || "Terjadi kesalahan tak terduga", "error");
            } else {
              const decoder = new TextDecoder("utf-8");
              const errText = decoder.decode(error.response?.data);
              const errJson = JSON.parse(errText);
              this.$swal("Error", errJson.error || "Terjadi kesalahan tak terduga", "error");
            }
          } catch (e) {
            this.$swal("Error", error.message || "Terjadi kesalahan", "error");
          }
        })
        .finally(() => {
          this.$bvModal.hide("modal-loading");
        });
    },
  },
  mounted() {
    this.getIdpPeriod();
    this.getEmployees();
    this.getIdpExamination();
    this.getDataIdpStructured();
    this.getDataIdpSocial();
    this.getDataIdpExperiential();
    this.getCompetency();
    // this.getProvider();
    this.getTrainingMethod();
    this.getTrainingType();
    this.getRole();
    this.fetchCoaching();
    this.getPersonalData();
    this.bodyProgress.date = this.$moment().format("YYYY-MM-DD");
    const listMenu = JSON.parse(localStorage.getItem("listMenu") || []);
    const currentPath = window.location.pathname; // Path dari URL saat ini
    const menu = listMenu.find(
      (menu) => menu.link === String(currentPath) || menu.children.some((child) => child.link === String(currentPath))
    );
    this.listTabMenu = menu;
  },
};
</script>

<style>
.pagination-controls {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 5px;
  margin-top: 15px;
}
.pagination-controls label {
  margin-right: 10px;
}
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
}
.pagination button {
  margin: 0 5px;
}
.table-responsive::-webkit-scrollbar {
  display: none; /* For Chrome, Safari, and Opera */
}
.table-responsive {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
.rectangle {
  width: 15px;
  height: 10px;
  background-color: #e0e0e0;
  border: 1px solid #ccc;
}
.rectangle.filled-danger {
  background-color: #e63757;
}
.rectangle.filled-target {
  background-color: #f6c343;
}
.rectangle.filled-achievement {
  background-color: #00d97e;
}
</style>
